/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInteger: any;
  Date: any;
  DateTime: any;
  /** ─── layoutConfig.graphqls ─────────────────────────────────────── */
  JSON: any;
  LocalDate: any;
  LocalDateTime: any;
  Long: any;
  UUID: any;
  Upload: any;
};

export type AchievementAwarded = BadgeAwarded | TrophyAwarded;

export type AddCorrectionInput = {
  artworkId: Scalars['UUID'];
  fileIds?: InputMaybe<Array<Scalars['UUID']>>;
  markers?: InputMaybe<Array<MarkerInput>>;
  text: Scalars['String'];
};

export type AddFilesToProductInput = {
  fileIds: Array<Scalars['UUID']>;
  productId: Scalars['UUID'];
};

export type AddFolderInput = {
  /** if not supplied one will be generated for you */
  folderId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  parentFolderId: Scalars['UUID'];
};

export type AddRelationshipsToProductInput = {
  productId: Scalars['UUID'];
  relationships: Array<RelationshipInput>;
};

export type AddSsoDomainInput = {
  autoCreateUsers?: Scalars['Boolean'];
  complementWithGraphInfo?: Scalars['Boolean'];
  domain: Scalars['String'];
  isPrimary?: Scalars['Boolean'];
};

export type AdoptionMilestone = {
  __typename: 'AdoptionMilestone';
  achieved: Scalars['Boolean'];
  count: Scalars['Int'];
  /** Epoch millis of the first time the milestone was reached; null when not achieved. */
  firstAchievedAt?: Maybe<Scalars['Long']>;
  key: AdoptionMilestoneKey;
};

/** Funnel steps an organisation can have reached, in rough funnel order. */
export enum AdoptionMilestoneKey {
  ApprovedArtwork = 'APPROVED_ARTWORK',
  AssignedApprover = 'ASSIGNED_APPROVER',
  ClosedProject = 'CLOSED_PROJECT',
  CommentedArtwork = 'COMMENTED_ARTWORK',
  CreatedArtwork = 'CREATED_ARTWORK',
  CreatedProject = 'CREATED_PROJECT',
  CreatedShare = 'CREATED_SHARE',
  DeliveredArtwork = 'DELIVERED_ARTWORK',
  InvitedUser = 'INVITED_USER',
  RejectedArtwork = 'REJECTED_ARTWORK',
  ShareDownloaded = 'SHARE_DOWNLOADED',
  SyncedToBrandStudio = 'SYNCED_TO_BRAND_STUDIO',
  UploadedRevision = 'UPLOADED_REVISION',
  UploadedToBrandStudio = 'UPLOADED_TO_BRAND_STUDIO'
}

/**
 * An organisation API key. A key with the GraphQL scope authenticates as a service account - an
 * agent member holding the role chosen at creation - so what it may do is that role's
 * permissionIds. REST-only keys are verified per request and have neither.
 */
export type ApiKey = {
  __typename: 'ApiKey';
  created: Scalars['DateTime'];
  createdBy: User;
  description: Scalars['String'];
  expired: Scalars['Boolean'];
  /**
   * When the key stops authenticating, epoch millis; null never expires. Reminders go to the
   * account owner and apitokens.manage holders 14 and 3 days ahead.
   */
  expiresAt?: Maybe<Scalars['Long']>;
  id: Scalars['UUID'];
  /**
   * Last authentication with the key, epoch millis, recorded to the day; null when never used
   * (or not since 2026-09-18).
   */
  lastUsedAt?: Maybe<Scalars['Long']>;
  /**
   * True for a GraphQL key created before service accounts (2026-09-18): it still acts as
   * its creator. Offer convertApiKeyToServiceAccount.
   */
  legacy: Scalars['Boolean'];
  /**
   * The role the key acts with: the service account's, or for a legacy GraphQL key the
   * creator's current role in this organisation. Null for a REST-only key.
   */
  role?: Maybe<Role>;
  scopes: Array<ApiTokenScope>;
  /**
   * The service account (User.isAgent) this key authenticates as. Null for a REST-only key
   * and for a legacy key.
   */
  serviceAccount?: Maybe<User>;
};

export enum ApiTokenScope {
  ArtworkStatus = 'ARTWORK_STATUS',
  ExportArtworks = 'EXPORT_ARTWORKS',
  Graphql = 'GRAPHQL'
}

export enum ApprovalMode {
  AllRequired = 'ALL_REQUIRED',
  AnyMember = 'ANY_MEMBER'
}

export type ApprovalStats = {
  __typename: 'ApprovalStats';
  approvedArtworks: Scalars['Int'];
  averageApprovalTime: Scalars['String'];
  averageRevisions: Scalars['Float'];
};

export type ApproveArtworkTask = {
  __typename: 'ApproveArtworkTask';
  artworkId: Scalars['ID'];
  artworkName: Scalars['String'];
  assignedTo: Scalars['ID'];
  categoryId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  currentRevisionNumber?: Maybe<Scalars['Long']>;
  /** @deprecated Renamed: use dueDate */
  deadline?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  previewFileId?: Maybe<Scalars['UUID']>;
  projectId: Scalars['ID'];
  projectName: Scalars['String'];
  projectOrderNo: Scalars['String'];
};

export type Approver = {
  __typename: 'Approver';
  approved: Scalars['Boolean'];
  approvedRevision?: Maybe<Scalars['UUID']>;
  clearOnNextRevision: Scalars['Boolean'];
  deadline?: Maybe<Scalars['LocalDateTime']>;
  rejected: Scalars['Boolean'];
  reminderSentDate?: Maybe<Scalars['LocalDateTime']>;
  undecided: Scalars['Boolean'];
};

export type Article = {
  __typename: 'Article';
  articleAxes: Scalars['JSON'];
  articleNo?: Maybe<Scalars['String']>;
  gtins: Array<Scalars['String']>;
  id: Scalars['UUID'];
  indicatorDigit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  packagingLevel: Scalars['String'];
  parentPackArticleId?: Maybe<Scalars['UUID']>;
  productId: Scalars['UUID'];
  quantityInParent?: Maybe<Scalars['Int']>;
  /** Epoch millis (per attribute key) the source-locale value was last set. */
  sourceUpdatedAt: Scalars['JSON'];
  /** Epoch millis (per `locale.key`) a non-source-locale value was last written. */
  translatedAt: Scalars['JSON'];
  /** Per-translation freshness (per `locale.key`): "ok" | "outdated". Missing/na are client-derivable. */
  translationStatus: Scalars['JSON'];
  /** Localized attribute values, keyed by attribute key (non-localizable) or `locale.key`. */
  values: Scalars['JSON'];
};

/** A project artwork */
export type Artwork = {
  __typename: 'Artwork';
  actions: Array<ArtworkActions>;
  approvalDate?: Maybe<Scalars['LocalDateTime']>;
  approvers: Array<ArtworkUser>;
  /** Articles (GTIN'd pack level) this artwork is linked to. Resolve details via the `article(id)` query. */
  articleIds: Array<Scalars['UUID']>;
  /** Will not work in subscriptions for now */
  artworkPermissions: ArtworkPermissions;
  artworkRules: Array<ArtworkRule>;
  basedOnMediaCenterArtwork?: Maybe<MediaCenterArtwork>;
  category: Category;
  collaborations: Array<ArtworkCollaboration>;
  created: Scalars['Date'];
  currentRevision?: Maybe<Revision>;
  deliveredBy?: Maybe<User>;
  deliveryDate?: Maybe<Scalars['LocalDateTime']>;
  deliveryRevokeCount?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  downloadedBy: Array<User>;
  downloadedDate?: Maybe<Scalars['LocalDateTime']>;
  endDate?: Maybe<Scalars['Date']>;
  fileHistory: Array<FileHistoryEntry>;
  files: Array<File>;
  filesWithType: Array<ArtworkFile>;
  id: Scalars['UUID'];
  inSyncWithMediaCenter?: Maybe<Scalars['Boolean']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isInApprovableState: Scalars['Boolean'];
  isInCommentableState: Scalars['Boolean'];
  isInCreateNewRevisionState: Scalars['Boolean'];
  isInRejectableState: Scalars['Boolean'];
  latestActivity: Scalars['DateTime'];
  metaData?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderer: User;
  previewFile?: Maybe<File>;
  printCoverageApproved: Scalars['Boolean'];
  projectId: Scalars['UUID'];
  projectName: Scalars['String'];
  receivers: Array<ArtworkUser>;
  revisions: Array<Revision>;
  /** Silent mode: no email notifications are sent about this artwork */
  silent: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  state: ArtworkState;
  stateEnteredAt: Scalars['Long'];
  status: StatusBall;
  suppliers: Array<ArtworkUser>;
  tags: Array<AssetTag>;
  /**
   * @deprecated Use actions instead
   * @deprecated Use 'actions' field instead
   */
  tasks: Array<ArtworkActions>;
  teamApprovers: Array<ArtworkUserTeam>;
  teamReceivers: Array<ArtworkUserTeam>;
  teamSuppliers: Array<ArtworkUserTeam>;
  teams: Array<ArtworkUserTeam>;
  users: Array<ArtworkUser>;
  /** Number of artwork events applied to this artwork; increases with every change */
  version: Scalars['Int'];
};

export type ArtworkActions = {
  __typename: 'ArtworkActions';
  dateCreated: Scalars['DateTime'];
  dateDone?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  done: Scalars['Boolean'];
  finishedBy?: Maybe<User>;
  readOnly: Scalars['Boolean'];
  type: TaskActionType;
};

export type ArtworkCollaboration = {
  __typename: 'ArtworkCollaboration';
  artworkCollaborationId: Scalars['UUID'];
  email: Scalars['String'];
  secured: Scalars['Boolean'];
  sharedBy: User;
};

export type ArtworkComment = {
  __typename: 'ArtworkComment';
  commentedBy: User;
  created: Scalars['DateTime'];
  files: Array<File>;
  id: Scalars['UUID'];
  invalidatedBy?: Maybe<User>;
  markers: Array<CommentMarker>;
  number: Scalars['Int'];
  text: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type ArtworkCommentInput = {
  artworkId: Scalars['UUID'];
  fileIds?: InputMaybe<Array<Scalars['UUID']>>;
  markers?: InputMaybe<Array<CommentMarkerInput>>;
  text: Scalars['String'];
};

export type ArtworkEvent = {
  __typename: 'ArtworkEvent';
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  timestamp: Scalars['Long'];
};

export type ArtworkFile = {
  __typename: 'ArtworkFile';
  file: File;
  fileType: FileType;
};

export type ArtworkFilesInput = {
  artworkId: Scalars['UUID'];
  fileIds: Array<Scalars['UUID']>;
};

export type ArtworkFolderItem = {
  __typename: 'ArtworkFolderItem';
  artwork?: Maybe<MediaCenterArtwork>;
  /** timestamp */
  created?: Maybe<Scalars['Long']>;
  id: Scalars['UUID'];
  lineage: Array<Folder>;
  name: Scalars['String'];
  obsolete: Scalars['Boolean'];
  tags: Array<AssetTag>;
};

export type ArtworkFromFile = {
  /** Will be generated if not provided */
  artworkId?: InputMaybe<Scalars['UUID']>;
  /** Will use the filename if not provided */
  artworkName?: InputMaybe<Scalars['String']>;
  /** Will use default if not provided */
  categoryId?: InputMaybe<Scalars['UUID']>;
  fileId: Scalars['UUID'];
};

export type ArtworkPermissions = {
  __typename: 'ArtworkPermissions';
  canAddCorrections: Scalars['Boolean'];
  canBundle: Scalars['Boolean'];
  canDownloadRevision: Scalars['Boolean'];
  canInvalidateCorrection: Scalars['Boolean'];
  canManageUsers: Scalars['Boolean'];
  canResetApprovals: Scalars['Boolean'];
  canUploadNewRevision: Scalars['Boolean'];
  id: Scalars['UUID'];
  mayApprove: Scalars['Boolean'];
  mayReject: Scalars['Boolean'];
};

export type ArtworkRejectionsByCategoryPerMonth = {
  __typename: 'ArtworkRejectionsByCategoryPerMonth';
  artworkCount: Scalars['Int'];
  average: Scalars['Float'];
  category: Scalars['String'];
  categoryId: Scalars['String'];
  count: Scalars['Int'];
  month: Scalars['Long'];
  monthValue: Scalars['Int'];
  year: Scalars['Int'];
};

export type ArtworkRule = {
  __typename: 'ArtworkRule';
  id: Scalars['UUID'];
  rule: Scalars['String'];
};

export enum ArtworkState {
  Approved = 'APPROVED',
  Bundled = 'BUNDLED',
  Canceled = 'CANCELED',
  Commented = 'COMMENTED',
  Delivered = 'DELIVERED',
  ForReview = 'FOR_REVIEW',
  Rejected = 'REJECTED',
  Shipped = 'SHIPPED',
  Unstarted = 'UNSTARTED'
}

export type ArtworkTeamMember = {
  __typename: 'ArtworkTeamMember';
  admin: Scalars['Boolean'];
  user: User;
};

export type ArtworkUser = {
  __typename: 'ArtworkUser';
  approver?: Maybe<Approver>;
  assignments: Array<Assignment>;
  isApprover: Scalars['Boolean'];
  isReceiver: Scalars['Boolean'];
  isSupplier: Scalars['Boolean'];
  name: Scalars['String'];
  receiver?: Maybe<Receiver>;
  supplier?: Maybe<Supplier>;
  userId: Scalars['UUID'];
  username: Scalars['String'];
};

export type ArtworkUserTeam = {
  __typename: 'ArtworkUserTeam';
  approvalMode: ApprovalMode;
  approvalState: TeamApprovalState;
  description: Scalars['String'];
  id: Scalars['UUID'];
  isApprover: Scalars['Boolean'];
  isReceiver: Scalars['Boolean'];
  isSupplier: Scalars['Boolean'];
  memberApprovals: Array<TeamMemberApproval>;
  members: Array<ArtworkTeamMember>;
  name: Scalars['String'];
  sourceTeamId: Scalars['UUID'];
};

export type AssetTag = {
  __typename: 'AssetTag';
  color: AssetTagColor;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  usageCount: Scalars['Int'];
};

/** ─── assetTag.graphqls ─────────────────────────────────────────── */
export enum AssetTagColor {
  Blue = 'BLUE',
  Green = 'GREEN',
  None = 'NONE',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Teal = 'TEAL',
  Yellow = 'YELLOW'
}

export enum AssetTagSort {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Recent = 'RECENT',
  UsageDesc = 'USAGE_DESC'
}

export enum AssignUserAction {
  Assign = 'ASSIGN',
  LeaveUnchanged = 'LEAVE_UNCHANGED',
  UnAssign = 'UN_ASSIGN'
}

export type AssignUserToArtworkInput = {
  artworkId: Scalars['UUID'];
  username: Scalars['String'];
};

export type Assignment = Approver | Receiver | Supplier;

export type AssignmentUpdateEvent = {
  __typename: 'AssignmentUpdateEvent';
  id: Scalars['UUID'];
};

export type AttributeFilterInput = {
  /** The value-map key to filter on: the attribute key, or `locale.key` for a localizable value. */
  attributeKey: Scalars['String'];
  value: Scalars['String'];
};

export enum AttributeScope {
  Both = 'BOTH',
  Product = 'PRODUCT',
  Variant = 'VARIANT'
}

export enum AttributeType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Richtext = 'RICHTEXT',
  Select = 'SELECT',
  Text = 'TEXT'
}

export enum AvatarSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Original = 'ORIGINAL',
  Small = 'SMALL'
}

export type AverageDeliveredArtworksPerMonth = {
  __typename: 'AverageDeliveredArtworksPerMonth';
  average: Scalars['Float'];
  month: Scalars['Long'];
  monthValue: Scalars['Int'];
};

export type BadgeAwarded = {
  __typename: 'BadgeAwarded';
  name?: Maybe<Scalars['String']>;
  notificationText?: Maybe<Scalars['String']>;
};

export type BadgeCount = {
  __typename: 'BadgeCount';
  projects: Scalars['Int'];
  quickShare: Scalars['Int'];
};

export type BadgeCountUpdatedEvent = {
  __typename: 'BadgeCountUpdatedEvent';
  id: Scalars['UUID'];
};

export enum BarCodeDirection {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical'
}

/** Barcod with location */
export type Barcode = {
  __typename: 'Barcode';
  id: Scalars['UUID'];
  markerRect: Rectangle;
  page: Scalars['Int'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type BarcodeInput = {
  fileId: Scalars['UUID'];
  id: Scalars['UUID'];
  markerRect?: InputMaybe<RectangleInput>;
};

export type BasicProjectDataInput = {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Date']>;
};

/**
 * Who an invoiced subscription's invoices are made out to and where they are taxed. Given by the
 * customer when accepting an invoiced offer; written to the Stripe customer, never stored in CWAY.
 */
export type BillingDetailsInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyName: Scalars['String'];
  /** ISO 3166-1 alpha-2, e.g. "SE" */
  country: Scalars['String'];
  postalCode: Scalars['String'];
  /** The customer's PO number or reference, printed on every invoice */
  reference?: InputMaybe<Scalars['String']>;
  /**
   * With its country prefix, e.g. "SE556677889901"; EU (incl. XI) and GB VAT ids are accepted,
   * others are refused with "cannot be registered here". Reverse charge needs it; without it
   * local VAT is added.
   */
  vatId?: InputMaybe<Scalars['String']>;
};

export type BlikkContact = {
  __typename: 'BlikkContact';
  customerNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type BlikkIntegrationSettings = {
  __typename: 'BlikkIntegrationSettings';
  /** Create Blikk projects with all Blikk organisation members as project members */
  allIsMember: Scalars['Boolean'];
  defaultBlikkCustomerId?: Maybe<Scalars['String']>;
  defaultBlikkResponsibleId?: Maybe<Scalars['String']>;
  defaultProjectNumberPrefix?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  syncProjectCloseStatus: Scalars['Boolean'];
  syncProjectCreation: Scalars['Boolean'];
};

export type BlikkProject = {
  __typename: 'BlikkProject';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  orderNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<BlikkProjectStatus>;
  title?: Maybe<Scalars['String']>;
};

export type BlikkProjectStatus = {
  __typename: 'BlikkProjectStatus';
  id?: Maybe<Scalars['String']>;
  isCompletedStatus: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type BlikkTimeReport = {
  __typename: 'BlikkTimeReport';
  activityName?: Maybe<Scalars['String']>;
  blikkUserName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  cwayUser?: Maybe<User>;
  date?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  invoiceableHours?: Maybe<Scalars['Float']>;
};

export type BlikkTimeReportSummary = {
  __typename: 'BlikkTimeReportSummary';
  byUser: Array<BlikkTimeReportUserSummary>;
  entries: Array<BlikkTimeReport>;
  totalCost: Scalars['Float'];
  totalHours: Scalars['Float'];
  totalInvoiceableHours: Scalars['Float'];
};

export type BlikkTimeReportUserSummary = {
  __typename: 'BlikkTimeReportUserSummary';
  blikkUserName: Scalars['String'];
  cwayUser?: Maybe<User>;
  totalCost: Scalars['Float'];
  totalHours: Scalars['Float'];
  totalInvoiceableHours: Scalars['Float'];
};

export type BlikkUser = {
  __typename: 'BlikkUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Brand = {
  __typename: 'Brand';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type BundleArtworkTask = {
  __typename: 'BundleArtworkTask';
  artworkId: Scalars['ID'];
  artworkName: Scalars['String'];
  assignedTo: Scalars['ID'];
  categoryId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  currentRevisionNumber?: Maybe<Scalars['Long']>;
  /** @deprecated Renamed: use dueDate */
  deadline?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  previewFileId?: Maybe<Scalars['UUID']>;
  projectId: Scalars['ID'];
  projectName: Scalars['String'];
  projectOrderNo: Scalars['String'];
};

/** ─── admin.graphqls ────────────────────────────────────────────── */
export type CqsStats = {
  __typename: 'CQSStats';
  averageDuration: Scalars['Long'];
  count: Scalars['Int'];
  type: Scalars['String'];
};

/** The artwork category specified by the organisation */
export type Category = {
  __typename: 'Category';
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  usage?: Maybe<Scalars['Int']>;
};

export type ChatContextDto = {
  __typename: 'ChatContextDto';
  artworkId?: Maybe<Scalars['UUID']>;
  folderId?: Maybe<Scalars['UUID']>;
  noteTitle?: Maybe<Scalars['String']>;
  organisationId: Scalars['UUID'];
  pageHint?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['UUID']>;
};

/**
 * Context about what the user is currently looking at in the UI. The bot uses
 * this to resolve references like "this project" or "this folder" and to feed
 * context-aware tools.
 *
 * Note: organisation is intentionally NOT accepted here. It is derived
 * server-side from the authenticated session (JWT) to prevent a client from
 * steering the chatbot into another tenancy.
 *
 * All fields are optional — send whatever the current view exposes.
 */
export type ChatContextInput = {
  /** UUID of the artwork the user is currently viewing, if any. */
  artworkId?: InputMaybe<Scalars['UUID']>;
  /** UUID of the folder the user is currently viewing, if any. */
  folderId?: InputMaybe<Scalars['UUID']>;
  /** Title of the project note the user currently has open, if any. */
  noteTitle?: InputMaybe<Scalars['String']>;
  /**
   * Free-form hint about the page or view the user is on (e.g.
   * "project-overview", "media-center-grid"). Use for anything that doesn't
   * fit the structured IDs above; fed verbatim to the model.
   */
  pageHint?: InputMaybe<Scalars['String']>;
  /** UUID of the project the user is currently viewing, if any. */
  projectId?: InputMaybe<Scalars['UUID']>;
};

export type ChatMessageDto = {
  __typename: 'ChatMessageDto';
  content: Scalars['String'];
  role: Scalars['String'];
  timestamp: Scalars['String'];
};

export type ChatSession = {
  __typename: 'ChatSession';
  context: ChatContextDto;
  id: Scalars['UUID'];
  loadedSkills: Array<Scalars['String']>;
  messages: Array<ChatMessageDto>;
  promptProfile: Scalars['String'];
};

/**
 * Single event type with a `kind` discriminator instead of a union, so the
 * frontend only needs to subscribe to one shape. Only fields relevant to
 * `kind` will be populated.
 */
export type ChatStreamEvent = {
  __typename: 'ChatStreamEvent';
  kind: ChatStreamEventKind;
  /** TOOL_CALL_FINISHED */
  success?: Maybe<Scalars['Boolean']>;
  /** TEXT_DELTA: text present. TURN_DONE: text holds final concatenated reply. ERROR: error message. */
  text?: Maybe<Scalars['String']>;
  /** TOOL_CALL_STARTED / TOOL_CALL_FINISHED */
  toolName?: Maybe<Scalars['String']>;
};

export enum ChatStreamEventKind {
  Error = 'ERROR',
  TextDelta = 'TEXT_DELTA',
  ToolCallFinished = 'TOOL_CALL_FINISHED',
  ToolCallStarted = 'TOOL_CALL_STARTED',
  TurnDone = 'TURN_DONE'
}

export type ChatbotSkillSummary = {
  __typename: 'ChatbotSkillSummary';
  description: Scalars['String'];
  name: Scalars['String'];
};

export type Checkin = {
  __typename: 'Checkin';
  comment?: Maybe<Scalars['String']>;
  deliveryFiles: Array<CheckinFile>;
  id: Scalars['UUID'];
  postDeliveryFiles: Array<CheckinFile>;
  proofFiles: Array<CheckinFile>;
  resourceFiles: Array<CheckinFile>;
  sourceFiles: Array<CheckinFile>;
  timestamp: Scalars['DateTime'];
  user: User;
};

export type CheckinArtworkInput = {
  artworkId: Scalars['UUID'];
  comment?: InputMaybe<Scalars['String']>;
  deliveryFiles: Array<CheckinFileInput>;
  postDeliveryFiles?: Array<CheckinFileInput>;
  proofFiles?: Array<CheckinFileInput>;
  resourceFiles: Array<CheckinFileInput>;
  sourceFiles: Array<CheckinFileInput>;
};

export type CheckinFile = {
  __typename: 'CheckinFile';
  fileId: Scalars['UUID'];
  filename: Scalars['String'];
};

export type CheckinFileInput = {
  fileId: Scalars['UUID'];
  filename: Scalars['String'];
};

export type Checkout = {
  __typename: 'Checkout';
  timestamp: Scalars['DateTime'];
  user: User;
};

export type CircleMarker = {
  __typename: 'CircleMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type ColorSeparation = {
  __typename: 'ColorSeparation';
  color: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CommentCircleMarker = {
  __typename: 'CommentCircleMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type CommentLineMarker = {
  __typename: 'CommentLineMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type CommentMarker = CommentCircleMarker | CommentLineMarker | CommentPinMarker | CommentRectangleMarker | MeasurementCommentLineMarker | MeasurementCommentRectangleMarker;

export type CommentMarkerInput = {
  /** default 0 */
  pageNo?: InputMaybe<Scalars['Int']>;
  type: MarkerType;
  x: Scalars['Int'];
  /** default -1 */
  xEnd?: InputMaybe<Scalars['Int']>;
  y: Scalars['Int'];
  /** default -1 */
  yEnd?: InputMaybe<Scalars['Int']>;
};

export type CommentPinMarker = {
  __typename: 'CommentPinMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type CommentRectangleMarker = {
  __typename: 'CommentRectangleMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type CommunicationSettings = {
  __typename: 'CommunicationSettings';
  defaultMuteProjectEmails: Scalars['Boolean'];
};

export type CommunicationSettingsInput = {
  defaultMuteProjectEmails: Scalars['Boolean'];
};

export type CompletenessScore = {
  __typename: 'CompletenessScore';
  missing: Array<Scalars['String']>;
  overall: Scalars['Int'];
  warnings: Array<Scalars['String']>;
};

export type ConfigureBlikkIntegrationInput = {
  /**
   * Create Blikk projects with all Blikk organisation members as project members.
   * Omitted or null preserves the current value. Initial default is false.
   */
  allIsMember?: InputMaybe<Scalars['Boolean']>;
  apiKey?: InputMaybe<Scalars['String']>;
  appId?: InputMaybe<Scalars['String']>;
  defaultBlikkCustomerId?: InputMaybe<Scalars['String']>;
  defaultBlikkResponsibleId?: InputMaybe<Scalars['String']>;
  defaultProjectNumberPrefix?: InputMaybe<Scalars['String']>;
  syncProjectCloseStatus: Scalars['Boolean'];
  syncProjectCreation: Scalars['Boolean'];
};

export type ConvertArtworkFileInput = {
  fileId: Scalars['UUID'];
  fileType: FileType;
};

export type ConvertFileToArtworkInput = {
  categoryId: Scalars['UUID'];
  description?: InputMaybe<Scalars['String']>;
  fileFolderItemId: Scalars['UUID'];
  files: Array<ConvertArtworkFileInput>;
  name: Scalars['String'];
  obsolete?: InputMaybe<Scalars['Boolean']>;
};

/** Corrigendum are corrections to artworks */
export type Correction = {
  __typename: 'Correction';
  commentedBy: User;
  created: Scalars['DateTime'];
  files: Array<File>;
  id: Scalars['UUID'];
  invalidatedBy?: Maybe<User>;
  markers: Array<Marker>;
  /** Serial number of correction (begins with 1 and increases from oldest corrections to newest) */
  number: Scalars['Int'];
  text: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type CreateAnonymousShareInput = {
  includeDeliveryFiles?: InputMaybe<Scalars['Boolean']>;
  includeSourceFiles?: InputMaybe<Scalars['Boolean']>;
  items: Array<CreateShareMediaInput>;
  message: Scalars['String'];
  /** will be generated if not provided */
  shareId?: InputMaybe<Scalars['UUID']>;
  title: Scalars['String'];
};

export type CreateArticleInput = {
  articleAxes?: InputMaybe<Scalars['JSON']>;
  articleNo?: InputMaybe<Scalars['String']>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['UUID']>;
  indicatorDigit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  packagingLevel?: InputMaybe<Scalars['String']>;
  parentPackArticleId?: InputMaybe<Scalars['UUID']>;
  productId: Scalars['UUID'];
  quantityInParent?: InputMaybe<Scalars['Int']>;
};

/** Input for creating a project artwork */
export type CreateArtworkInput = {
  categoryId: Scalars['UUID'];
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Date']>;
};

export type CreateCustomerOrganisationInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organisationName: Scalars['String'];
};

/** Input for creating a mediacenter artwork */
export type CreateMediaCenterArtworkInput = {
  categoryId: Scalars['UUID'];
  name: Scalars['String'];
};

export type CreateOrganisationInput = {
  name: Scalars['String'];
  organisationId?: InputMaybe<Scalars['UUID']>;
};

export type CreateProductAttributeInput = {
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  localizable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  regulated?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<AttributeScope>;
  selectValues?: InputMaybe<Array<Scalars['String']>>;
  setId: Scalars['UUID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  type: AttributeType;
  unit?: InputMaybe<Scalars['String']>;
};

export type CreateProductInput = {
  /** if brand is known. Overrides brandName */
  brandId?: InputMaybe<Scalars['UUID']>;
  /** matches existing brand names or creates a new brand. Overridden by brandId */
  brandName?: InputMaybe<Scalars['String']>;
  /** explicit category ids the product belongs to */
  categoryIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** matches existing category names or creates the path; the resulting category is added to categoryIds */
  categoryNames?: InputMaybe<Array<Scalars['String']>>;
  /** generated if not provided */
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  productNo: Scalars['String'];
};

export type CreateProductStageInput = {
  bucket: Scalars['String'];
  icon?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Input for creating a project */
export type CreateProjectInput = {
  artworkMedia?: InputMaybe<Array<CreateProjectMediaInput>>;
  /** Optional Blikk customer ID override for this project */
  blikkCustomerId?: InputMaybe<Scalars['String']>;
  /** Optional Blikk project number prefix override for this project */
  blikkProjectPrefix?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  orderNo?: InputMaybe<Scalars['String']>;
  ordererId: Scalars['UUID'];
  /** Will be generated if not supplied */
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type CreateProjectMediaInput = {
  id: Scalars['UUID'];
  type: CreateProjectMediaType;
};

export enum CreateProjectMediaType {
  File = 'FILE',
  McArtwork = 'MC_ARTWORK'
}

export type CreateProjectStatusInput = {
  category: ProjectStatusCategory;
  /** If true, becomes the default status for its category. */
  default?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateShareInput = {
  emails: Scalars['String'];
  includeDeliveryFiles?: InputMaybe<Scalars['Boolean']>;
  includeSourceFiles?: InputMaybe<Scalars['Boolean']>;
  items: Array<CreateShareMediaInput>;
  message: Scalars['String'];
  /** will be generated if not provided */
  shareId?: InputMaybe<Scalars['UUID']>;
  title: Scalars['String'];
};

export type CreateShareMediaInput = {
  id: Scalars['UUID'];
  mediaType: CreateShareMediaType;
};

export enum CreateShareMediaType {
  File = 'FILE',
  McArtwork = 'MC_ARTWORK',
  ProjectArtwork = 'PROJECT_ARTWORK'
}

export type CreateSubscriptionOfferInput = {
  globalDiscount?: InputMaybe<OfferDiscountInput>;
  lines: Array<SubscriptionOfferLineInput>;
  /** Internal sales note, never shown to the customer */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Invoice the subscription with this many days to pay (1-90, e.g. 30 for net 30) instead of
   * charging a card. Omit for card. On an offer to a paying organisation this switches the
   * running subscription to invoicing; an offer without terms leaves its collection method alone.
   */
  paymentTermsDays?: InputMaybe<Scalars['Int']>;
  /** Free days before the first invoice (1-730) */
  trialDays?: InputMaybe<Scalars['Int']>;
  /** Acceptance deadline, epoch millis; omit for open-ended */
  validUntil?: InputMaybe<Scalars['Long']>;
};

export type CreateWebhookInput = {
  basicAuthPassword?: InputMaybe<Scalars['String']>;
  basicAuthUsername?: InputMaybe<Scalars['String']>;
  bearerToken?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  events: Array<Scalars['String']>;
  url: Scalars['String'];
};

export enum CwayModule {
  /** The DAM module — sells as Brand Studio (the legacy mediacenter naming is internal only) */
  BrandStudio = 'BRAND_STUDIO',
  Insights = 'INSIGHTS',
  Pim = 'PIM',
  Project = 'PROJECT',
  Sharing = 'SHARING'
}

export type Decor = {
  __typename: 'Decor';
  barCodeDirection: BarCodeDirection;
  barCodeSize: Scalars['Int'];
  otherPackItemToMatch: Scalars['String'];
  otherProductsToMatch: Scalars['String'];
};

export type DecorInput = {
  barCodeDirection: BarCodeDirection;
  barCodeSize: Scalars['Int'];
  otherPackItemToMatch: Scalars['String'];
  otherProductsToMatch: Scalars['String'];
};

export type DeliverArtworkTask = {
  __typename: 'DeliverArtworkTask';
  artworkId: Scalars['ID'];
  artworkName: Scalars['String'];
  assignedTo: Scalars['ID'];
  categoryId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  currentRevisionNumber?: Maybe<Scalars['Long']>;
  /** @deprecated Renamed: use dueDate */
  deadline?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  previewFileId?: Maybe<Scalars['UUID']>;
  projectId: Scalars['ID'];
  projectName: Scalars['String'];
  projectOrderNo: Scalars['String'];
};

export type DeliveredArtworksByCategoryPerMonth = {
  __typename: 'DeliveredArtworksByCategoryPerMonth';
  category: Scalars['String'];
  categoryId: Scalars['String'];
  count: Scalars['Int'];
  month: Scalars['Long'];
  monthValue: Scalars['Int'];
  year: Scalars['Int'];
};

export type DeliveredArtworksPerMonth = {
  __typename: 'DeliveredArtworksPerMonth';
  count: Scalars['Int'];
  month: Scalars['Long'];
  monthValue: Scalars['Int'];
  year: Scalars['Int'];
};

export type DeliveredArtworksPerYear = {
  __typename: 'DeliveredArtworksPerYear';
  count: Scalars['Int'];
  year: Scalars['Int'];
};

export type DesktopTheme = {
  __typename: 'DesktopTheme';
  dockBackground?: Maybe<Scalars['String']>;
  dockColor?: Maybe<Scalars['String']>;
  mediaCenterColor?: Maybe<Scalars['String']>;
  progressColor?: Maybe<Scalars['String']>;
  projectColor?: Maybe<Scalars['String']>;
  quickShareColor?: Maybe<Scalars['String']>;
  shortcutColor?: Maybe<Scalars['String']>;
  topBarBackground?: Maybe<Scalars['String']>;
  topBarColor?: Maybe<Scalars['String']>;
  wallpaper?: Maybe<Scalars['UUID']>;
  wallpaperColor?: Maybe<Scalars['String']>;
  wallpaperStyle?: Maybe<WallpaperStyle>;
};

export type DesktopThemeInput = {
  dockBackground?: InputMaybe<Scalars['String']>;
  dockColor?: InputMaybe<Scalars['String']>;
  mediaCenterColor?: InputMaybe<Scalars['String']>;
  progressColor?: InputMaybe<Scalars['String']>;
  projectColor?: InputMaybe<Scalars['String']>;
  quickShareColor?: InputMaybe<Scalars['String']>;
  shortcutColor?: InputMaybe<Scalars['String']>;
  topBarBackground?: InputMaybe<Scalars['String']>;
  topBarColor?: InputMaybe<Scalars['String']>;
  wallpaper?: InputMaybe<Scalars['UUID']>;
  wallpaperColor?: InputMaybe<Scalars['String']>;
  wallpaperStyle?: InputMaybe<WallpaperStyle>;
};

export type DiscardCheckout = {
  __typename: 'DiscardCheckout';
  timestamp: Scalars['DateTime'];
  user: User;
};

export type DownloadEvent = {
  __typename: 'DownloadEvent';
  fileId?: Maybe<Scalars['UUID']>;
  shareId?: Maybe<Scalars['UUID']>;
  username: Scalars['String'];
};

export type DownloadFile = {
  __typename: 'DownloadFile';
  id: Scalars['UUID'];
  name: Scalars['String'];
  parent?: Maybe<Scalars['UUID']>;
  size: Scalars['Long'];
};

export type DownloadFileDescriptor = DownloadFile | DownloadFolder;

export type DownloadFileDescriptorInput = {
  /** only on type FOLDER */
  children?: InputMaybe<Array<DownloadFileDescriptorInput>>;
  /** required on type FILE */
  fileId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  type: FileDescriptorType;
};

export type DownloadFolder = {
  __typename: 'DownloadFolder';
  /** Temporary id used for mapping to tree. Do not save */
  id: Scalars['UUID'];
  name: Scalars['String'];
  parent?: Maybe<Scalars['UUID']>;
};

export type DownloadShareTask = {
  __typename: 'DownloadShareTask';
  assignedTo: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  /** @deprecated Renamed: use dueDate */
  deadline?: Maybe<Scalars['DateTime']>;
  /** The share's expiry; a share without expiry has no due date */
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  shareId: Scalars['ID'];
  shareName: Scalars['String'];
};

export type DuplicateUserInfo = {
  __typename: 'DuplicateUserInfo';
  createdAt: Scalars['DateTime'];
  eventCount: Scalars['Int'];
  hasPassword: Scalars['Boolean'];
  name: Scalars['String'];
  organisationNames: Array<Scalars['String']>;
  userId: Scalars['UUID'];
  username: Scalars['String'];
};

export type DuplicateUserPair = {
  __typename: 'DuplicateUserPair';
  currentLookupPointsTo: Scalars['UUID'];
  email: Scalars['String'];
  newUser: DuplicateUserInfo;
  oldUser: DuplicateUserInfo;
};

export enum EmailValidationReason {
  AlreadyUser = 'ALREADY_USER',
  Deliverable = 'DELIVERABLE',
  FreeEmailDomain = 'FREE_EMAIL_DOMAIN',
  Undeliverable = 'UNDELIVERABLE',
  UnknownAssumedValid = 'UNKNOWN_ASSUMED_VALID'
}

export type EmailValidationResult = {
  __typename: 'EmailValidationResult';
  email: Scalars['String'];
  reason?: Maybe<EmailValidationReason>;
  valid: Scalars['Boolean'];
};

export type ExtractedTextBlock = {
  __typename: 'ExtractedTextBlock';
  blockId: Scalars['Int'];
  category: Scalars['String'];
  confidence: Scalars['String'];
  language: Scalars['String'];
  text: Scalars['String'];
};

/** The file representaion in the system. */
export type File = {
  __typename: 'File';
  barcodeStatus: Scalars['String'];
  barcodes: Array<Barcode>;
  contentType?: Maybe<Scalars['String']>;
  created: Scalars['Long'];
  fullSize?: Maybe<Scalars['Long']>;
  id: Scalars['UUID'];
  isVideo: Scalars['Boolean'];
  lowQuality?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noPages?: Maybe<Scalars['Int']>;
  numberOfTiles?: Maybe<Scalars['Int']>;
  pages: Array<Page>;
  renderServiceName?: Maybe<Scalars['String']>;
  renderStatus?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Long']>;
  tags: Array<AssetTag>;
  textExtractions: Array<TextExtractionResult>;
  totalTileSize?: Maybe<Scalars['Long']>;
  /** Number of events applied to the file aggregate; increases with every change */
  version: Scalars['Int'];
  xDpi?: Maybe<Scalars['Float']>;
  xInches?: Maybe<Scalars['Float']>;
  xMillimeters?: Maybe<Scalars['Float']>;
  xPixels?: Maybe<Scalars['Int']>;
  yDpi?: Maybe<Scalars['Float']>;
  yInches?: Maybe<Scalars['Float']>;
  yMillimeters?: Maybe<Scalars['Float']>;
  yPixels?: Maybe<Scalars['Int']>;
  zoomLevels?: Maybe<Scalars['Int']>;
};

export type FileAdded = {
  __typename: 'FileAdded';
  fileId: Scalars['UUID'];
  fileType: FileType;
  filename: Scalars['String'];
  timestamp: Scalars['DateTime'];
  user: User;
};

export enum FileDescriptorType {
  File = 'FILE',
  Folder = 'FOLDER'
}

export type FileFolderItem = {
  __typename: 'FileFolderItem';
  /** timestamp */
  created?: Maybe<Scalars['Long']>;
  file?: Maybe<File>;
  id: Scalars['UUID'];
  lineage: Array<Folder>;
  name: Scalars['String'];
  obsolete: Scalars['Boolean'];
  tags: Array<AssetTag>;
};

export type FileHistoryEntry = Checkin | Checkout | DiscardCheckout | FileAdded | FileRemoved | FileTypeChanged;

export type FileRemoved = {
  __typename: 'FileRemoved';
  fileId: Scalars['UUID'];
  timestamp: Scalars['DateTime'];
  user: User;
};

export type FileStoragePerMonthResult = {
  __typename: 'FileStoragePerMonthResult';
  fullSize: Scalars['Long'];
  month: Scalars['Long'];
  size: Scalars['Long'];
};

/** ─── mediacenter.graphqls ──────────────────────────────────────── */
export enum FileType {
  Delivery = 'DELIVERY',
  Postdelivery = 'POSTDELIVERY',
  Preview = 'PREVIEW',
  Proof = 'PROOF',
  Resource = 'RESOURCE',
  Source = 'SOURCE',
  Unbound = 'UNBOUND'
}

export type FileTypeChanged = {
  __typename: 'FileTypeChanged';
  fileId: Scalars['UUID'];
  fileType: FileType;
  timestamp: Scalars['DateTime'];
  user: User;
};

export type FileWithTypeInput = {
  fileId: Scalars['UUID'];
  fileType: FileType;
};

export type FindFolderItemInput = {
  categoryId?: InputMaybe<Scalars['UUID']>;
  folderId: Scalars['UUID'];
  /** Defaults to false */
  includeObsolete?: InputMaybe<Scalars['Boolean']>;
  /** Search recursivly. Defaults to true */
  recursive?: InputMaybe<Scalars['Boolean']>;
  searchString?: InputMaybe<Scalars['String']>;
  tagFilter?: InputMaybe<TagFilterInput>;
};

export type FindFolderItemsInOrganisationInput = {
  categoryId?: InputMaybe<Scalars['UUID']>;
  /** Defaults to false */
  includeObsolete?: InputMaybe<Scalars['Boolean']>;
  searchString?: InputMaybe<Scalars['String']>;
  tagFilter?: InputMaybe<TagFilterInput>;
};

export type Folder = {
  __typename: 'Folder';
  /** True when the folder belongs to a deleted tree (only visible via tree(includeDeleted: true)). */
  deleted: Scalars['Boolean'];
  folders: Array<Folder>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['UUID']>;
  permissions?: Maybe<FolderPermissions>;
  shared: Scalars['Boolean'];
};

export type FolderItem = ArtworkFolderItem | FileFolderItem;

export type FolderItemSort = {
  direction: SortingDirection;
  field: FolderItemSortField;
};

export enum FolderItemSortField {
  Created = 'CREATED',
  Name = 'NAME'
}

export type FolderPermissionInput = {
  downloadDeliveryFiles: Scalars['Boolean'];
  manage: Scalars['Boolean'];
  share: Scalars['Boolean'];
  write: Scalars['Boolean'];
};

export type FolderPermissions = {
  __typename: 'FolderPermissions';
  downloadDeliveryFiles: Scalars['Boolean'];
  manage: Scalars['Boolean'];
  share: Scalars['Boolean'];
  write: Scalars['Boolean'];
};

export type FolderRole = {
  __typename: 'FolderRole';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type FolderSize = {
  __typename: 'FolderSize';
  id: Scalars['UUID'];
  name: Scalars['String'];
  size: Scalars['BigDecimal'];
  unit: FolderStorageUnit;
};

export enum FolderStorageUnit {
  Bytes = 'BYTES',
  Gigabytes = 'GIGABYTES',
  Kilobytes = 'KILOBYTES',
  Megabytes = 'MEGABYTES',
  Terabytes = 'TERABYTES'
}

export type FolderUser = {
  __typename: 'FolderUser';
  name: Scalars['String'];
  permissions: FolderPermissions;
  userId: Scalars['UUID'];
  username: Scalars['String'];
};

export type HubSpotCompany = {
  __typename: 'HubSpotCompany';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type HubSpotContact = {
  __typename: 'HubSpotContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
};

/**
 * Who to invite, and as what. The role is applied in the same dispatch that adds the
 * members, so an invitee is never briefly on the organisation's default role.
 */
export type InviteUsersInput = {
  emails: Array<Scalars['String']>;
  /** Optional note from the inviter, included in the invitation mail. */
  message?: InputMaybe<Scalars['String']>;
  /** Default to currentOrganisation */
  organisationId?: InputMaybe<Scalars['UUID']>;
  /** The role every newly added member gets. Only a role you may hand out yourself. */
  roleId: Scalars['UUID'];
};

export type Invoice = {
  __typename: 'Invoice';
  amount: Scalars['BigDecimal'];
  currency: Scalars['String'];
  id: Scalars['String'];
  /** slower query. Request on demand */
  invoicePdf: Scalars['String'];
  payedAt: Scalars['Long'];
  payedBy: User;
  subscriptionId: Scalars['String'];
};

export type ItemsPerMonth = {
  __typename: 'ItemsPerMonth';
  items: Scalars['Int'];
  month: Scalars['Long'];
};

export type LayoutConfig = {
  __typename: 'LayoutConfig';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  ownerId: Scalars['ID'];
  scope: LayoutScope;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export enum LayoutScope {
  Org = 'ORG',
  User = 'USER'
}

/** Organisation */
export type Limits = {
  __typename: 'Limits';
  maxStorage: Scalars['Long'];
  maxUsers: Scalars['Int'];
};

export type LineMarker = {
  __typename: 'LineMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type LoginAuditPost = {
  __typename: 'LoginAuditPost';
  city: Scalars['String'];
  country: Scalars['String'];
  ip: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  organisationId: Scalars['UUID'];
  timestamp: Scalars['Long'];
  userAgent: Scalars['String'];
  username: Scalars['String'];
};

export type LoginCity = {
  __typename: 'LoginCity';
  country: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
};

export type LoginInfo = {
  __typename: 'LoginInfo';
  /** Currently selected organisation */
  currentOrganisation?: Maybe<Organisation>;
  /**
   * True when the current user may perform seat-gated actions of the given kind. Resolved
   * through the same predicate as the server-side gate, so flag and enforcement cannot drift.
   * PROJECT: they hold that seat, or the organisation is not on seat pricing (fails open).
   * LIGHTBOX - the Lightbox app's licence check: they hold a Lightbox seat in the selected
   * organisation and it still pays for Lightbox seats. Strict: legacy, trial and unsubscribed
   * organisations answer false. System admins and users with lightboxEverywhere always get true.
   */
  hasSeat: Scalars['Boolean'];
  hubSpotToken?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** set to impersonating users username if impersonated */
  impersonatedBy?: Maybe<Scalars['String']>;
  /** True when the current user is the account owner of the selected organisation. */
  isAccountOwner: Scalars['Boolean'];
  /** CWAY staff. Not a role permission: staff-only UI (user administration, project history) keys on this. */
  isSystemAdmin: Scalars['Boolean'];
  /** List of organisations that the current user is a member of */
  organisationMemberships: Array<OrganisationMembership>;
  /**
   * The organisation-level permissions the current user effectively holds in the selected
   * organisation, as Permission ids (see getPermissionCatalog): through their role, plus
   * billing.manage / seats.purchase when they own the account (withheld while impersonating).
   * Empty without a selected organisation; every id for a system admin. Key menus and controls
   * on these. Modules and seats are separate axes: AND with Organisation.modules and hasSeat.
   */
  permissionIds: Array<Scalars['String']>;
  settings: UserSettings;
  shouldProvideName: Scalars['Boolean'];
  user: User;
};


export type LoginInfoHasSeatArgs = {
  seatType?: SeatType;
};

export type McArtworkFile = {
  __typename: 'MCArtworkFile';
  file: File;
  fileType: FileType;
};

export type Marker = CircleMarker | LineMarker | MeasurementLineMarker | MeasurementRectangleMarker | PinMarker | RectangleMarker;

export type MarkerInput = {
  /** default 0 */
  pageNo?: InputMaybe<Scalars['Int']>;
  type: MarkerType;
  x: Scalars['Int'];
  /** default -1 */
  xEnd?: InputMaybe<Scalars['Int']>;
  y: Scalars['Int'];
  /** default -1 */
  yEnd?: InputMaybe<Scalars['Int']>;
};

export enum MarkerType {
  Circle = 'CIRCLE',
  Line = 'LINE',
  MeasurementLine = 'MEASUREMENT_LINE',
  MeasurementRectangle = 'MEASUREMENT_RECTANGLE',
  Pin = 'PIN',
  Rectangle = 'RECTANGLE'
}

export type Market = {
  __typename: 'Market';
  id: Scalars['UUID'];
  locales: Array<Scalars['String']>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type MarketSettings = {
  __typename: 'MarketSettings';
  /** The tenant's source locale (default "en") — defines completeness and translation freshness. */
  sourceLocale: Scalars['String'];
};

export type MarketSettingsInput = {
  sourceLocale: Scalars['String'];
};

export type MeasurementCommentLineMarker = {
  __typename: 'MeasurementCommentLineMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type MeasurementCommentRectangleMarker = {
  __typename: 'MeasurementCommentRectangleMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type MeasurementLineMarker = {
  __typename: 'MeasurementLineMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type MeasurementRectangleMarker = {
  __typename: 'MeasurementRectangleMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type MediaCenterArtwork = {
  __typename: 'MediaCenterArtwork';
  /** Articles (GTIN'd pack level) this artwork is linked to. Resolve details via the `article(id)` query. */
  articleIds: Array<Scalars['UUID']>;
  category: Category;
  comments: Array<ArtworkComment>;
  created: Scalars['Long'];
  draft: Scalars['Boolean'];
  files: Array<File>;
  filesWithType: Array<McArtworkFile>;
  id: Scalars['UUID'];
  modifiedDate: Scalars['DateTime'];
  name: Scalars['String'];
  orderer?: Maybe<User>;
  preview: File;
  printCoverage?: Maybe<PrintCoverage>;
  printCoverageApproved: Scalars['Boolean'];
  project?: Maybe<Project>;
  projectArtwork?: Maybe<Artwork>;
  projectId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  tags: Array<AssetTag>;
  usedInActiveProject: Scalars['Boolean'];
  /** Number of events applied to the media center artwork aggregate; increases with every change */
  version: Scalars['Int'];
};

export type MediaCenterArtworkLocation = {
  __typename: 'MediaCenterArtworkLocation';
  artworkId: Scalars['UUID'];
  folder: Folder;
  itemId: Scalars['UUID'];
  lineage: Array<Folder>;
  treeId: Scalars['UUID'];
};

export type MediaCenterStats = {
  __typename: 'MediaCenterStats';
  artworks?: Maybe<Scalars['Int']>;
  itemsPerMonth: Array<ItemsPerMonth>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type MediaCenterStorageSummary = {
  __typename: 'MediaCenterStorageSummary';
  fullSize: Scalars['BigDecimal'];
  organisationId: Scalars['UUID'];
  /** Not always set */
  organisationName?: Maybe<Scalars['String']>;
  totalSize: Scalars['BigDecimal'];
  unit: FolderStorageUnit;
};

/**
 * One module on a subscription with its quotas. Quota fields: null = not applicable to the
 * module (e.g. storage on Project), -1 = unlimited, otherwise the included amount.
 */
export type ModuleEntitlement = {
  __typename: 'ModuleEntitlement';
  includedUsers?: Maybe<Scalars['Int']>;
  module: CwayModule;
  /** Stripe item quantity; 1 for base modules, the unit count for overage lines */
  quantity: Scalars['Long'];
  skuLimit?: Maybe<Scalars['Int']>;
  storageQuotaGb?: Maybe<Scalars['BigDecimal']>;
  tier?: Maybe<SubscriptionTier>;
  trafficQuotaGb?: Maybe<Scalars['BigDecimal']>;
};

/** Count of open projects for a specific month */
export type MonthlyOpenProjectsCount = {
  __typename: 'MonthlyOpenProjectsCount';
  count: Scalars['Int'];
  month: Scalars['LocalDate'];
};

export type Mutation = {
  __typename: 'Mutation';
  /**
   * Accept the organisation's open offer. For an offer paid by card, returns a Stripe Checkout
   * URL where the customer saves a payment method; the subscription is created when that session
   * completes and then arrives on the organisation like any other (refetch on the
   * ?payment.success return, as for checkout).
   *
   * For an invoiced offer (paymentTermsDays set) there is no Stripe page: `billing` is required,
   * the subscription is created right away with Stripe sending the invoices, and null is returned
   * - refetch the organisation. Fails with "The billing address could not be used for tax" or
   * "The VAT id ... was not recognised" when Stripe refuses the details; nothing is created then.
   */
  acceptSubscriptionOffer?: Maybe<Scalars['String']>;
  /** System admin only - Reactivate previously deactivated organisations. */
  activateOrganisations: Scalars['Boolean'];
  /**
   * Add an API key for programmatic access to the system with specified scopes. With the GRAPHQL
   * scope, roleId (a role with Role.grantableByMe) is required: the key acts as a service account
   * holding that role. Refused with a role for REST-only scopes.
   * expiresAt (epoch millis, must be in the future) makes the key stop authenticating then; omit for no expiry.
   */
  addApiKey: Scalars['Boolean'];
  /** Link a product to a mediacenter artwork. */
  addArticleToMCArtwork: Scalars['Boolean'];
  /** Add actions to multiple project artworks (e.g., deliver to mediacenter, create color proof). */
  addArtworkActions: Scalars['Boolean'];
  /** Add additional files to a project artwork. Does not replace existing files. Optionally set bundled state. */
  addArtworkFiles: Scalars['Boolean'];
  /** Add a validation rule to a project artwork (e.g., bleed requirements, color space). */
  addArtworkRule: Scalars['Boolean'];
  /** Add a mediacenter artwork to a folder (creates a link/reference). */
  addArtworkToFolder: Scalars['Boolean'];
  /** Add a correction (comment with annotations) to a project artwork. Can include markers and attached files. */
  addCorrection: Scalars['Boolean'];
  /**
   * Add a file to a mediacenter folder. An optional folderItemId may be supplied
   * by the client to pre-generate the item's id; omit it to have the server generate one.
   */
  addFileToFolder: Scalars['Boolean'];
  /** Add files to a product. Files must be uploaded first (via tempFileUploadUrl). */
  addFilesToProduct: Scalars['Boolean'];
  /**
   * Add reference or supporting files to a project (not tied to specific artworks).
   * path is an optional S3-style folder prefix; omitted/null adds to the project root.
   */
  addFilesToProject: Scalars['Boolean'];
  /** Add a note to a project. */
  addNoteToProject: Scalars['Boolean'];
  /** Add relationships to a product (e.g. cross-sell, upsell, accessory). */
  addRelationshipsToProduct: Scalars['Boolean'];
  /** Add an SSO domain directly as trusted (system admin only). Organisation owners should use initiateSsoDomainVerification instead. */
  addSsoDomain: Scalars['Boolean'];
  addTagsToMediaCenterArtworks: Scalars['Boolean'];
  addTagsToMetaFiles: Scalars['Boolean'];
  addTagsToProjectArtworks: Scalars['Boolean'];
  /** Add an assignment type (APPROVER/RECEIVER/SUPPLIER) to a team on an artwork. */
  addTeamAssignmentToArtwork: Scalars['Boolean'];
  /** Create a new API token for the current user. Client must provide the token value. */
  addUserApiToken: Scalars['Boolean'];
  /** Add a user to a project artwork (legacy operation, prefer assignUsersToArtworks for batch operations). */
  addUserToArtwork: Scalars['Boolean'];
  /** Add a user to a team on an artwork. */
  addUserToArtworkTeam: Scalars['Boolean'];
  /** Grant a user access to a mediacenter folder with specific permissions (write, manage, share, download). */
  addUserToFolder: Scalars['Boolean'];
  /**
   * System admin only - Add users to an organisation on the customer's behalf (sales flow).
   * New users are created and receive a welcome mail; permissionGroupId optionally assigns a role.
   */
  addUsersToOrganisation: Scalars['Boolean'];
  /** Add users to a team with optional admin privileges. */
  addUsersToTeam: Scalars['Boolean'];
  /**
   * Apply the organisation's open offer to the subscription it already pays for: items and
   * discounts change right away, prorated and invoiced on the card on file, a cancelled renewal
   * is reinstated. All or nothing - a declined card fails with "Payment failed (...); nothing
   * was changed". The offer closes at once; the subscription snapshot follows by webhook.
   *
   * Returns null when the offer was applied. Otherwise a Stripe Checkout URL: send the customer
   * there to save a card, and the offer is applied when that session completes (refetch on the
   * ?payment.success return, as for checkout). That happens when the person accepting is not
   * the Stripe customer the subscription is billed to - a legacy or enterprise subscription set
   * up by a colleague - in which case accepting starts a subscription of their own and cancels
   * the old one, so invoices and receipts reach whoever actually pays; and when the customer is
   * right but has no payment method saved, in which case the subscription is changed in place
   * once the card is there.
   *
   * An invoiced offer (paymentTermsDays set) never returns a URL: `billing` is required, the
   * subscription is switched to invoicing with the offer's terms in the same update (the invoice
   * the preview showed is sent, not charged), and null is returned. When the accepter is not the
   * billed customer, an invoiced subscription of their own is created right away and the old one
   * cancelled - the preview's replacesSubscription says so beforehand.
   */
  applySubscriptionOffer?: Maybe<Scalars['String']>;
  /** Approve a project artwork. The approver must be assigned to the artwork and the artwork must be in an approvable state. */
  approveArtwork: Scalars['Boolean'];
  /** Approve multiple project artworks at once. Current user must be assigned as approver to all artworks. */
  approveArtworks: Scalars['Boolean'];
  /** Archive artwork categories (hide them but preserve existing usage). */
  archiveArtworkCategories: Scalars['Boolean'];
  /** Archive a project status, hiding it from new selections but keeping historical references intact. */
  archiveProjectStatus: Scalars['Boolean'];
  /** Assign a user as an approver to a project artwork. Approvers can approve or reject the artwork. */
  assignApproverToArtwork: Scalars['Boolean'];
  /** Assign a user as a receiver to a project artwork. Receivers are notified when the artwork is delivered. */
  assignReceiverToArtwork: Scalars['Boolean'];
  /**
   * Assign a seat to a member. Requires a free seat on seat-requiring subscriptions.
   * organisationId is system-admin only.
   */
  assignSeat: Scalars['Boolean'];
  /** Assign an attribute set to a product category. */
  assignSetToCategory: Scalars['Boolean'];
  /** Assign a user as a supplier to a project artwork. Suppliers are responsible for uploading revisions. */
  assignSupplierToArtwork: Scalars['Boolean'];
  /** Assign multiple users to multiple project artworks with specific roles (approver, receiver, supplier) in a single operation. */
  assignUsersToArtworks: Scalars['Boolean'];
  /** Attach a team from the organisation to a single artwork with specified assignments. */
  attachTeamToArtwork: Scalars['Boolean'];
  /** Attach a team from the organisation to multiple artworks with specified assignments. */
  attachTeamToArtworks: Scalars['Boolean'];
  /** Bundle project artworks for delivery. Sets artwork files and transitions to bundled state. */
  bundleArtworks: Scalars['Boolean'];
  /** Cancel project artworks, marking them as canceled and removing them from active work. */
  cancelArtworks: Scalars['Boolean'];
  /**
   * Cancel a subscription at period end; access continues until then. Without arguments it
   * cancels the caller's active subscription. subscriptionId targets a specific one (e.g. a
   * past-due subscription that is not the active one); organisationId is system-admin only,
   * omitted = caller's organisation. For an immediate cancel see cancelSubscriptionImmediately.
   */
  cancelSubscription: Scalars['Boolean'];
  /**
   * System admin only - cancel a Stripe subscription right away, with no final invoice and no
   * proration (the customer-facing cancelSubscription only schedules a cancel at period end).
   * Refused for CWAY-managed trials (use stopOrganisationTrial) and already-canceled
   * subscriptions. reason is stored on the Stripe subscription as the cancellation comment.
   */
  cancelSubscriptionImmediately: Scalars['Boolean'];
  /** Change the file type of existing files on a project artwork. Each entry retypes an already-added file. */
  changeArtworkFileTypes: Scalars['Boolean'];
  /** Change the name of a project artwork. */
  changeArtworkName: Scalars['Boolean'];
  /** Modify an existing validation rule on a project artwork. */
  changeArtworkRule: Scalars['Boolean'];
  /** Change the approval mode for a team on an artwork. */
  changeArtworkTeamApprovalMode: Scalars['Boolean'];
  /** Edit basic project data like name, description, dates, and order number. */
  changeBasicProjectData: Scalars['Boolean'];
  /** Change the category of multiple project artworks at once. */
  changeCategoryOfArtworks: Scalars['Boolean'];
  /** Rename a mediacenter item (artwork or file). */
  changeFolderItemName: Scalars['Boolean'];
  /** Change the permissions for a user who already has access to a mediacenter folder. */
  changeFolderUserPermission: Scalars['Boolean'];
  /** Change the category of a mediacenter artwork. Cannot be used on artworks synchronized from projects. */
  changeMCArtworkCategory: Scalars['Boolean'];
  /** Change the preview file of a mediacenter artwork. Cannot be used on artworks synchronized from projects. */
  changeMCArtworkPreviewFile: Scalars['Boolean'];
  /** Update the name and description of an existing artwork category. */
  changeNameAndDescriptionOfCategory: Scalars['Boolean'];
  /** Change the orderer (client) of a project. Requires appropriate permissions. */
  changeOrderer: Scalars['Boolean'];
  /** Request an email address change for the current user. Sends verification email to new address. */
  changeOwnEmail?: Maybe<Scalars['Boolean']>;
  /** Change the current user's password. Requires providing the old password for verification. */
  changeOwnPassword?: Maybe<Scalars['Boolean']>;
  /** Admin only - Change a user's password without requiring the old password. */
  changePassword?: Maybe<Scalars['Boolean']>;
  /**
   * Move a project to a customisable status. Invariants of the target status's category are enforced
   * (e.g. moving to a CLOSED-category status requires all artwork tasks to be finished, unless force=true).
   */
  changeProjectStatus: Scalars['Boolean'];
  /**
   * Legacy single-product plan switch. Prorates charges/credits.
   * @deprecated Legacy single-product plan switch; module subscriptions change through updateSubscriptionItems.
   */
  changeSubscription: Scalars['Boolean'];
  /** Change the approval mode for a team (ALL_REQUIRED or ANY_MEMBER). */
  changeUserTeamApprovalMode: Scalars['Boolean'];
  /** Check in a project artwork after editing, uploading the modified files. */
  checkinArtwork: Scalars['Boolean'];
  /** Check out a project artwork for editing (creates a work copy for desktop editing). */
  checkoutArtwork: Scalars['Boolean'];
  /** Close one or more projects, marking them as completed. Use force=true to close projects not in closeable state. */
  closeProjects?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated(reason: "Use commentMediaCenterArtworks instead")
   * @deprecated Use commentMediaCenterArtworks instead
   */
  commentMediaCenterArtwork: Scalars['Boolean'];
  /** Add comments with optional annotations to mediacenter artworks. Comments can include markers and attached files. */
  commentMediaCenterArtworks: Scalars['Boolean'];
  /** Complete SSO domain verification with the code and state returned from Microsoft (organisation owner). */
  completeSsoDomainVerification: Scalars['Boolean'];
  /** Configure Blikk integration settings for the organisation. Set apiKey to null to disable. */
  configureBlikkIntegration: Scalars['Boolean'];
  /** Accept the general terms and conditions for the current user. */
  consentToGeneralTerms: Scalars['Boolean'];
  /**
   * Give a legacy GraphQL key (ApiKey.legacy) a service account with roleId, so it stops acting
   * as its creator. Once per key.
   */
  convertApiKeyToServiceAccount: Scalars['Boolean'];
  /** Convert a file in the mediacenter into a mediacenter artwork with typed files (source, delivery, resource). */
  convertFileIntoMediaCenterArtwork: Scalars['Boolean'];
  /** Copy a mediacenter folder and all its contents to a new location. */
  copyFolder: Scalars['Boolean'];
  /** Copy mediacenter items to another folder. */
  copyFolderItems: Scalars['Boolean'];
  /** System admin only - Create an AI agent user within the current organisation. */
  createAgentUser: Scalars['Boolean'];
  /** Create an anonymous share that can be accessed via a public link without requiring an account. */
  createAnonymousShare: Scalars['Boolean'];
  /**
   * Create a new article (SKU) for a product. Returns the new article's UUID; read the record
   * back via the article query (with delay) or a subscription.
   */
  createArticle: Scalars['UUID'];
  /** Create a new project artwork within an existing project. */
  createArtwork: Scalars['Boolean'];
  /** Create a new artwork category for organizing artworks within the organisation. */
  createArtworkCategory: Scalars['Boolean'];
  /** Create multiple project artworks from existing files. Each file becomes a separate artwork. */
  createArtworksFromFiles: Scalars['Boolean'];
  /** Create project artworks by copying from mediacenter artworks. Links the project artwork to the mediacenter artwork. */
  createArtworksFromMediaCenterArtworks: Scalars['Boolean'];
  /** Create new project artworks by copying from existing project artworks (within or across projects). */
  createArtworksFromProjectArtworks: Scalars['Boolean'];
  createAssetTag: Scalars['UUID'];
  /** Create a new attribute set. Returns the new set's UUID. */
  createAttributeSet: Scalars['UUID'];
  /** Create a new brand. UUID will be generated if not supplied. */
  createBrand: Scalars['Boolean'];
  /** Attach a brief document (reference file) to a project artwork. */
  createBriefFromFile: Scalars['Boolean'];
  /** Create external collaboration links for project artworks, allowing non-users to view/comment via email. */
  createCollaborationForArtworks: Scalars['Boolean'];
  /** Admin only - Create a custom organisation role from a set of permissions. Returns the new role id. */
  createCustomRole: Scalars['UUID'];
  /**
   * System admin only - Create an organisation on behalf of a new customer (sales flow).
   * The customer becomes organisation owner and receives a registration mail with a password request.
   * Returns the id of the new organisation.
   */
  createCustomerOrganisation: Scalars['UUID'];
  /** Create a download job for multiple files with custom folder structure. Returns job ID for download from file service. */
  createDownloadJob: Scalars['UUID'];
  /** Create a download job for a single file. Returns job ID for download from file service. Optionally package as zip. */
  createFileDownloadJob: Scalars['UUID'];
  /** Create a new subfolder within an existing mediacenter folder. */
  createFolder: Scalars['Boolean'];
  /** System admin only - Create HubSpot contacts for all users in the system. */
  createHubSpotContactForAllUsers: Scalars['Boolean'];
  /** System admin only - Create a HubSpot contact for a user if they don't already exist in CRM. */
  createHubSpotContactIfMissing: Scalars['Boolean'];
  /** Create a new market for geographical organization. Returns the new market's UUID. */
  createMarket: Scalars['UUID'];
  /** Create a new print specification with default values. Returns the created specification's ID. */
  createPrintSpecification: Scalars['UUID'];
  /** Create a new product. Returns the created product's ID. */
  createProduct: Scalars['UUID'];
  /** Create a new product attribute definition. */
  createProductAttribute: Scalars['UUID'];
  /** Create a new product category with optional parent for hierarchy. */
  createProductCategory: Scalars['Boolean'];
  /** Create a new product stage. Returns the new stage's UUID. */
  createProductStage: Scalars['UUID'];
  /** Create a new project. Can optionally attach files or mediacenter artworks during creation. */
  createProject: Scalars['Boolean'];
  /** Create a customisable project status under a category (IN_PROGRESS or CLOSED). */
  createProjectStatus: Scalars['Boolean'];
  /** Create a new root-level folder in the mediacenter. Requires special permissions. */
  createRootFolder: Scalars['Boolean'];
  /** Create a share and send it to specified email addresses. Recipients must have accounts to access. */
  createShare: Scalars['Boolean'];
  /**
   * System admin only - Make a special subscription offer to an organisation: catalog products at
   * list price with per-line and global percentage discounts (100 = free), an optional trial and
   * acceptance deadline. Only one open offer at a time - revoke the previous one first. Returns the offer id.
   */
  createSubscriptionOffer: Scalars['UUID'];
  /** Create a new user account within an organisation. Email invitation will be sent. */
  createUser: Scalars['Boolean'];
  /** Create a new user team for organizing users. Team ID will be generated if not provided. */
  createUserTeam: Scalars['Boolean'];
  /** Create multiple users from a list of email addresses. Sends invitations to all valid addresses. */
  createUsersFromEmailString: Scalars['Boolean'];
  /** Create a webhook to receive event notifications at a specified URL. */
  createWebhook: Scalars['Boolean'];
  /** System admin only - Deactivate organisations, preventing access to the system. */
  deactivateOrganisations: Scalars['Boolean'];
  /**
   * Decline a pending seat request with an optional reason. The requester is notified by email.
   * organisationId is system-admin only; omitted = caller's organisation.
   */
  declineSeatRequest: Scalars['Boolean'];
  /** Delete an article. Refused when it still has child pack levels. */
  deleteArticle: Scalars['Boolean'];
  /** Permanently delete project artworks from the project. */
  deleteArtworks: Scalars['Boolean'];
  deleteAssetTag: Scalars['Boolean'];
  /** Delete an attribute set. Fails if the set is locked. */
  deleteAttributeSet: Scalars['Boolean'];
  /** Delete a detected barcode from a file. */
  deleteBarcode: Scalars['Boolean'];
  /** Admin only - Delete a custom role. Fails if the role is still assigned to any user. */
  deleteCustomRole: Scalars['Boolean'];
  /** Delete a mediacenter folder and all its contents. Use with caution. */
  deleteFolder: Scalars['Boolean'];
  /** Delete a market. */
  deleteMarket: Scalars['Boolean'];
  /** Delete a print specification. */
  deletePrintSpecification: Scalars['Boolean'];
  /** @deprecated Use deleteArticles instead */
  deleteProduct: Scalars['Boolean'];
  /** Delete a product attribute definition. */
  deleteProductAttribute: Scalars['Boolean'];
  /** Delete a product category. */
  deleteProductCategory: Scalars['Boolean'];
  /** Delete a product stage. */
  deleteProductStage: Scalars['Boolean'];
  /** Delete one or more products. */
  deleteProducts: Scalars['Boolean'];
  /** Permanently delete a project status. Cannot delete the default status for a category. */
  deleteProjectStatus: Scalars['Boolean'];
  /** Delete one or more projects. Use force=true to delete projects that are not in a deleteable state. */
  deleteProjects: Scalars['Boolean'];
  /** @deprecated. Use deleteUserTeams(teamIds: [UUID!]!) */
  deleteUserTeam: Scalars['Boolean'];
  /** Delete one or more user teams. */
  deleteUserTeams: Scalars['Boolean'];
  /** Admin only - Delete users from an organisation. Removes access but preserves data. */
  deleteUsers?: Maybe<Scalars['Boolean']>;
  /** Deliver project artworks to receivers. Optionally include a delivery message. Triggers notifications. */
  deliverArtworks: Scalars['Boolean'];
  /** Mark a project as delivered to the client. */
  deliverProject?: Maybe<Scalars['Boolean']>;
  /** Discard the current user's checkout of an artwork without uploading any files (e.g. local copy was lost or abandoned). */
  discardArtworkCheckout: Scalars['Boolean'];
  /** Dismiss a spelling error (false positive) for a specific file page. */
  dismissSpellingError: Scalars['Boolean'];
  endChatSession: Scalars['Boolean'];
  /**
   * End the Stripe trial period on the active subscription early and start billing.
   * (CWAY-managed trials are ended by staff with stopOrganisationTrial.)
   */
  endSubscriptionTrial: Scalars['Boolean'];
  /** @deprecated Renamed: use endSubscriptionTrial */
  endTrial: Scalars['Boolean'];
  /** Export a project and all its artworks to a downloadable file. Returns the file ID for download. */
  exportProjectToFile: Scalars['UUID'];
  findOrCreateAssetTag: Scalars['UUID'];
  /** Mark actions as completed on multiple project artworks. */
  finishArtworkActions: Scalars['Boolean'];
  /**
   * Grant a pending seat request: assigns the seat and resolves the request. Refused with
   * NO_SEATS_AVAILABLE when the block is full - buy one more seat (setSubscriptionSeats) and retry.
   * organisationId is system-admin only; omitted = caller's organisation.
   */
  grantSeatRequest: Scalars['Boolean'];
  /** Mark a comment on a mediacenter artwork as invalid/deleted. */
  inValidateMediaCenterArtworkComment: Scalars['Boolean'];
  /** Initiate SSO domain verification (organisation owner). Returns a Microsoft auth URL. After authenticating, call completeSsoDomainVerification. */
  initiateSsoDomainVerification: Scalars['String'];
  /** Mark a correction as invalid/deleted. Invalid corrections are hidden from the approval workflow. */
  invalidateCorrection: Scalars['Boolean'];
  /**
   * Admin only - Invite people to the organisation as a given role, in one step. Emails that
   * already belong to a member are left alone, role included. Requires both the right to add
   * users and the right to assign the role.
   */
  inviteUsers: Scalars['Boolean'];
  /** @deprecated - no need to launch when planned state is removed */
  launchProjects?: Maybe<Scalars['Boolean']>;
  /** Link a CWAY project to a Blikk project. */
  linkProjectToBlikk: Scalars['Boolean'];
  /** Mark all shares received by the current user as read. */
  markAllSharesAsRead: Scalars['Boolean'];
  /** Mark a share as read by the current user. */
  markShareAsRead: Scalars['Boolean'];
  mergeAssetTags: Scalars['Boolean'];
  /** Modify the position or boundaries of a detected barcode on a file. */
  modifyBarcode: Scalars['Boolean'];
  /** Move a mediacenter folder to a new parent location. Can specify position relative to target. */
  moveFolder: Scalars['Boolean'];
  /** Move mediacenter items from one folder to another. */
  moveFolderItems: Scalars['Boolean'];
  /** Move a product category to a different parent in the hierarchy. */
  moveProductCategory: Scalars['Boolean'];
  /** Move project files to a folder path. Null/omitted path moves them to the project root. */
  moveProjectFiles: Scalars['Boolean'];
  /** Upload a new revision for a project artwork from an existing file. Optionally include a comment explaining changes. */
  newRevisionFromFile: Scalars['Boolean'];
  /** Mark a mediacenter item (artwork or file) as obsolete without deleting it. */
  obsoleteFolderItem: Scalars['Boolean'];
  /** Trigger async text re-extraction for an artwork. Returns immediately while extraction runs in background. */
  reExtractText: Scalars['Boolean'];
  /** Trigger color separation re-rendering for a PDF file. */
  reRenderColorSeparation?: Maybe<Scalars['Boolean']>;
  /** Trigger re-rendering of a file (regenerates tiles, previews, and metadata). */
  reRenderFile?: Maybe<Scalars['Boolean']>;
  /** System admin only - Reindex a share in the search system. */
  reindexShare: Scalars['Boolean'];
  /** Reject delivered project artworks and change their state. Requires special permissions. */
  rejectAndChangeDeliveredArtworks: Scalars['Boolean'];
  /** Reject a project artwork with an optional comment. Can optionally reset other users' approvals. */
  rejectArtwork: Scalars['Boolean'];
  /** Reject multiple project artworks at once. Current user must be assigned as approver to all artworks. */
  rejectArtworks: Scalars['Boolean'];
  /** Send a reminder email to an approver who hasn't yet approved or rejected a project artwork. */
  remindApprover: Scalars['Boolean'];
  /** Remove all role assignments (approver, receiver, supplier) for a user from a project artwork. */
  removeAllAssignmentsForUserFromArtwork: Scalars['Boolean'];
  /** Remove all user assignments (approvers, receivers, suppliers) from project artworks. */
  removeAllAssignmentsFromArtworks: Scalars['Boolean'];
  /** Remove an API key, revoking its access. Its service account leaves the organisation with it. */
  removeApiKey: Scalars['Boolean'];
  /** Remove a user's approver role from a project artwork. */
  removeApproverFromArtwork: Scalars['Boolean'];
  /** Unlink a product from a mediacenter artwork. */
  removeArticleFromMCArtwork: Scalars['Boolean'];
  /** Remove actions from multiple project artworks. */
  removeArtworkActions: Scalars['Boolean'];
  /** Remove files from multiple artworks within a single project. Each entry lists the files to remove from one artwork. */
  removeArtworkFiles: Scalars['Boolean'];
  /** Remove a validation rule from a project artwork. */
  removeArtworkRule: Scalars['Boolean'];
  /** Remove a collaboration link from a project artwork. */
  removeCollaborationForArtworks: Scalars['Boolean'];
  /** Remove specific events from mediacenter folder tree history. */
  removeEventsFromTree: Scalars['Boolean'];
  /** Remove files from a product. */
  removeFilesFromProduct: Scalars['Boolean'];
  /** Remove reference files from a project. */
  removeFilesFromProject: Scalars['Boolean'];
  /** Remove a mediacenter item from a folder (deletes the item). */
  removeFolderItem?: Maybe<Scalars['Boolean']>;
  /** Remove a note from a project. */
  removeNoteFromProject: Scalars['Boolean'];
  /**
   * System admin only - remove a subscription that has no backing in Stripe (dev/staging data
   * drift). Refused when Stripe still knows the subscription (cancel it through its normal
   * lifecycle) or when it is a CWAY-managed trial (use stopOrganisationTrial).
   */
  removeOrphanedSubscription: Scalars['Boolean'];
  /** Remove a user's receiver role from a project artwork. */
  removeReceiverFromArtwork: Scalars['Boolean'];
  /** Remove relationships from a product. */
  removeRelationshipsFromProduct: Scalars['Boolean'];
  /** Delete one or more shares, removing access for recipients. */
  removeShares: Scalars['Boolean'];
  /** Remove an SSO domain from the organisation (organisation owner). */
  removeSsoDomain: Scalars['Boolean'];
  /** Remove a sub-approver's approval from a project artwork, optionally providing a reason. */
  removeSubApprovalForUser: Scalars['Boolean'];
  /** Remove a user's supplier role from a project artwork. */
  removeSupplierFromArtwork: Scalars['Boolean'];
  removeTagsFromMediaCenterArtworks: Scalars['Boolean'];
  removeTagsFromMetaFiles: Scalars['Boolean'];
  removeTagsFromProjectArtworks: Scalars['Boolean'];
  /** Remove an assignment type from a team on an artwork. */
  removeTeamAssignmentFromArtwork: Scalars['Boolean'];
  /** Remove a team from an artwork. */
  removeTeamFromArtwork: Scalars['Boolean'];
  /** Remove an API token for the current user by its ID. */
  removeUserApiToken: Scalars['Boolean'];
  /** Remove a user from a team on an artwork. */
  removeUserFromArtworkTeam: Scalars['Boolean'];
  /** Remove a user's access to a mediacenter folder. */
  removeUserFromFolder: Scalars['Boolean'];
  /** Remove users from a team. */
  removeUsersFromTeam: Scalars['Boolean'];
  /** Remove a webhook, stopping event notifications. */
  removeWebhook: Scalars['Boolean'];
  /** Rename an attribute set. */
  renameAttributeSet: Scalars['Boolean'];
  /** System admin only - Rename a duplicate user's email to deactivate it as a duplicate. */
  renameDuplicateUser: Scalars['Boolean'];
  /** Rename a mediacenter folder. */
  renameFolder: Scalars['Boolean'];
  /** Rename a market. */
  renameMarket: Scalars['Boolean'];
  /** Rename a note on a project. */
  renameNoteOnProject: Scalars['Boolean'];
  /** Rename a product category. */
  renameProductCategory: Scalars['Boolean'];
  /** Update the name and description of a project status. */
  renameProjectStatus: Scalars['Boolean'];
  /** Reopen previously closed projects, allowing further work to be done. */
  reopenProjects?: Maybe<Scalars['Boolean']>;
  /** Reorder attribute sets by supplying all IDs in the desired order. */
  reorderAttributeSets: Scalars['Boolean'];
  /** Reorder the attributes within a set by supplying all IDs in the desired order. */
  reorderAttributes: Scalars['Boolean'];
  /** Reorder markets by supplying all IDs in the desired order. */
  reorderMarkets: Scalars['Boolean'];
  /** Reorder product stages by supplying all IDs in the desired order. */
  reorderProductStages: Scalars['Boolean'];
  /** Replace the preview/thumbnail file for a project artwork. */
  replacePreviewFile: Scalars['Boolean'];
  /**
   * Ask the account owner and seat managers for a seat - for yourself (userId omitted) or a colleague you tried
   * to assign. Idempotent: an existing seat or pending request is a quiet no-op.
   */
  requestSeat: Scalars['Boolean'];
  /** Request an update form for a print specification, optionally sending it to a specific email address. */
  requestUpdateForPrintSpecification: Scalars['Boolean'];
  /** Reset completed actions on multiple project artworks to incomplete state. */
  resetArtworkActions: Scalars['Boolean'];
  /**
   * Removes stored configs so clients fall back to defaults. Targets one exact key, every
   * key starting with keyPrefix (give at most one of the two), or — with neither — every
   * key of the type.
   */
  resetLayoutConfig: Scalars['Boolean'];
  /** Revert specific project events by ID. More targeted than rollback. */
  revertProjectEvents: Scalars['Boolean'];
  /** Revoke approval status from project artworks, allowing them to be worked on again. Requires appropriate permissions. */
  revokeArtworkApproval: Scalars['Boolean'];
  /** @deprecated. Remove this */
  revokeArtworkApprovalOrRejection: Scalars['Boolean'];
  /** Revoke rejection status from project artworks, allowing them to be resubmitted. Requires appropriate permissions. */
  revokeArtworkRejection: Scalars['Boolean'];
  /** Revoke bundling status from project artworks, returning them to their previous state. */
  revokeBundlingOfArtworks: Scalars['Boolean'];
  /** Revoke delivery of project artworks, returning them to bundled state. Useful for fixing delivery mistakes. */
  revokeDeliveryOfArtworks: Scalars['Boolean'];
  /**
   * Free a member's seat without shrinking the subscription: the purchased seat stays and can be
   * reassigned with assignSeat. organisationId is system-admin only.
   */
  revokeSeat: Scalars['Boolean'];
  /** System admin only - Withdraw an open offer. */
  revokeSubscriptionOffer: Scalars['Boolean'];
  /** Rollback project history to a specific event, undoing all events after that point. Use with caution. */
  rollBackProjectHistory: Scalars['Boolean'];
  /** Rollback mediacenter folder tree to a specific event, undoing all changes after that point. Use with caution. */
  rollbackTree: Scalars['Boolean'];
  /** Save print coverage analysis data for a mediacenter artwork, including print and color canvas information. */
  saveMCArtworkPrintCoverage: Scalars['Boolean'];
  /** Save print coverage analysis data for a project artwork, including print and color canvas information. */
  savePrintCoverage: Scalars['Boolean'];
  /**
   * Send a user message on an existing session. If `context` is supplied it
   * replaces the session's current context wholesale — pass it whenever the
   * user navigates so the bot stays in sync with what the user is looking at.
   * Omit to keep the existing context unchanged.
   */
  sendChatMessage: Scalars['Boolean'];
  /** System admin only - Set custom instructions for an AI agent user. */
  setAgentInstructions: Scalars['Boolean'];
  /**
   * Set attribute values on an article.
   * Set (or clear, when value is null) one localized article attribute value.
   */
  setArticleAttributeValue: Scalars['Boolean'];
  /** Set the GS1 indicator digit (1–8); regenerates gtins[0] as a GTIN-14 when a single base unit resolves. */
  setArticleIndicatorDigit: Scalars['Boolean'];
  /**
   * --- Pack-hierarchy management (GS1 trade-item hierarchy). Articles are addressed by id alone.
   * Per the CQRS convention these return an ack; the recomputed article (incl. derived GTIN-14)
   * is read back via the article query or a subscription.
   * Link/move an article under a parent pack level (null parent = unlink → standalone).
   */
  setArticlePackParent: Scalars['Boolean'];
  /** Edit the roll-up quantity on an already-linked article. */
  setArticleQuantityInParent: Scalars['Boolean'];
  /** Set an artwork category as the default for new artworks. */
  setArtworkCategoryAsDefault: Scalars['Boolean'];
  /** Set artworks to silent mode (suppress email notifications about them) or unset silent mode. */
  setArtworksSilent: Scalars['Boolean'];
  /** Upload and set an avatar image for the current user. */
  setAvatar: Scalars['Boolean'];
  /** Update communication settings for the organisation, such as default email notification preferences. */
  setCommunicationSettings: Scalars['Boolean'];
  /** Admin only - Replace the set of permissions a custom role grants. */
  setCustomRolePermissions: Scalars['Boolean'];
  /** Set or update the start and end dates for multiple artworks within a project. */
  setDatesOnArtworks: Scalars['Boolean'];
  /** Set or update the start and end dates for a project. */
  setDatesOnProject: Scalars['Boolean'];
  /** Customize the desktop application theme colors and wallpaper for the organisation. */
  setDesktopTheme: Scalars['Boolean'];
  /** Admin only - Grant or revoke early access program features for a user. */
  setEarlyAccess: Scalars['Boolean'];
  /** Admin only - Set FTP password for a user to enable file transfers. */
  setFtpPassword: Scalars['Boolean'];
  /** Set or update the invoice number for a project artwork (for billing/accounting purposes). */
  setInvoiceNumber: Scalars['Boolean'];
  setLayoutConfig: Scalars['Boolean'];
  /** Admin only - Grant or revoke Lightbox in every organisation, regardless of Lightbox seats. */
  setLightboxEverywhere: Scalars['Boolean'];
  /** Set/replace all files on a mediacenter artwork with typed files (source, delivery, preview, resource). */
  setMCArtworkFiles: Scalars['Boolean'];
  /** Set locales for a market. */
  setMarketLocales: Scalars['Boolean'];
  /** Update market settings for the organisation (e.g. the source locale). */
  setMarketSettings: Scalars['Boolean'];
  setMediaCenterArtworkTags: Scalars['Boolean'];
  /** Mark mediacenter artworks as draft (hidden from normal views) or published (visible). */
  setMediaCenterArtworksDraft: Scalars['Boolean'];
  setMetaFileTags: Scalars['Boolean'];
  /** Admin only - Set the organisation's logo image. */
  setOrganisationLogo: Scalars['Boolean'];
  /** Update the current user's first and last name. */
  setOwnUserRealName: Scalars['Boolean'];
  /** Admin only - Assign users a role (permissionGroupId is the role id), controlling their access level. */
  setPermissionGroupForUsers: Scalars['Boolean'];
  /**
   * Set attribute values on a product.
   * Set (or clear, when value is null) one localized product attribute value.
   */
  setProductAttributeValue: Scalars['Boolean'];
  /** Set brand for multiple products at once. Null removes the brand. */
  setProductBrand: Scalars['Boolean'];
  /** Set categories for multiple products at once, replacing all existing categories. */
  setProductCategories: Scalars['Boolean'];
  /** Set the full set of markets for one or more products at once (replaces each product's set). */
  setProductMarkets: Scalars['Boolean'];
  /** Set the stage of a product. */
  setProductStage: Scalars['Boolean'];
  /** Set/replace all files on a project artwork with typed files (source, delivery, resource). Optionally set bundled state. */
  setProjectArtworkFiles: Scalars['Boolean'];
  setProjectArtworkTags: Scalars['Boolean'];
  /** Assign or change the project manager responsible for overseeing the project. */
  setProjectManager: Scalars['Boolean'];
  /** Set a project status as the default within its category. New projects in that category get this status. */
  setProjectStatusAsDefault: Scalars['Boolean'];
  /** Set projects to silent mode (suppress email notifications) or unset silent mode. */
  setProjectsSilent: Scalars['Boolean'];
  /**
   * Set the purchased extra-seat quantity on the active subscription. Invoiced immediately with proration.
   * organisationId is system-admin only; omitted = caller's organisation.
   */
  setSubscriptionSeats: Scalars['Boolean'];
  /**
   * System admin only - Grant or revoke the CWAY system administrator role for another user.
   * Not allowed on yourself, and not from an impersonated session.
   */
  setSystemAdmin: Scalars['Boolean'];
  /** Set whether a team is self-managed (all members treated as admins). */
  setTeamSelfManaged: Scalars['Boolean'];
  /** Grant or revoke team admin privileges for a user. */
  setUserAsTeamAdmin: Scalars['Boolean'];
  /** Admin only - Change a user's email address directly without verification. */
  setUserEmail: Scalars['Boolean'];
  /** Update the name and description of a user team. */
  setUserTeamNameAndDescription: Scalars['Boolean'];
  /** Compact a project's event stream into a snapshot. System admin only. */
  snapshotProject: Scalars['Boolean'];
  /** Create a snapshot of the mediacenter folder tree for backup/versioning purposes. */
  snapshotTree: Scalars['Boolean'];
  /** Mark project artworks as started/in progress. */
  startArtworks: Scalars['Boolean'];
  startChatSession: Scalars['UUID'];
  /**
   * System admin only - Start a CWAY-managed trial on an organisation (no Stripe subscription).
   * trialEnd is epoch millis. The configured trial display product is snapshotted onto the
   * subscription automatically (name/description/features for the frontend).
   */
  startOrganisationTrial: Scalars['Boolean'];
  /**
   * Start Stripe Checkout for a set of module products (+ seats). Returns the checkout URL; the
   * subscription arrives on the organisation through the webhook (refetch on ?payment.success).
   */
  startSubscriptionCheckout: Scalars['String'];
  /**
   * Legacy single-product checkout. Returns a URL to Stripe checkout.
   * @deprecated Legacy single-product checkout; use startSubscriptionCheckout(items).
   */
  startSubscriptionPaymentFlow: Scalars['String'];
  /** System admin only - End an active CWAY-managed trial immediately. */
  stopOrganisationTrial: Scalars['Boolean'];
  /**
   * Deprecated: superseded by synchronizeArtworksWithMediaCenter, and eligible artworks now auto-sync on change.
   * @deprecated Use synchronizeArtworksWithMediaCenter; project artworks now auto-sync to the media center on change.
   */
  synchronizeArtworkWithMediaCenter: Scalars['Boolean'];
  /**
   * Synchronize multiple project artworks with their linked mediacenter artworks, updating content and metadata.
   * Deprecated: eligible project artworks now auto-sync to the media center shortly after they change
   * (see ArtworkMediaCenterSyncDaemon). Retained as a manual fallback; no longer required in normal flows.
   * @deprecated Project artworks now auto-sync to the media center on change; manual triggering is no longer required.
   */
  synchronizeArtworksWithMediaCenter: Scalars['Boolean'];
  /**
   * Hand account ownership to another member. Immediate. Current account owner only, or a system
   * admin with an explicit organisationId (defaults to the selected organisation).
   */
  transferAccountOwnership: Scalars['Boolean'];
  /** Restore archived artwork categories. */
  unArchiveArtworkCategories: Scalars['Boolean'];
  /** Restore a mediacenter item from obsolete status. */
  unObsoleteFolderItem: Scalars['Boolean'];
  /** Restore an archived project status, making it selectable again. */
  unarchiveProjectStatus: Scalars['Boolean'];
  /** Remove an attribute set from a product category. */
  unassignSetFromCategory: Scalars['Boolean'];
  /** Unlink a CWAY project from its linked Blikk project. */
  unlinkProjectFromBlikk: Scalars['Boolean'];
  /** System admin only - Update all HubSpot contacts' lifecycle stage to customer. */
  updateAllHubSpotContactsToCustomer: Scalars['Boolean'];
  /** Update an existing article. */
  updateArticle: Scalars['Boolean'];
  updateAssetTag: Scalars['Boolean'];
  /** Update a brand's name. */
  updateBrand: Scalars['Boolean'];
  /** Admin only - Rename and re-describe a custom role. */
  updateCustomRole: Scalars['Boolean'];
  /** System admin only - Update a HubSpot contact's lifecycle stage to customer. */
  updateHubSpotContactToCustomer: Scalars['Boolean'];
  /** Update the content of an existing note on a project. */
  updateNoteOnProject: Scalars['Boolean'];
  /** Admin only - Update organisation name and description. */
  updateOrganisationBaseInformation: Scalars['Boolean'];
  /** System admin only - Move the end date of an active CWAY-managed trial (extend or shorten). trialEnd is epoch millis. */
  updateOrganisationTrial: Scalars['Boolean'];
  /**
   * Get a Stripe Checkout URL where the customer replaces the card their subscription is paid
   * with. The checkout is opened for the Stripe customer the subscription is billed to - which
   * need not be the caller - and the saved card becomes that subscription's payment method when
   * the session completes. Also serves a past-due subscription, whose card is the one most
   * likely to need replacing.
   */
  updatePaymentMethod: Scalars['String'];
  /** Update an existing print specification with new packaging, print, decor, or instruction details. */
  updatePrintSpecification: Scalars['Boolean'];
  /** @deprecated Use updateProducts instead */
  updateProduct: Scalars['Boolean'];
  /** Update an existing product attribute definition. */
  updateProductAttribute: Scalars['Boolean'];
  /** Update an existing product stage. */
  updateProductStage: Scalars['Boolean'];
  /** Update one or more products with new information. Null values are not changed except brandId (null removes it). Markets are managed via setProductMarkets. */
  updateProducts: Scalars['Boolean'];
  /** Update or set the notes field on a project (internal notes visible to project team). */
  updateProjectNotes: Scalars['Boolean'];
  /** Update an existing SSO domain configuration (organisation owner). */
  updateSsoDomain: Scalars['Boolean'];
  /**
   * Reconcile the module items on the active subscription (add/remove modules, change tiers). Prorated.
   * Omitting an item removes it, except for seats, non-module lines (e.g. support plans) and
   * sales-negotiated prices, which only a system admin can remove.
   * organisationId is system-admin only (cway-admin acting on a customer); omitted = caller's organisation.
   */
  updateSubscriptionItems: Scalars['Boolean'];
  /** Update team configuration (approval mode and members) for multiple artworks at once. */
  updateTeamForArtworks: Scalars['Boolean'];
  /** Update the current user's account information including address, phone, and work details. */
  updateUserAccountInfo: Scalars['Boolean'];
  /** Admin only - Update another user's account information including name, address, phone, and work details. */
  updateUserAccountInfoForUser: Scalars['Boolean'];
  /** Update an existing webhook configuration. */
  updateWebhook: Scalars['Boolean'];
  /** Restore a previously invalidated correction, making it visible again. */
  validateCorrection: Scalars['Boolean'];
  /** Restore a previously invalidated comment on a mediacenter artwork. */
  validateMediaCenterArtworkComment: Scalars['Boolean'];
};


export type MutationAcceptSubscriptionOfferArgs = {
  billing?: InputMaybe<BillingDetailsInput>;
  offerId: Scalars['UUID'];
};


export type MutationActivateOrganisationsArgs = {
  organisationIds: Array<Scalars['UUID']>;
};


export type MutationAddApiKeyArgs = {
  description: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['Long']>;
  roleId?: InputMaybe<Scalars['UUID']>;
  scopes?: InputMaybe<Array<ApiTokenScope>>;
  token: Scalars['String'];
};


export type MutationAddArticleToMcArtworkArgs = {
  articleId: Scalars['UUID'];
  artworkId: Scalars['UUID'];
};


export type MutationAddArtworkActionsArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  taskActionType: TaskActionType;
};


export type MutationAddArtworkFilesArgs = {
  artworkId: Scalars['UUID'];
  files?: InputMaybe<Array<InputMaybe<FileWithTypeInput>>>;
  projectId: Scalars['UUID'];
  setBundledState?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddArtworkRuleArgs = {
  artworkId: Scalars['UUID'];
  rule: Scalars['String'];
};


export type MutationAddArtworkToFolderArgs = {
  artworkId: Scalars['UUID'];
  folderId: Scalars['UUID'];
};


export type MutationAddCorrectionArgs = {
  input: AddCorrectionInput;
};


export type MutationAddFileToFolderArgs = {
  fileId: Scalars['UUID'];
  folderId: Scalars['UUID'];
  folderItemId?: InputMaybe<Scalars['UUID']>;
};


export type MutationAddFilesToProductArgs = {
  input: AddFilesToProductInput;
};


export type MutationAddFilesToProjectArgs = {
  files: Array<Scalars['UUID']>;
  path?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
};


export type MutationAddNoteToProjectArgs = {
  content?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
  title: Scalars['String'];
};


export type MutationAddRelationshipsToProductArgs = {
  input: AddRelationshipsToProductInput;
};


export type MutationAddSsoDomainArgs = {
  input: AddSsoDomainInput;
};


export type MutationAddTagsToMediaCenterArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  tagIds: Array<Scalars['UUID']>;
};


export type MutationAddTagsToMetaFilesArgs = {
  fileIds: Array<Scalars['UUID']>;
  tagIds: Array<Scalars['UUID']>;
};


export type MutationAddTagsToProjectArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  tagIds: Array<Scalars['UUID']>;
};


export type MutationAddTeamAssignmentToArtworkArgs = {
  artworkId: Scalars['UUID'];
  assignmentType: TeamAssignmentType;
  teamId: Scalars['UUID'];
};


export type MutationAddUserApiTokenArgs = {
  description: Scalars['String'];
  token: Scalars['String'];
};


export type MutationAddUserToArtworkArgs = {
  input?: InputMaybe<AssignUserToArtworkInput>;
};


export type MutationAddUserToArtworkTeamArgs = {
  artworkId: Scalars['UUID'];
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationAddUserToFolderArgs = {
  folderId: Scalars['UUID'];
  permissions?: InputMaybe<FolderPermissionInput>;
  userId: Scalars['UUID'];
};


export type MutationAddUsersToOrganisationArgs = {
  organisationId: Scalars['UUID'];
  users: Array<OrganisationUserInput>;
};


export type MutationAddUsersToTeamArgs = {
  teamId: Scalars['UUID'];
  users: Array<TeamUserInput>;
};


export type MutationApplySubscriptionOfferArgs = {
  billing?: InputMaybe<BillingDetailsInput>;
  offerId: Scalars['UUID'];
};


export type MutationApproveArtworkArgs = {
  artworkId: Scalars['UUID'];
};


export type MutationApproveArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationArchiveArtworkCategoriesArgs = {
  categoryIds: Array<Scalars['UUID']>;
};


export type MutationArchiveProjectStatusArgs = {
  statusId: Scalars['UUID'];
};


export type MutationAssignApproverToArtworkArgs = {
  input?: InputMaybe<AssignUserToArtworkInput>;
};


export type MutationAssignReceiverToArtworkArgs = {
  input?: InputMaybe<AssignUserToArtworkInput>;
};


export type MutationAssignSeatArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  seatType?: SeatType;
  userId: Scalars['UUID'];
};


export type MutationAssignSetToCategoryArgs = {
  categoryId: Scalars['UUID'];
  setId: Scalars['UUID'];
};


export type MutationAssignSupplierToArtworkArgs = {
  input?: InputMaybe<AssignUserToArtworkInput>;
};


export type MutationAssignUsersToArtworksArgs = {
  input: UserAssignmentsInput;
};


export type MutationAttachTeamToArtworkArgs = {
  artworkId: Scalars['UUID'];
  assignments: Array<TeamAssignmentType>;
  teamId: Scalars['UUID'];
};


export type MutationAttachTeamToArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  assignments: Array<TeamAssignmentType>;
  projectId: Scalars['UUID'];
  teamId: Scalars['UUID'];
};


export type MutationBundleArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationCancelArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationCancelSubscriptionArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};


export type MutationCancelSubscriptionImmediatelyArgs = {
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};


export type MutationChangeArtworkFileTypesArgs = {
  artworkId: Scalars['UUID'];
  files?: InputMaybe<Array<InputMaybe<FileWithTypeInput>>>;
  projectId: Scalars['UUID'];
};


export type MutationChangeArtworkNameArgs = {
  artworkId: Scalars['UUID'];
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};


export type MutationChangeArtworkRuleArgs = {
  artworkId: Scalars['UUID'];
  rule: Scalars['String'];
  ruleId: Scalars['UUID'];
};


export type MutationChangeArtworkTeamApprovalModeArgs = {
  approvalMode: ApprovalMode;
  artworkId: Scalars['UUID'];
  teamId: Scalars['UUID'];
};


export type MutationChangeBasicProjectDataArgs = {
  input?: InputMaybe<BasicProjectDataInput>;
};


export type MutationChangeCategoryOfArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  categoryId: Scalars['UUID'];
  projectId: Scalars['UUID'];
};


export type MutationChangeFolderItemNameArgs = {
  folderItemId: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationChangeFolderUserPermissionArgs = {
  folderId: Scalars['UUID'];
  permissions: FolderPermissionInput;
  userId: Scalars['UUID'];
};


export type MutationChangeMcArtworkCategoryArgs = {
  artworkId: Scalars['UUID'];
  categoryId: Scalars['UUID'];
};


export type MutationChangeMcArtworkPreviewFileArgs = {
  artworkId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};


export type MutationChangeNameAndDescriptionOfCategoryArgs = {
  categoryId: Scalars['UUID'];
  description: Scalars['String'];
  name: Scalars['String'];
};


export type MutationChangeOrdererArgs = {
  ordererId: Scalars['UUID'];
  projectId: Scalars['UUID'];
};


export type MutationChangeOwnEmailArgs = {
  newEmail: Scalars['String'];
};


export type MutationChangeOwnPasswordArgs = {
  oldPassword: Scalars['String'];
  password: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationChangeProjectStatusArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['UUID'];
  statusId: Scalars['UUID'];
};


export type MutationChangeSubscriptionArgs = {
  productId: Scalars['String'];
};


export type MutationChangeUserTeamApprovalModeArgs = {
  approvalMode: ApprovalMode;
  teamId: Scalars['UUID'];
};


export type MutationCheckinArtworkArgs = {
  input?: InputMaybe<CheckinArtworkInput>;
};


export type MutationCheckoutArtworkArgs = {
  artworkId: Scalars['UUID'];
};


export type MutationCloseProjectsArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  projectIds: Array<Scalars['UUID']>;
};


export type MutationCommentMediaCenterArtworkArgs = {
  input: ArtworkCommentInput;
};


export type MutationCommentMediaCenterArtworksArgs = {
  comments: Array<ArtworkCommentInput>;
};


export type MutationCompleteSsoDomainVerificationArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type MutationConfigureBlikkIntegrationArgs = {
  input: ConfigureBlikkIntegrationInput;
};


export type MutationConvertApiKeyToServiceAccountArgs = {
  keyId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};


export type MutationConvertFileIntoMediaCenterArtworkArgs = {
  input?: InputMaybe<ConvertFileToArtworkInput>;
};


export type MutationCopyFolderArgs = {
  sourceFolderId: Scalars['UUID'];
  targetFolderId: Scalars['UUID'];
};


export type MutationCopyFolderItemsArgs = {
  folderItems: Array<Scalars['UUID']>;
  sourceFolderId: Scalars['UUID'];
  targetFolderId: Scalars['UUID'];
};


export type MutationCreateAgentUserArgs = {
  name: Scalars['String'];
};


export type MutationCreateAnonymousShareArgs = {
  input: CreateAnonymousShareInput;
};


export type MutationCreateArticleArgs = {
  input: CreateArticleInput;
};


export type MutationCreateArtworkArgs = {
  input: CreateArtworkInput;
};


export type MutationCreateArtworkCategoryArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationCreateArtworksFromFilesArgs = {
  files: Array<ArtworkFromFile>;
  projectId: Scalars['UUID'];
};


export type MutationCreateArtworksFromMediaCenterArtworksArgs = {
  mediaCenterArtworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationCreateArtworksFromProjectArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationCreateAssetTagArgs = {
  color: AssetTagColor;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};


export type MutationCreateAttributeSetArgs = {
  name: Scalars['String'];
  scope: Scalars['String'];
};


export type MutationCreateBrandArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};


export type MutationCreateBriefFromFileArgs = {
  artworkId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};


export type MutationCreateCollaborationForArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  email: Scalars['String'];
  secured: Scalars['Boolean'];
};


export type MutationCreateCustomRoleArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  permissionIds: Array<Scalars['String']>;
};


export type MutationCreateCustomerOrganisationArgs = {
  input: CreateCustomerOrganisationInput;
};


export type MutationCreateDownloadJobArgs = {
  forceZipFile?: InputMaybe<Scalars['Boolean']>;
  selections: Array<DownloadFileDescriptorInput>;
  zipName?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFileDownloadJobArgs = {
  fileId: Scalars['UUID'];
  fileName?: InputMaybe<Scalars['String']>;
  forceZipFile?: InputMaybe<Scalars['Boolean']>;
  zipName?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFolderArgs = {
  input: AddFolderInput;
};


export type MutationCreateHubSpotContactIfMissingArgs = {
  username: Scalars['String'];
};


export type MutationCreateMarketArgs = {
  name: Scalars['String'];
};


export type MutationCreatePrintSpecificationArgs = {
  name: Scalars['String'];
};


export type MutationCreateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationCreateProductAttributeArgs = {
  input: CreateProductAttributeInput;
};


export type MutationCreateProductCategoryArgs = {
  name: Scalars['String'];
  parent?: InputMaybe<Scalars['UUID']>;
};


export type MutationCreateProductStageArgs = {
  input: CreateProductStageInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectStatusArgs = {
  input: CreateProjectStatusInput;
};


export type MutationCreateRootFolderArgs = {
  name: Scalars['String'];
};


export type MutationCreateShareArgs = {
  input: CreateShareInput;
};


export type MutationCreateSubscriptionOfferArgs = {
  input: CreateSubscriptionOfferInput;
  organisationId: Scalars['UUID'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateUserTeamArgs = {
  approvalMode?: InputMaybe<ApprovalMode>;
  description: Scalars['String'];
  name: Scalars['String'];
  teamId?: InputMaybe<Scalars['UUID']>;
};


export type MutationCreateUsersFromEmailStringArgs = {
  emails: Array<Scalars['String']>;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationDeactivateOrganisationsArgs = {
  organisationIds: Array<Scalars['UUID']>;
};


export type MutationDeclineSeatRequestArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['String']>;
  requestId: Scalars['UUID'];
};


export type MutationDeleteArticleArgs = {
  articleId: Scalars['UUID'];
};


export type MutationDeleteArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationDeleteAssetTagArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteAttributeSetArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteBarcodeArgs = {
  barcodeId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};


export type MutationDeleteCustomRoleArgs = {
  roleId: Scalars['UUID'];
};


export type MutationDeleteFolderArgs = {
  folderId: Scalars['UUID'];
};


export type MutationDeleteMarketArgs = {
  id: Scalars['UUID'];
};


export type MutationDeletePrintSpecificationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProductAttributeArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProductCategoryArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProductStageArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProductsArgs = {
  ids: Array<Scalars['UUID']>;
};


export type MutationDeleteProjectStatusArgs = {
  statusId: Scalars['UUID'];
};


export type MutationDeleteProjectsArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  projectIds: Array<Scalars['UUID']>;
};


export type MutationDeleteUserTeamArgs = {
  teamId: Scalars['UUID'];
};


export type MutationDeleteUserTeamsArgs = {
  teamIds: Array<Scalars['UUID']>;
};


export type MutationDeleteUsersArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  usernames: Array<Scalars['String']>;
};


export type MutationDeliverArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
};


export type MutationDeliverProjectArgs = {
  projectId: Scalars['UUID'];
};


export type MutationDiscardArtworkCheckoutArgs = {
  artworkId: Scalars['UUID'];
};


export type MutationDismissSpellingErrorArgs = {
  blockId: Scalars['Int'];
  fileId: Scalars['UUID'];
  page: Scalars['Int'];
  word: Scalars['String'];
};


export type MutationEndChatSessionArgs = {
  sessionId: Scalars['UUID'];
};


export type MutationExportProjectToFileArgs = {
  projectId: Scalars['UUID'];
};


export type MutationFindOrCreateAssetTagArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};


export type MutationFinishArtworkActionsArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  taskActionType: TaskActionType;
};


export type MutationGrantSeatRequestArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  requestId: Scalars['UUID'];
};


export type MutationInValidateMediaCenterArtworkCommentArgs = {
  artworkId: Scalars['UUID'];
  commentId: Scalars['UUID'];
};


export type MutationInitiateSsoDomainVerificationArgs = {
  input: AddSsoDomainInput;
};


export type MutationInvalidateCorrectionArgs = {
  artworkId: Scalars['UUID'];
  correctionId: Scalars['UUID'];
};


export type MutationInviteUsersArgs = {
  input: InviteUsersInput;
};


export type MutationLaunchProjectsArgs = {
  projectIds: Array<Scalars['UUID']>;
};


export type MutationLinkProjectToBlikkArgs = {
  blikkCustomerId?: InputMaybe<Scalars['String']>;
  blikkProjectId: Scalars['String'];
  blikkProjectPrefix?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
};


export type MutationMarkShareAsReadArgs = {
  shareId: Scalars['UUID'];
};


export type MutationMergeAssetTagsArgs = {
  sourceId: Scalars['UUID'];
  targetId: Scalars['UUID'];
};


export type MutationModifyBarcodeArgs = {
  input: BarcodeInput;
};


export type MutationMoveFolderArgs = {
  before?: InputMaybe<Scalars['Boolean']>;
  child?: InputMaybe<Scalars['Boolean']>;
  sourceFolderId: Scalars['UUID'];
  targetFolderId: Scalars['UUID'];
};


export type MutationMoveFolderItemsArgs = {
  folderItems: Array<Scalars['UUID']>;
  sourceFolderId: Scalars['UUID'];
  targetFolderId: Scalars['UUID'];
};


export type MutationMoveProductCategoryArgs = {
  id: Scalars['UUID'];
  parent?: InputMaybe<Scalars['UUID']>;
};


export type MutationMoveProjectFilesArgs = {
  files: Array<Scalars['UUID']>;
  path?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
};


export type MutationNewRevisionFromFileArgs = {
  artworkId: Scalars['UUID'];
  comment?: InputMaybe<Scalars['String']>;
  fileId: Scalars['UUID'];
};


export type MutationObsoleteFolderItemArgs = {
  folderId: Scalars['UUID'];
  folderItemId: Scalars['UUID'];
};


export type MutationReExtractTextArgs = {
  artworkId: Scalars['UUID'];
};


export type MutationReRenderColorSeparationArgs = {
  fileId?: InputMaybe<Scalars['UUID']>;
};


export type MutationReRenderFileArgs = {
  fileId?: InputMaybe<Scalars['UUID']>;
};


export type MutationReindexShareArgs = {
  shareId: Scalars['UUID'];
};


export type MutationRejectAndChangeDeliveredArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRejectArtworkArgs = {
  input?: InputMaybe<RejectArtworkInput>;
};


export type MutationRejectArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRemindApproverArgs = {
  input?: InputMaybe<RemindApproverInput>;
};


export type MutationRemoveAllAssignmentsForUserFromArtworkArgs = {
  input?: InputMaybe<RemoveUserFromArtworkInput>;
};


export type MutationRemoveAllAssignmentsFromArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRemoveApiKeyArgs = {
  keyId: Scalars['UUID'];
};


export type MutationRemoveApproverFromArtworkArgs = {
  input?: InputMaybe<RemoveUserFromArtworkInput>;
};


export type MutationRemoveArticleFromMcArtworkArgs = {
  articleId: Scalars['UUID'];
  artworkId: Scalars['UUID'];
};


export type MutationRemoveArtworkActionsArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  taskActionType: TaskActionType;
};


export type MutationRemoveArtworkFilesArgs = {
  artworks: Array<ArtworkFilesInput>;
  projectId: Scalars['UUID'];
};


export type MutationRemoveArtworkRuleArgs = {
  artworkId: Scalars['UUID'];
  ruleId: Scalars['UUID'];
};


export type MutationRemoveCollaborationForArtworksArgs = {
  artworkId: Scalars['UUID'];
  collaborationId: Scalars['UUID'];
};


export type MutationRemoveEventsFromTreeArgs = {
  eventsToRemove: Array<Scalars['UUID']>;
  treeId: Scalars['UUID'];
};


export type MutationRemoveFilesFromProductArgs = {
  input: RemoveFilesFromProductInput;
};


export type MutationRemoveFilesFromProjectArgs = {
  files: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRemoveFolderItemArgs = {
  folderId: Scalars['UUID'];
  folderItemId: Scalars['UUID'];
};


export type MutationRemoveNoteFromProjectArgs = {
  projectId: Scalars['UUID'];
  title: Scalars['String'];
};


export type MutationRemoveOrphanedSubscriptionArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  subscriptionId: Scalars['String'];
};


export type MutationRemoveReceiverFromArtworkArgs = {
  input?: InputMaybe<RemoveUserFromArtworkInput>;
};


export type MutationRemoveRelationshipsFromProductArgs = {
  input: RemoveRelationshipsFromProductInput;
};


export type MutationRemoveSharesArgs = {
  shareIds: Array<Scalars['UUID']>;
};


export type MutationRemoveSsoDomainArgs = {
  domain: Scalars['String'];
};


export type MutationRemoveSubApprovalForUserArgs = {
  input?: InputMaybe<RemoveSubApprovalFromArtworkInput>;
};


export type MutationRemoveSupplierFromArtworkArgs = {
  input?: InputMaybe<RemoveUserFromArtworkInput>;
};


export type MutationRemoveTagsFromMediaCenterArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  tagIds: Array<Scalars['UUID']>;
};


export type MutationRemoveTagsFromMetaFilesArgs = {
  fileIds: Array<Scalars['UUID']>;
  tagIds: Array<Scalars['UUID']>;
};


export type MutationRemoveTagsFromProjectArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  tagIds: Array<Scalars['UUID']>;
};


export type MutationRemoveTeamAssignmentFromArtworkArgs = {
  artworkId: Scalars['UUID'];
  assignmentType: TeamAssignmentType;
  teamId: Scalars['UUID'];
};


export type MutationRemoveTeamFromArtworkArgs = {
  artworkId: Scalars['UUID'];
  teamId: Scalars['UUID'];
};


export type MutationRemoveUserApiTokenArgs = {
  tokenId: Scalars['UUID'];
};


export type MutationRemoveUserFromArtworkTeamArgs = {
  artworkId: Scalars['UUID'];
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationRemoveUserFromFolderArgs = {
  folderId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationRemoveUsersFromTeamArgs = {
  teamId: Scalars['UUID'];
  userIds: Array<Scalars['UUID']>;
};


export type MutationRemoveWebhookArgs = {
  webhookId: Scalars['UUID'];
};


export type MutationRenameAttributeSetArgs = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationRenameDuplicateUserArgs = {
  newEmail: Scalars['String'];
  userId: Scalars['UUID'];
};


export type MutationRenameFolderArgs = {
  folderId: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationRenameMarketArgs = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationRenameNoteOnProjectArgs = {
  newTitle: Scalars['String'];
  oldTitle: Scalars['String'];
  projectId: Scalars['UUID'];
};


export type MutationRenameProductCategoryArgs = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationRenameProjectStatusArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  statusId: Scalars['UUID'];
};


export type MutationReopenProjectsArgs = {
  projectIds: Array<Scalars['UUID']>;
};


export type MutationReorderAttributeSetsArgs = {
  ids: Array<Scalars['UUID']>;
};


export type MutationReorderAttributesArgs = {
  ids: Array<Scalars['UUID']>;
  setId: Scalars['UUID'];
};


export type MutationReorderMarketsArgs = {
  ids: Array<Scalars['UUID']>;
};


export type MutationReorderProductStagesArgs = {
  ids: Array<Scalars['UUID']>;
};


export type MutationReplacePreviewFileArgs = {
  artworkId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};


export type MutationRequestSeatArgs = {
  message?: InputMaybe<Scalars['String']>;
  seatType?: SeatType;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type MutationRequestUpdateForPrintSpecificationArgs = {
  id: Scalars['UUID'];
  sendToEmail?: InputMaybe<Scalars['String']>;
};


export type MutationResetArtworkActionsArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  taskActionType: TaskActionType;
};


export type MutationResetLayoutConfigArgs = {
  key?: InputMaybe<Scalars['String']>;
  keyPrefix?: InputMaybe<Scalars['String']>;
  scope: LayoutScope;
  type: Scalars['String'];
};


export type MutationRevertProjectEventsArgs = {
  eventIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRevokeArtworkApprovalArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRevokeArtworkApprovalOrRejectionArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRevokeArtworkRejectionArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRevokeBundlingOfArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRevokeDeliveryOfArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationRevokeSeatArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  seatType?: SeatType;
  userId: Scalars['UUID'];
};


export type MutationRevokeSubscriptionOfferArgs = {
  offerId: Scalars['UUID'];
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationRollBackProjectHistoryArgs = {
  lastEventToKeep: Scalars['UUID'];
  projectId: Scalars['UUID'];
};


export type MutationRollbackTreeArgs = {
  lastEventToKeep: Scalars['UUID'];
  treeId: Scalars['UUID'];
};


export type MutationSaveMcArtworkPrintCoverageArgs = {
  artworkId: Scalars['UUID'];
  colorArea?: InputMaybe<Scalars['BigDecimal']>;
  colorCanvas: Scalars['UUID'];
  printArea?: InputMaybe<Scalars['BigDecimal']>;
  printCanvas: Scalars['UUID'];
  targetPercentage?: InputMaybe<Scalars['Int']>;
};


export type MutationSavePrintCoverageArgs = {
  artworkId: Scalars['UUID'];
  colorArea?: InputMaybe<Scalars['BigDecimal']>;
  colorCanvas: Scalars['UUID'];
  printArea?: InputMaybe<Scalars['BigDecimal']>;
  printCanvas: Scalars['UUID'];
  targetPercentage?: InputMaybe<Scalars['Int']>;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSetAgentInstructionsArgs = {
  instructions?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};


export type MutationSetArticleAttributeValueArgs = {
  articleId: Scalars['UUID'];
  attributeKey: Scalars['String'];
  locale: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationSetArticleIndicatorDigitArgs = {
  articleId: Scalars['UUID'];
  indicatorDigit?: InputMaybe<Scalars['Int']>;
};


export type MutationSetArticlePackParentArgs = {
  articleId: Scalars['UUID'];
  parentPackArticleId?: InputMaybe<Scalars['UUID']>;
  quantityInParent?: InputMaybe<Scalars['Int']>;
};


export type MutationSetArticleQuantityInParentArgs = {
  articleId: Scalars['UUID'];
  quantityInParent: Scalars['Int'];
};


export type MutationSetArtworkCategoryAsDefaultArgs = {
  categoryId: Scalars['UUID'];
};


export type MutationSetArtworksSilentArgs = {
  artworkIds: Array<Scalars['UUID']>;
  silent: Scalars['Boolean'];
};


export type MutationSetAvatarArgs = {
  fileId: Scalars['UUID'];
};


export type MutationSetCommunicationSettingsArgs = {
  input: CommunicationSettingsInput;
};


export type MutationSetCustomRolePermissionsArgs = {
  permissionIds: Array<Scalars['String']>;
  roleId: Scalars['UUID'];
};


export type MutationSetDatesOnArtworksArgs = {
  artworkId: Array<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  projectId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationSetDatesOnProjectArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationSetDesktopThemeArgs = {
  input?: InputMaybe<DesktopThemeInput>;
};


export type MutationSetEarlyAccessArgs = {
  earlyAccess: Scalars['Boolean'];
  userId: Scalars['UUID'];
};


export type MutationSetFtpPasswordArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationSetInvoiceNumberArgs = {
  artworkId: Scalars['UUID'];
  invoiceNumber: Scalars['String'];
  projectId: Scalars['UUID'];
};


export type MutationSetLayoutConfigArgs = {
  data: Scalars['JSON'];
  key: Scalars['String'];
  scope: LayoutScope;
  type: Scalars['String'];
};


export type MutationSetLightboxEverywhereArgs = {
  lightboxEverywhere: Scalars['Boolean'];
  userId: Scalars['UUID'];
};


export type MutationSetMcArtworkFilesArgs = {
  artworkId: Scalars['UUID'];
  files?: InputMaybe<Array<InputMaybe<FileWithTypeInput>>>;
};


export type MutationSetMarketLocalesArgs = {
  id: Scalars['UUID'];
  locales: Array<Scalars['String']>;
};


export type MutationSetMarketSettingsArgs = {
  input: MarketSettingsInput;
};


export type MutationSetMediaCenterArtworkTagsArgs = {
  artworkId: Scalars['UUID'];
  tagIds: Array<Scalars['UUID']>;
};


export type MutationSetMediaCenterArtworksDraftArgs = {
  artworkIds: Array<Scalars['UUID']>;
  draft: Scalars['Boolean'];
};


export type MutationSetMetaFileTagsArgs = {
  fileId: Scalars['UUID'];
  tagIds: Array<Scalars['UUID']>;
};


export type MutationSetOrganisationLogoArgs = {
  fileId: Scalars['UUID'];
  organisationId: Scalars['UUID'];
};


export type MutationSetOwnUserRealNameArgs = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};


export type MutationSetPermissionGroupForUsersArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  permissionGroupId: Scalars['UUID'];
  usernames: Array<Scalars['String']>;
};


export type MutationSetProductAttributeValueArgs = {
  attributeKey: Scalars['String'];
  locale: Scalars['String'];
  productId: Scalars['UUID'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationSetProductBrandArgs = {
  products: Array<SetProductBrandInput>;
};


export type MutationSetProductCategoriesArgs = {
  products: Array<SetProductCategoriesInput>;
};


export type MutationSetProductMarketsArgs = {
  products: Array<SetProductMarketsInput>;
};


export type MutationSetProductStageArgs = {
  productId: Scalars['UUID'];
  stageId: Scalars['UUID'];
};


export type MutationSetProjectArtworkFilesArgs = {
  artworkId: Scalars['UUID'];
  files?: InputMaybe<Array<InputMaybe<FileWithTypeInput>>>;
  projectId: Scalars['UUID'];
  setBundledState?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetProjectArtworkTagsArgs = {
  artworkId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  tagIds: Array<Scalars['UUID']>;
};


export type MutationSetProjectManagerArgs = {
  projectId: Scalars['UUID'];
  projectManagerId: Scalars['UUID'];
};


export type MutationSetProjectStatusAsDefaultArgs = {
  statusId: Scalars['UUID'];
};


export type MutationSetProjectsSilentArgs = {
  projectIds: Array<Scalars['UUID']>;
  silent: Scalars['Boolean'];
};


export type MutationSetSubscriptionSeatsArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  quantity: Scalars['Long'];
};


export type MutationSetSystemAdminArgs = {
  admin: Scalars['Boolean'];
  userId: Scalars['UUID'];
};


export type MutationSetTeamSelfManagedArgs = {
  selfManaged: Scalars['Boolean'];
  teamId: Scalars['UUID'];
};


export type MutationSetUserAsTeamAdminArgs = {
  admin: Scalars['Boolean'];
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationSetUserEmailArgs = {
  newEmail: Scalars['String'];
  oldEmail: Scalars['String'];
};


export type MutationSetUserTeamNameAndDescriptionArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['UUID'];
};


export type MutationSnapshotProjectArgs = {
  projectId: Scalars['UUID'];
};


export type MutationSnapshotTreeArgs = {
  treeId: Scalars['UUID'];
};


export type MutationStartArtworksArgs = {
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
};


export type MutationStartChatSessionArgs = {
  input: StartChatSessionInput;
};


export type MutationStartOrganisationTrialArgs = {
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
  trialEnd: Scalars['Long'];
};


export type MutationStartSubscriptionCheckoutArgs = {
  items: Array<SubscriptionItemInput>;
};


export type MutationStartSubscriptionPaymentFlowArgs = {
  productId: Scalars['String'];
};


export type MutationStopOrganisationTrialArgs = {
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationSynchronizeArtworkWithMediaCenterArgs = {
  artworkId: Scalars['UUID'];
};


export type MutationSynchronizeArtworksWithMediaCenterArgs = {
  artworkIds: Array<Scalars['UUID']>;
};


export type MutationTransferAccountOwnershipArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};


export type MutationUnArchiveArtworkCategoriesArgs = {
  categoryIds: Array<Scalars['UUID']>;
};


export type MutationUnObsoleteFolderItemArgs = {
  folderId: Scalars['UUID'];
  folderItemId: Scalars['UUID'];
};


export type MutationUnarchiveProjectStatusArgs = {
  statusId: Scalars['UUID'];
};


export type MutationUnassignSetFromCategoryArgs = {
  categoryId: Scalars['UUID'];
  setId: Scalars['UUID'];
};


export type MutationUnlinkProjectFromBlikkArgs = {
  projectId: Scalars['UUID'];
};


export type MutationUpdateArticleArgs = {
  input: UpdateArticleInput;
};


export type MutationUpdateAssetTagArgs = {
  color?: InputMaybe<AssetTagColor>;
  description?: InputMaybe<Scalars['String']>;
  descriptionCleared?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<Scalars['String']>;
  iconCleared?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationUpdateCustomRoleArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  roleId: Scalars['UUID'];
};


export type MutationUpdateHubSpotContactToCustomerArgs = {
  username: Scalars['String'];
};


export type MutationUpdateNoteOnProjectArgs = {
  content: Scalars['String'];
  projectId: Scalars['UUID'];
  title: Scalars['String'];
};


export type MutationUpdateOrganisationBaseInformationArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organisationId: Scalars['UUID'];
};


export type MutationUpdateOrganisationTrialArgs = {
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
  trialEnd: Scalars['Long'];
};


export type MutationUpdatePrintSpecificationArgs = {
  input: UpdatePrintSpecificationInput;
};


export type MutationUpdateProductArgs = {
  articleNo?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['UUID']>;
  categories?: InputMaybe<Array<Scalars['UUID']>>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProductAttributeArgs = {
  input: UpdateProductAttributeInput;
};


export type MutationUpdateProductStageArgs = {
  input: UpdateProductStageInput;
};


export type MutationUpdateProductsArgs = {
  products: Array<UpdateProductInput>;
};


export type MutationUpdateProjectNotesArgs = {
  notes: Scalars['String'];
  projectId: Scalars['UUID'];
};


export type MutationUpdateSsoDomainArgs = {
  input: UpdateSsoDomainInput;
};


export type MutationUpdateSubscriptionItemsArgs = {
  items: Array<SubscriptionItemInput>;
  organisationId?: InputMaybe<Scalars['UUID']>;
};


export type MutationUpdateTeamForArtworksArgs = {
  approvalMode: ApprovalMode;
  artworkIds: Array<Scalars['UUID']>;
  projectId: Scalars['UUID'];
  sourceTeamId: Scalars['UUID'];
  userIds: Array<Scalars['UUID']>;
};


export type MutationUpdateUserAccountInfoArgs = {
  input: UserAccountInfoInput;
};


export type MutationUpdateUserAccountInfoForUserArgs = {
  input: UserAccountInfoInput;
  userId: Scalars['UUID'];
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationValidateCorrectionArgs = {
  artworkId: Scalars['UUID'];
  correctionId: Scalars['UUID'];
};


export type MutationValidateMediaCenterArtworkCommentArgs = {
  artworkId: Scalars['UUID'];
  commentId: Scalars['UUID'];
};

export type MyActivity = {
  __typename: 'MyActivity';
  /** The same counts split per organisation, most active first. */
  byOrganisation: Array<MyActivityOrganisation>;
  /** One entry per day that has activity, ascending. Days with none are omitted. */
  daily: Array<MyActivityDay>;
  totals: MyActivityTotals;
};

/**
 * Uploads only. Deliveries are deliberately absent: the grid reads as "what I did that day",
 * and a delivery is not something the caller did.
 */
export type MyActivityDay = {
  __typename: 'MyActivityDay';
  /**
   * That day's uploads split per organisation, most active first; ties keep the order of the
   * top-level `byOrganisation`. Take names from there - every organisation here appears in it.
   */
  byOrganisation: Array<MyActivityDayOrganisation>;
  day: Scalars['LocalDate'];
  revisionsUploaded: Scalars['Int'];
  uploadedAfterDeadline: Scalars['Int'];
  /**
   * Of that day's `revisionsUploaded`, those uploaded on or before / after the artwork's
   * deadline. Same rules as in `MyActivityTotals`: artworks with no endDate count in neither.
   */
  uploadedBeforeDeadline: Scalars['Int'];
};

export type MyActivityDayArtwork = {
  __typename: 'MyActivityDayArtwork';
  artworkId: Scalars['UUID'];
  /** The artwork's current name, not the name it had that day. Empty if it could not be read. */
  artworkName: Scalars['String'];
  revisionsUploaded: Scalars['Int'];
};

export type MyActivityDayDetail = {
  __typename: 'MyActivityDayDetail';
  /** Most active first. */
  byOrganisation: Array<MyActivityDayDetailOrganisation>;
  day: Scalars['LocalDate'];
  /** Revisions the caller uploaded that day. Uploads only, as in the `myActivity` grid. */
  revisionsUploaded: Scalars['Int'];
};

export type MyActivityDayDetailOrganisation = {
  __typename: 'MyActivityDayDetailOrganisation';
  organisationId: Scalars['UUID'];
  organisationName: Scalars['String'];
  projects: Array<MyActivityDayProject>;
  revisionsUploaded: Scalars['Int'];
};

export type MyActivityDayOrganisation = {
  __typename: 'MyActivityDayOrganisation';
  organisationId: Scalars['UUID'];
  revisionsUploaded: Scalars['Int'];
};

/**
 * Ids are for keys and colour matching, not for navigation: opening a project would mean switching
 * the client into its organisation, which this block deliberately never asks for.
 */
export type MyActivityDayProject = {
  __typename: 'MyActivityDayProject';
  artworks: Array<MyActivityDayArtwork>;
  projectId: Scalars['UUID'];
  /** The project's current name. Empty if it could not be read. */
  projectName: Scalars['String'];
  revisionsUploaded: Scalars['Int'];
};

export type MyActivityOrganisation = {
  __typename: 'MyActivityOrganisation';
  artworksDelivered: Scalars['Int'];
  /** Of `artworksDelivered`, those delivered on or before the artwork's endDate. */
  deliveredBeforeDeadline: Scalars['Int'];
  firstTimeApprovalRate?: Maybe<Scalars['Float']>;
  /**
   * As in `MyActivityTotals`, computed from this organisation's uploads alone. Few uploads make
   * these swing widely; show `revisionsUploaded` alongside. Null when nothing qualifies.
   */
  medianTurnaroundHours?: Maybe<Scalars['Float']>;
  organisationId: Scalars['UUID'];
  organisationName: Scalars['String'];
  revisionsUploaded: Scalars['Int'];
  uploadedAfterDeadline: Scalars['Int'];
  uploadedBeforeDeadline: Scalars['Int'];
};

export type MyActivityTotals = {
  __typename: 'MyActivityTotals';
  /**
   * Artworks the caller supplied - uploaded at least one revision of - that were delivered
   * inside the range. A lagging figure they do not control: it can be non-zero in a range where
   * they uploaded nothing, and vice versa. "Delivered" means dispatched to receivers, the same
   * moment `deliveredArtworksPerMonth` counts, not the receiver's download. Revoked deliveries
   * are not counted.
   */
  artworksDelivered: Scalars['Int'];
  /** Distinct artworks those revisions belong to. */
  artworksTouched: Scalars['Int'];
  /** Mean revisions the caller uploaded per artwork touched. Null when no artworks were touched. */
  averageRevisionsPerArtwork?: Maybe<Scalars['Float']>;
  /** Of `artworksDelivered`, those delivered on or before the artwork's endDate. */
  deliveredBeforeDeadline: Scalars['Int'];
  /**
   * 0-1. Share of the caller's resolved revisions that reached APPROVED with no further
   * revision ordered. Still-open revisions are in neither the numerator nor the denominator.
   * Null while none have resolved.
   */
  firstTimeApprovalRate?: Maybe<Scalars['Float']>;
  /**
   * Median hours from the upload being asked for - the artwork being created, briefed, or
   * rejected - to the caller uploading it. Revisions recovered from a compacted project stream
   * have no recorded ask and are left out of this figure; they still count everywhere else.
   * Null when nothing qualifies.
   */
  medianTurnaroundHours?: Maybe<Scalars['Float']>;
  /**
   * Revisions whose creator is the caller, created within the range. Brief revisions are not
   * counted: they are the orderer asking for work, not the supplier doing it.
   */
  revisionsUploaded: Scalars['Int'];
  /** Of `revisionsUploaded`, those uploaded after it. Artworks with no endDate count in neither. */
  uploadedAfterDeadline: Scalars['Int'];
  /**
   * Of `revisionsUploaded`, those uploaded on or before the artwork's endDate as it stood at
   * the moment of the upload. For artworks whose history predates the event store the deadline
   * was never recorded, and the artwork's current endDate is used instead.
   */
  uploadedBeforeDeadline: Scalars['Int'];
};

/**
 * A discount term on an offer: percent off the list price (100 = free), for durationMonths
 * months or (null) for as long as the subscription lives.
 */
export type OfferDiscount = {
  __typename: 'OfferDiscount';
  durationMonths?: Maybe<Scalars['Int']>;
  percentOff: Scalars['BigDecimal'];
};

export type OfferDiscountInput = {
  /** Omit for a discount that lasts as long as the subscription */
  durationMonths?: InputMaybe<Scalars['Int']>;
  /** Above 0 and at most 100 (= free) */
  percentOff: Scalars['BigDecimal'];
};

export type OnTimeDeliveriesPerMonth = {
  __typename: 'OnTimeDeliveriesPerMonth';
  late: Scalars['Int'];
  month: Scalars['Long'];
  monthValue: Scalars['Int'];
  onTime: Scalars['Int'];
  onTimePercentage: Scalars['Float'];
  total: Scalars['Int'];
  year: Scalars['Int'];
};

/** Order type describes the type of order */
export enum OrderType {
  Changes = 'CHANGES',
  NewDesign = 'NEW_DESIGN'
}

export type Organisation = {
  __typename: 'Organisation';
  /**
   * The single member accountable for the account: holds billing and seat purchasing on top of
   * their role. The creator by default; transferred with transferAccountOwnership. Null only when
   * the creator has left and no legacy owner remains (a system admin sets one).
   */
  accountOwner?: Maybe<User>;
  /** Is this an active organisation? If not it cannot be interacted with. */
  active: Scalars['Boolean'];
  activeSubscription?: Maybe<PaymentSubscription>;
  /**
   * System admin only: adoption funnel for sales follow-up on trials.
   * Nullable so a permission error on this field does not null the whole Organisation.
   */
  adoption?: Maybe<OrganisationAdoption>;
  apiKeys: Array<ApiKey>;
  archivedArtworkCategories: Array<Category>;
  /** Archived project statuses (hidden from selection but kept for historical reference). */
  archivedProjectStatuses: Array<ProjectStatus>;
  artworkCategories: Array<Category>;
  /** @deprecated Badges are replaced by user tasks as a concept: use tasksForUser with the userTaskListEvents subscription. */
  badgeCount: BadgeCount;
  blikkIntegration?: Maybe<BlikkIntegrationSettings>;
  /** @deprecated The monthly artwork cap was retired: the 2026 catalog prices seats, storage, traffic and SKUs, never artwork volume. Always returns true. */
  canAddArtwork: Scalars['Boolean'];
  canAddUser: Scalars['Boolean'];
  communicationSettings: CommunicationSettings;
  defaultCategory: Category;
  description?: Maybe<Scalars['String']>;
  desktopTheme?: Maybe<DesktopTheme>;
  /** @deprecated Folder permissions are now set via individual boolean flags (FolderPermissionInput) instead of named roles. Always returns an empty list. */
  folderRoles: Array<FolderRole>;
  id: Scalars['UUID'];
  invoices: Array<Invoice>;
  licensed: Scalars['Boolean'];
  /** @deprecated Legacy user/storage quotas were retired: always unlimited (-1). Module-priced quotas are on PaymentSubscription.entitlements. */
  limits: Limits;
  marketSettings: MarketSettings;
  /**
   * The feature modules this organisation may use. Commands and queries of modules not
   * listed here are rejected server-side. Legacy, enterprise, trialing and unsubscribed
   * organisations list every module.
   */
  modules: Array<CwayModule>;
  name: Scalars['String'];
  /** Artworks currently in the organisation, across all its projects. */
  numberOfArtworks: Scalars['Int'];
  numberOfFullUsers: Scalars['Int'];
  numberOfLimitedUsers: Scalars['Int'];
  numberOfUsers: Scalars['Int'];
  /** Customisable project statuses, grouped by category (IN_PROGRESS / CLOSED). Excludes archived. */
  projectStatuses: Array<ProjectStatus>;
  /**
   * True only when the active subscription is module pricing with LIMITED seats.
   * Legacy, Enterprise/unlimited, trials and unsubscribed organisations are false and are
   * never blocked by seat-gated features.
   */
  requiresSeats: Scalars['Boolean'];
  /**
   * The roles this organisation works with: the assignable built-in roles plus its custom
   * roles. Readable by anyone who can read the organisation (cway-admin included). Pickers
   * filter on Role.grantableByMe; assigning is still governed by setPermissionGroupForUsers.
   * A member's role (User.role) is not guaranteed to be in this list: a retired role, or one
   * above the caller, comes back with grantableByMe = false. Whether that member can be
   * changed or removed is Role.membersChangeableByMe on their role, not grantableByMe.
   */
  roles: Array<Role>;
  /** Seats held by current members; join against users to render who holds a seat */
  seatAssignments: Array<SeatAssignment>;
  /**
   * Pending "Ask for a seat" requests. Visible only to those who can act on them
   * (admins/owners and custom roles with the seats.manage permission); empty for everyone else.
   */
  seatRequests: Array<SeatRequest>;
  /**
   * Seat usage. PROJECT: null unless the active subscription is on module-based pricing.
   * LIGHTBOX: never null - Lightbox seats are only purchased (includedSeats is 0), counted
   * across every active subscription, and all zeros for an organisation that has none.
   */
  seatUsage?: Maybe<SeatUsage>;
  ssoDomains: Array<SsoDomain>;
  /**
   * The special subscription offer the customer can accept right now; null when none is open.
   * Also null for members who could not accept it: only the account owner, roles holding
   * billing.manage and system admins see the negotiated terms. Render it in the
   * product-selection dialog and accept it with acceptSubscriptionOffer.
   */
  subscriptionOffer?: Maybe<SubscriptionOffer>;
  /** System admin only: every offer ever made to the organisation, newest first (empty for everyone else). */
  subscriptionOffers: Array<SubscriptionOffer>;
  subscriptions: Array<PaymentSubscription>;
  teams: Array<UserTeam>;
  /**
   * System admin only: trial reminders sent or skipped for this organisation's CWAY trials,
   * newest first. Nullable so a permission error on this field does not null the whole Organisation.
   */
  trialReminders?: Maybe<Array<TrialReminderRecord>>;
  users: Array<User>;
  webhooks: Array<Webhook>;
};


export type OrganisationSeatUsageArgs = {
  seatType?: SeatType;
};

export type OrganisationAdoption = {
  __typename: 'OrganisationAdoption';
  /** Epoch millis of the organisation's latest tracked activity. */
  lastActivityAt?: Maybe<Scalars['Long']>;
  /** Always contains exactly one entry per AdoptionMilestoneKey. */
  milestones: Array<AdoptionMilestone>;
};

export type OrganisationMembership = {
  __typename: 'OrganisationMembership';
  /** True when this member is the organisation's account owner. */
  isAccountOwner: Scalars['Boolean'];
  name: Scalars['String'];
  organisationId: Scalars['UUID'];
  /** The member's role in this organisation (built-in or custom); Limited user when none is recorded. */
  role: Role;
};

export type OrganisationUserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  permissionGroupId?: InputMaybe<Scalars['UUID']>;
};

export type OrphanedFile = {
  __typename: 'OrphanedFile';
  createdAt: Scalars['Long'];
  fileId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organisationId?: Maybe<Scalars['ID']>;
  sizeBytes?: Maybe<Scalars['Long']>;
};

export type Packaging = {
  __typename: 'Packaging';
  packagingItem: Scalars['String'];
  substrate: Scalars['String'];
  substrateColor: Scalars['String'];
};

export type PackagingInput = {
  packagingItem: Scalars['String'];
  substrate: Scalars['String'];
  substrateColor: Scalars['String'];
};

export type Page = {
  __typename: 'Page';
  colorSeparations: Array<ColorSeparation>;
  lowQuality: Scalars['Boolean'];
  xDpi: Scalars['Float'];
  xInches: Scalars['Float'];
  xMillimeters: Scalars['Float'];
  xPixels: Scalars['Int'];
  yDpi: Scalars['Float'];
  yInches: Scalars['Float'];
  yMillimeters: Scalars['Float'];
  yPixels: Scalars['Int'];
  zoomLevels: Scalars['Int'];
};

export type PaginatedFolderItems = {
  __typename: 'PaginatedFolderItems';
  items: Array<FolderItem>;
  page: Scalars['Int'];
  totalHits: Scalars['Long'];
};

export type PaginatedProducts = {
  __typename: 'PaginatedProducts';
  page: Scalars['Int'];
  products: Array<Product>;
  totalHits: Scalars['Long'];
};

export type PaginatedProjects = {
  __typename: 'PaginatedProjects';
  page: Scalars['Int'];
  projects: Array<Project>;
  totalHits: Scalars['Long'];
};

export type PaginatedUsers = {
  __typename: 'PaginatedUsers';
  page: Scalars['Int'];
  totalHits: Scalars['Long'];
  users: Array<User>;
};

export type PaginatedUsersOrTeams = {
  __typename: 'PaginatedUsersOrTeams';
  page: Scalars['Int'];
  totalHits: Scalars['Long'];
  usersOrTeams: Array<UserOrTeam>;
};

export type Paging = {
  /** Page number. Starts at 0 */
  page: Scalars['Int'];
  /** PreviewSize of pages. */
  pageSize: Scalars['Int'];
};

export type PaymentSubscription = {
  __typename: 'PaymentSubscription';
  autoRenewal: Scalars['Boolean'];
  createdBy: User;
  currentPeriodEnd?: Maybe<Scalars['Date']>;
  currentPeriodStart: Scalars['Date'];
  /** Subscription-level discount from an accepted offer; item-level discounts sit on the products */
  discount?: Maybe<SubscriptionDiscount>;
  /** Module entitlements derived from the products (empty for legacy subscriptions) */
  entitlements: Array<ModuleEntitlement>;
  /** True when the subscription is on the 2026 module-based pricing model */
  hasModulePricing: Scalars['Boolean'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  /**
   * True for a CWAY-managed trial (no backing Stripe subscription) — the trials staff can
   * extend or stop with updateOrganisationTrial/stopOrganisationTrial. Stripe trials are false.
   */
  isCwayTrial: Scalars['Boolean'];
  /** True when the subscription is managed by Cway staff (self-service changes are locked) */
  isManaged: Scalars['Boolean'];
  isTrial: Scalars['Boolean'];
  /** The subscription offer this subscription was created from, when any */
  offerId?: Maybe<Scalars['UUID']>;
  /**
   * Set when the subscription is invoiced (Stripe send_invoice) with this many days to pay each
   * invoice, by bank transfer or card on the hosted invoice; null when charged automatically to a
   * card. An invoiced subscription stays isActive while PAST_DUE (a late transfer) until Stripe
   * marks it UNPAID or CANCELED; "Update payment method" does not apply to it.
   */
  paymentTermsDays?: Maybe<Scalars['Int']>;
  products: Array<SubscriptionProduct>;
  /**
   * Who started the subscription - for a CWAY trial, the staff member who started the trial.
   * Unlike createdBy it does not change when the subscription is later updated.
   */
  startedBy?: Maybe<User>;
  status: Scalars['String'];
  /** Epoch millis of the trial end; null when not trialling. Drives the in-app trial countdown. */
  trialEnd?: Maybe<Scalars['Long']>;
};

/**
 * A permission is the editable building block of a custom role: a named bundle of secured
 * actions. Its id is what LoginInfo.permissionIds and Role.permissionIds carry.
 */
export type Permission = {
  __typename: 'Permission';
  /**
   * True for the baseline.* permissions: the floor every member stands on (Limited user), implied
   * by every role and never selectable. Render them as always-on in a role editor.
   */
  baseline: Scalars['Boolean'];
  description: Scalars['String'];
  /**
   * True when the current caller may put this permission in a role: they hold it themselves,
   * and for billing.manage / seats.purchase they are the account owner. Offer only these.
   */
  grantableByMe: Scalars['Boolean'];
  /** Frontend grouping label, e.g. "Projects", "Products", "Brand Studio", "Baseline". */
  group: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PinMarker = {
  __typename: 'PinMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type PlannerArtwork = {
  __typename: 'PlannerArtwork';
  category: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  state: ArtworkState;
};

/** ─── planning.graphqls ─────────────────────────────────────────── */
export type PlannerProject = {
  __typename: 'PlannerProject';
  artworks: Array<PlannerArtwork>;
  endDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  percentageDone?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Date']>;
  state: ProjectState;
};

export type Planning = {
  __typename: 'Planning';
  end?: Maybe<Scalars['LocalDate']>;
  start?: Maybe<Scalars['LocalDate']>;
};

export type Print = {
  __typename: 'Print';
  availableInks: Scalars['String'];
  bleed: Scalars['Int'];
  colorBehindNegativeText: Scalars['Int'];
  embossing: Scalars['Boolean'];
  firstDotPrinted: Scalars['String'];
  lastDotPrinted: Scalars['String'];
  maximumInkCoverage: Scalars['Int'];
  metallicPMS: Scalars['Boolean'];
  minimumLineThicknessNegative: Scalars['Int'];
  minimumLineThicknessPositive: Scalars['Int'];
  minimumTextSizeNegative: Scalars['Int'];
  minimumTextSizePositive: Scalars['Int'];
  minimumTrapping: Scalars['Int'];
  misregistration: Scalars['Int'];
  partialVarnish: Scalars['Boolean'];
  partialWhite: Scalars['Boolean'];
  printingTechnique: Scalars['String'];
  screenResolution: Scalars['Int'];
  textColor: Scalars['Int'];
  textDistanceFromDieCut: Scalars['Int'];
  totalVarnish: Scalars['Boolean'];
  totalWhite: Scalars['Boolean'];
};

export type PrintCoverage = {
  __typename: 'PrintCoverage';
  colorCanvas: Scalars['UUID'];
  printCanvas: Scalars['UUID'];
};

export type PrintInput = {
  availableInks: Scalars['String'];
  bleed: Scalars['Int'];
  colorBehindNegativeText: Scalars['Int'];
  embossing: Scalars['Boolean'];
  firstDotPrinted: Scalars['String'];
  lastDotPrinted: Scalars['String'];
  maximumInkCoverage: Scalars['Int'];
  metallicPMS: Scalars['Boolean'];
  minimumLineThicknessNegative: Scalars['Int'];
  minimumLineThicknessPositive: Scalars['Int'];
  minimumTextSizeNegative: Scalars['Int'];
  minimumTextSizePositive: Scalars['Int'];
  minimumTrapping: Scalars['Int'];
  misregistration: Scalars['Int'];
  partialVarnish: Scalars['Boolean'];
  partialWhite: Scalars['Boolean'];
  printingTechnique: Scalars['String'];
  screenResolution: Scalars['Int'];
  textColor: Scalars['Int'];
  textDistanceFromDieCut: Scalars['Int'];
  totalVarnish: Scalars['Boolean'];
  totalWhite: Scalars['Boolean'];
};

/** ─── printmanagement.graphqls ──────────────────────────────────── */
export type PrintSpecification = {
  __typename: 'PrintSpecification';
  createdAt: Scalars['Long'];
  createdBy: User;
  decor: Decor;
  id: Scalars['UUID'];
  name: Scalars['String'];
  packaging: Packaging;
  print: Print;
  specialInstructions: SpecialInstructions;
};

export type Product = {
  __typename: 'Product';
  articles: Array<Article>;
  /** Product attribute definitions applicable to this product, resolved from its categories' attribute sets (union). */
  attributes: Array<ProductAttribute>;
  brand?: Maybe<Brand>;
  categories: Array<ProductCategory>;
  completeness: CompletenessScore;
  /** Locales editable for this product = the union of its markets' locales. */
  editableLocales: Array<Scalars['String']>;
  files: Array<File>;
  id: Scalars['UUID'];
  markets: Array<Market>;
  name?: Maybe<Scalars['String']>;
  productNo: Scalars['String'];
  relationships: Array<ProductRelationship>;
  /** Epoch millis (per attribute key) the source-locale value was last set. */
  sourceUpdatedAt: Scalars['JSON'];
  stage?: Maybe<Scalars['UUID']>;
  /** Epoch millis (per `locale.key`) a non-source-locale value was last written. */
  translatedAt: Scalars['JSON'];
  /** Per-translation freshness (per `locale.key`): "ok" | "outdated". Missing/na are client-derivable. */
  translationStatus: Scalars['JSON'];
  /** Localized attribute values, keyed by attribute key (non-localizable) or `locale.key`. */
  values: Scalars['JSON'];
};

export type ProductAttribute = {
  __typename: 'ProductAttribute';
  group?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key: Scalars['String'];
  localizable: Scalars['Boolean'];
  name: Scalars['String'];
  regulated: Scalars['Boolean'];
  required: Array<Scalars['String']>;
  scope: AttributeScope;
  selectValues: Array<Scalars['String']>;
  setId: Scalars['UUID'];
  sortOrder: Scalars['Int'];
  type: AttributeType;
  unit?: Maybe<Scalars['String']>;
};

export type ProductAttributeSet = {
  __typename: 'ProductAttributeSet';
  anchorAttributeKeys: Array<Scalars['String']>;
  id: Scalars['UUID'];
  locked: Scalars['Boolean'];
  name: Scalars['String'];
  scope: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type ProductCategory = {
  __typename: 'ProductCategory';
  id: Scalars['UUID'];
  lineage: Array<Maybe<ProductCategory>>;
  name: Scalars['String'];
  parent?: Maybe<Scalars['UUID']>;
  productCount: Scalars['Int'];
  setIds: Array<Scalars['UUID']>;
};

export type ProductLocale = {
  __typename: 'ProductLocale';
  code: Scalars['String'];
  label: Scalars['String'];
  region: Scalars['String'];
};

export type ProductRelationship = {
  __typename: 'ProductRelationship';
  relatedProductId: Scalars['UUID'];
  type: RelationshipType;
};

export type ProductStage = {
  __typename: 'ProductStage';
  bucket: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type Progress = {
  __typename: 'Progress';
  artworksDone: Scalars['Int'];
  artworksInProgress: Scalars['Int'];
  artworksUnstarted: Scalars['Int'];
  percentageDone: Scalars['Float'];
  percentageInProgress: Scalars['Float'];
  percentageUnstarted: Scalars['Float'];
  totalArtworks: Scalars['Int'];
};

/** A project representation */
export type Project = {
  __typename: 'Project';
  artworks: Array<Artwork>;
  /** Blikk customer ID override for this project */
  blikkCustomerId?: Maybe<Scalars['String']>;
  /** Blikk project ID if linked to a Blikk project */
  blikkProjectId?: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  /** The customisable status currently assigned to the project. Derived from legacy state if not explicitly set. */
  currentStatus: ProjectStatus;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  /**
   * Project files with their S3-style folder path. Same files as `files`, with location.
   * not available over subscription
   */
  fileEntries: Array<ProjectFileEntry>;
  /** not available over subscription */
  files: Array<File>;
  id: Scalars['UUID'];
  isInClosableState: Scalars['Boolean'];
  isInDeleteableState: Scalars['Boolean'];
  /**
   * True when the current user is involved in the project: orderer, project manager,
   * or assigned to any of its artworks (directly or through a team)
   */
  isMember: Scalars['Boolean'];
  lastActivity?: Maybe<Scalars['LocalDateTime']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  orderNo: Scalars['String'];
  orderer: User;
  planning: Planning;
  progress: Progress;
  projectManager?: Maybe<User>;
  projectNotes: Array<ProjectNote>;
  projectPermissions: ProjectPermissions;
  /** The Purchase Order number */
  refOrderNo?: Maybe<Scalars['String']>;
  silent: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  state: ProjectState;
  status: StatusBall;
  /** Number of events applied to the project aggregate; increases with every change */
  version: Scalars['Int'];
};

export type ProjectEvent = {
  __typename: 'ProjectEvent';
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  timestamp: Scalars['Long'];
};

/** A project file together with its folder location. */
export type ProjectFileEntry = {
  __typename: 'ProjectFileEntry';
  file: File;
  /** S3-style parent prefix (e.g. "print/source"). Null means the project root. */
  path?: Maybe<Scalars['String']>;
};

/** A filter to reduce the number of projects */
export type ProjectFilter = {
  /** Searches in name, descriptions, filecontent and barcodes */
  name?: InputMaybe<Scalars['String']>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  orderNo?: InputMaybe<Scalars['String']>;
  orderer?: InputMaybe<Scalars['String']>;
  /** Legacy enum filter. Prefer statusIds for granular filtering by customisable status. */
  states?: InputMaybe<Array<ProjectState>>;
  /** Match projects whose current status is one of the given customisable statuses. */
  statusIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type ProjectListEvent = {
  __typename: 'ProjectListEvent';
  /** Resolved on ADDED/UPDATED; null on REMOVED */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  type: ProjectListEventType;
  /**
   * Project version on the same scale as Project.version: monotonically increasing per
   * project. Use it to order events for a project and drop ones already applied.
   */
  version: Scalars['Long'];
};

export enum ProjectListEventType {
  Added = 'ADDED',
  Removed = 'REMOVED',
  Updated = 'UPDATED'
}

export type ProjectNote = {
  __typename: 'ProjectNote';
  content: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['UUID'];
  lastModifiedAt: Scalars['Long'];
  lastModifiedBy: Scalars['UUID'];
  title: Scalars['String'];
};

export type ProjectPermissions = {
  __typename: 'ProjectPermissions';
  canChangeCategory: Scalars['Boolean'];
  canChangeNotes: Scalars['Boolean'];
  canChangeOrderer: Scalars['Boolean'];
  canManageArtworks: Scalars['Boolean'];
  canManageProject: Scalars['Boolean'];
  canManageTasks: Scalars['Boolean'];
  canRejectDeliveredArtworks: Scalars['Boolean'];
  canRevokeApproval: Scalars['Boolean'];
  canRevokeRejection: Scalars['Boolean'];
  canSeeAllArtworks: Scalars['Boolean'];
  canSeeDeliveries: Scalars['Boolean'];
  canSetInvoiceNumber: Scalars['Boolean'];
  id: Scalars['UUID'];
  projectId: Scalars['UUID'];
};

/** Role types For a project */
export enum ProjectRoleType {
  Admin = 'ADMIN',
  External = 'EXTERNAL',
  GraphicCreator = 'GRAPHIC_CREATOR',
  LeadGraphicCreator = 'LEAD_GRAPHIC_CREATOR',
  Orderer = 'ORDERER',
  ProjectManager = 'PROJECT_MANAGER',
  Repro = 'REPRO',
  Reviewer = 'REVIEWER'
}

export enum ProjectState {
  Closed = 'CLOSED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  /** deprecated, planned is being removed */
  Planned = 'PLANNED',
  StandBy = 'STAND_BY'
}

/** A customisable project status. Belongs to an organisation and groups under a category. */
export type ProjectStatus = {
  __typename: 'ProjectStatus';
  archived: Scalars['Boolean'];
  category: ProjectStatusCategory;
  description: Scalars['String'];
  id: Scalars['UUID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

/** Category that a customisable project status belongs to. Drives lifecycle invariants. */
export enum ProjectStatusCategory {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS'
}

export type Query = {
  __typename: 'Query';
  /** Get a single anonymous share by ID. No authentication required, works with public share links. */
  anonymousShare?: Maybe<Share>;
  /** Get a single article by its id, or null if no such (non-deleted) article exists. */
  article?: Maybe<Article>;
  /** Get all non-deleted articles across every product in the organisation. */
  articles: Array<Article>;
  /** Get all non-deleted articles for a specific product. */
  articlesForProduct: Array<Article>;
  /** Get a single project artwork by its ID. Note: This retrieves a project artwork, not a mediacenter artwork. */
  artwork?: Maybe<Artwork>;
  /** Run AI analysis of artwork rules verification. Returns the analysis result. */
  artworkAIAnalysis: Scalars['String'];
  /** Get the complete event history for a project artwork, including revisions, comments, and state changes. */
  artworkHistory: Array<ArtworkEvent>;
  /** Find all mediacenter locations where a project artwork is linked/stored. */
  artworkLocationsForProjectArtwork: Array<MediaCenterArtworkLocation>;
  /** Get the file structure for a project artwork as it would appear in a downloaded zip file. */
  artworkZipStructure: Array<DownloadFileDescriptor>;
  /**
   * Get all project artworks awaiting approval by the current user.
   * @deprecated Use tasksForUser (ApproveArtworkTask entries) with the userTaskListEvents subscription for live updates.
   */
  artworksToApprove: Array<Artwork>;
  /**
   * Get all project artworks where the current user is assigned as a supplier and needs to upload a revision.
   * @deprecated Use tasksForUser (UploadRevisionTask entries) with the userTaskListEvents subscription for live updates.
   */
  artworksToUpload: Array<Artwork>;
  assetTag?: Maybe<AssetTag>;
  assetTags: Array<AssetTag>;
  /** Get a temporary URL for a user's avatar image. Returns null if the user has no avatar. The URL expires after 4 hours. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Get cached Blikk contacts for the current organisation. Requires Blikk integration to be enabled. */
  blikkContacts: Array<BlikkContact>;
  /** Get Blikk project info for a linked project. Returns null if not linked or integration inactive. */
  blikkProjectInfo?: Maybe<BlikkProject>;
  /** Get Blikk time reports for a linked project with matched CWAY users. Returns a summary with per-user totals. */
  blikkTimeReports?: Maybe<BlikkTimeReportSummary>;
  /** Get cached Blikk users for the current organisation. Requires Blikk integration to be enabled. */
  blikkUsers: Array<BlikkUser>;
  /** Get all available brands for organizing products by brand. */
  brands: Array<Brand>;
  chatSession?: Maybe<ChatSession>;
  /** System admin only - Get all detected duplicate user accounts (same email, different UserIds). */
  duplicateUsers: Array<DuplicateUserPair>;
  /** Check if a file exists in the archive storage. */
  existsInArchive: Scalars['Boolean'];
  /** Export user search results as a downloadable file. Returns a file ID. */
  exportUserSearch: Scalars['String'];
  /** System admin only - The users findUsersInAnyOrganisation would match, as CSV. */
  exportUsersInAnyOrganisation: Scalars['String'];
  /** Get file metadata and information by its ID. */
  file?: Maybe<File>;
  /**
   * Get a temporary URL for a rendered file at a specific size and format.
   * Null when the file has no rendering and no source in the archive yet, e.g. an artwork
   * that has not been uploaded or rendered.
   */
  fileRenderUrl?: Maybe<Scalars['String']>;
  /** Generate a short-lived JWT token for authenticating with the file service. Token is valid for 30 minutes. */
  fileServiceJwt: Scalars['String'];
  /** Search for shares with optional filters. By default excludes read shares unless includeRead is true. */
  findShares?: Maybe<Array<Maybe<Share>>>;
  /** Search for users within the current organisation by username. Returns partial matches. */
  findUsers: Array<Maybe<User>>;
  /** Search for both users and teams within the current organisation with pagination. Useful for assignment operations. */
  findUsersAndTeamsPage: PaginatedUsersOrTeams;
  /**
   * System admin only - Search for users across all organisations with pagination support.
   * filter and sort are optional; without sort the list is ordered by username.
   */
  findUsersInAnyOrganisation: PaginatedUsers;
  /**
   * Search for users within the current organisation with pagination support.
   * Agent users (AI agents, API-key service accounts) are left out of every user search and of
   * Organisation.users unless includeAgents is true; a key's service account is on ApiKey.serviceAccount.
   */
  findUsersPage: PaginatedUsers;
  /** Get a single mediacenter folder by ID with its subfolders. */
  folder: Folder;
  /**
   * Generate an image using AI. Returns base64 encoded image.
   * Without fileId: generates from scratch using the prompt (Flux 2 Pro) at the given size.
   * With fileId: edits the file's preview image based on the prompt (Flux Kontext).
   *   Edited images are always ~1MP; use aspectRatio to control shape (e.g. "16:9", "1:1", range 3:7 to 7:3).
   */
  generateImage: Scalars['String'];
  /** Get the catalogue of permissions that custom roles can be built from. */
  getPermissionCatalog: Array<Permission>;
  /** Get detailed information about a specific user by username. */
  getUser?: Maybe<User>;
  /** System admin only - Get all companies from HubSpot CRM. */
  hubSpotCompanies: Array<HubSpotCompany>;
  /** Search and retrieve mediacenter items (artworks and files) within a folder with optional filtering and pagination. */
  itemsForFolder?: Maybe<PaginatedFolderItems>;
  /** Search mediacenter items across the entire organisation with optional filtering and pagination. */
  itemsForOrganisation?: Maybe<PaginatedFolderItems>;
  layoutConfig?: Maybe<LayoutConfig>;
  listChatbotSkills: Array<ChatbotSkillSummary>;
  loginInfo?: Maybe<LoginInfo>;
  /** Get all available markets for organizing products geographically. */
  markets: Array<Market>;
  /** Get the file structure for a mediacenter artwork as it would appear in a downloaded zip file. */
  mcArtworkZipStructure: Array<DownloadFileDescriptor>;
  /** Get a single mediacenter artwork by ID. Note: This retrieves a mediacenter artwork, not a project artwork. */
  mediaCenterArtwork?: Maybe<MediaCenterArtwork>;
  /** System admin only - Get the mediacenter artwork linked to a project artwork. */
  mediaCenterArtworkForProjectArtwork?: Maybe<MediaCenterArtwork>;
  /** Get all mediacenter artworks linked to a specific article. */
  mediaCenterArtworksForArticle: Array<MediaCenterArtwork>;
  /** Get all mediacenter artworks linked to a specific product (roll-up over the product's articles). */
  mediaCenterArtworksForProduct: Array<MediaCenterArtwork>;
  /** System admin only - Get mediacenter storage usage across all organisations. */
  mediaCenterStorageForAllOrganisations: Array<MediaCenterStorageSummary>;
  /** Get the complete event history for a mediacenter folder tree. */
  mediaCenterTreeHistory: Array<TreeHistoryEvent>;
  /**
   * Activity summary for the signed-in user across every organisation they are a member of.
   * Deliberately NOT scoped to the token's organisation, unlike `statistics` - the caller's
   * memberships define the span. Readable by any member: no permission group, no module.
   * `timeZone` is the IANA zone the day buckets are cut in, e.g. "Europe/Stockholm";
   * defaults to UTC. The range is inclusive at both ends and may span at most 400 days;
   * a wider range, an unknown zone, or `from` after `to` is rejected rather than truncated.
   */
  myActivity: MyActivity;
  /**
   * What the signed-in user worked on during one day: organisation, project and artwork names
   * with an upload count each. Meant to be fetched when a day in the `myActivity` grid is
   * hovered, so the summary does not carry names for every day. Cross-organisation in the same
   * way as `myActivity` - any session token answers for every membership, and no organisation
   * switch is needed. `timeZone` as for `myActivity`; an unknown zone is rejected.
   */
  myActivityDay: MyActivityDayDetail;
  /** Get the total count of artworks in all in-progress projects visible to the current user. */
  myArtworksCount: Scalars['Int'];
  /**
   * System admin only - Everything that can go on a subscription offer: the whole active Stripe
   * catalog (managed Enterprise tiers, seats, overage and billing-only lines such as a support
   * plan included), sorted by name. Products with module == null and seatType == null are
   * billing-only: they show on the invoice and grant nothing. Use this for the offer builder's
   * product picker.
   */
  offerProducts: Array<SubscriptionProduct>;
  /** Get the number of open projects per month for the past year. Useful for trend analysis and capacity planning. */
  openProjectsCountByMonth: Array<MonthlyOpenProjectsCount>;
  /** Get organisation details by ID. If no ID provided, returns current user's organisation. */
  organisation?: Maybe<Organisation>;
  /** Get login audit logs for the current organisation showing user access history. */
  organisationAuditLogs: Array<LoginAuditPost>;
  /** Admin only - Get mediacenter storage usage for a specific organisation with size in specified unit. */
  organisationMediaCenterStorageStorage: MediaCenterStorageSummary;
  /** System admin only - Get all organisations in the system. */
  organisations?: Maybe<Array<Maybe<Organisation>>>;
  /**
   * System-admin: files that nothing references and are older than the grace window.
   * organisationId is optional — omit to span all organisations, or pass one to scope to it.
   */
  orphanedFiles: Array<OrphanedFile>;
  /** Get all projects with planning information including dates, completion percentage, and artwork details. */
  plannerProjects?: Maybe<Array<Maybe<PlannerProject>>>;
  /** Get all possible trophies/achievements that can be earned in the system. */
  possibleTrophies: Array<Trophy>;
  /** Get a single print specification by its ID. */
  printSpecification: PrintSpecification;
  /** Get all print specifications in the organisation. */
  printSpecifications: Array<PrintSpecification>;
  /** Get a single product by its ID. */
  product?: Maybe<Product>;
  /** Get all attribute sets for the current organisation, sorted by sortOrder. */
  productAttributeSets: Array<ProductAttributeSet>;
  /** Get all product attribute definitions, optionally filtered by scope. */
  productAttributes: Array<ProductAttribute>;
  /** Get all product categories as a flattened list (includes hierarchy via lineage field). */
  productCategories: Array<ProductCategory>;
  /** Get all supported product locales for use with market locale assignment. */
  productLocales: Array<ProductLocale>;
  /** Get all product stages for the current organisation, sorted by sortOrder. */
  productStages: Array<ProductStage>;
  /** Search products with optional filters on article number, name, category, or brand. Returns paginated results. */
  products: PaginatedProducts;
  /** Get a single project by its ID. Returns full project details including all artworks. */
  project?: Maybe<Project>;
  /** Get all project artworks linked to a specific article. */
  projectArtworksForArticle: Array<Artwork>;
  /**
   * Get all project artworks linked to a specific product.
   * Roll-up over the product's articles.
   */
  projectArtworksForProduct: Array<Artwork>;
  /** Get the complete event history for a project, including all changes and actions performed. */
  projectHistory: Array<ProjectEvent>;
  /** Search and filter projects with pagination. Returns projects visible to the current user. */
  projects?: Maybe<PaginatedProjects>;
  /** Search/list Blikk projects for linking. Optional search filter on title/order number. */
  searchBlikkProjects: Array<BlikkProject>;
  /** System admin only - Search for contacts in HubSpot CRM by email address. */
  searchHubSpotContacts: Array<HubSpotContact>;
  /** Get a single share by ID. Requires authentication and access to the share. */
  share?: Maybe<Share>;
  /** Get the file structure for a share as it would appear in a downloaded zip file. */
  shareZipStructure: Array<DownloadFileDescriptor>;
  /**
   * Get comprehensive statistics and analytics for an organisation including approvals, storage, deliveries, and user metrics.
   * organisationId omitted = the caller's organisation. System admins may target any organisation.
   */
  statistics: Statistics;
  /** System admin only - Get system status including renderer status and command/query statistics. */
  status: SystemStatus;
  /**
   * What applying the open offer to the organisation's running subscription would invoice right
   * now (subscription.manage). Only for offers whose appliesToSubscriptionId is set.
   */
  subscriptionOfferPreview: SubscriptionOfferPreview;
  /** Get all available subscription products and pricing for purchasing/upgrading. */
  subscriptionProducts: Array<SubscriptionProduct>;
  /** Get all tasks for the current user within a specific project. */
  tasksForProject: Array<UserTask>;
  /** Get all tasks for the current user across all projects and shares in their current organisation. */
  tasksForUser: Array<UserTask>;
  /** Get a temporary URL for downloading a file directly from storage. */
  tempFileDownloadUrl: Scalars['String'];
  /** Get a temporary URL for uploading a file directly to storage. */
  tempFileUploadUrl: Scalars['String'];
  /** Get a temporary streaming URL for a video file. */
  tempUrlForVideo: Scalars['String'];
  /**
   * Get all mediacenter folders for the current organisation as a flattened list. Reconstruct the tree structure using parent IDs.
   * includeDeleted (system admins only) also returns folders of deleted trees, marked with deleted: true.
   */
  tree: Array<Folder>;
  /**
   * System admin only - Get organisations whose active subscription is in trial
   * (CWAY-managed trials and Stripe trialing subscriptions), sorted by name.
   */
  triallingOrganisations: Array<Organisation>;
  /** Get detailed information about a specific user by their UUID. */
  user?: Maybe<User>;
  /** Get all API tokens for the current user (tokens are not included for security). */
  userApiTokens: Array<UserApiToken>;
  /** System admin only - Counts of the users findUsersInAnyOrganisation would match, per property. */
  userCountsInAnyOrganisation: UserCounts;
  /** Get all users with access to a specific mediacenter folder and their permissions. */
  usersForFolder: Array<FolderUser>;
  /** Validate a list of email addresses for deliverability and check if they're already registered users. */
  validateEmails: Array<EmailValidationResult>;
  /**
   * System admin only - Validate the organisation's subscriptions against Stripe and flag
   * orphans (subscriptions Stripe does not know — dev/staging data drift), removable with
   * removeOrphanedSubscription. organisationId omitted = caller's organisation.
   */
  validateSubscriptions: Array<SubscriptionValidation>;
  /** Get all available webhook event types that can be subscribed to. */
  webhookEventTypes: Array<WebhookEventType>;
};


export type QueryAnonymousShareArgs = {
  id: Scalars['UUID'];
};


export type QueryArticleArgs = {
  id: Scalars['UUID'];
};


export type QueryArticlesForProductArgs = {
  productId: Scalars['UUID'];
};


export type QueryArtworkArgs = {
  id: Scalars['UUID'];
};


export type QueryArtworkAiAnalysisArgs = {
  artworkId: Scalars['UUID'];
};


export type QueryArtworkHistoryArgs = {
  artworkId: Scalars['UUID'];
};


export type QueryArtworkLocationsForProjectArtworkArgs = {
  projectArtworkId: Scalars['UUID'];
};


export type QueryArtworkZipStructureArgs = {
  artworkId: Scalars['UUID'];
};


export type QueryAssetTagArgs = {
  id: Scalars['UUID'];
};


export type QueryAssetTagsArgs = {
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<AssetTagSort>;
};


export type QueryAvatarUrlArgs = {
  size?: InputMaybe<AvatarSize>;
  userId: Scalars['UUID'];
};


export type QueryBlikkProjectInfoArgs = {
  projectId: Scalars['UUID'];
};


export type QueryBlikkTimeReportsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryChatSessionArgs = {
  sessionId: Scalars['UUID'];
};


export type QueryExistsInArchiveArgs = {
  uuid: Scalars['UUID'];
};


export type QueryExportUserSearchArgs = {
  username?: InputMaybe<Scalars['String']>;
};


export type QueryExportUsersInAnyOrganisationArgs = {
  filter?: InputMaybe<UserFilter>;
  sort?: InputMaybe<UserSort>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryFileArgs = {
  uuid: Scalars['UUID'];
};


export type QueryFileRenderUrlArgs = {
  fileId: Scalars['UUID'];
  format?: InputMaybe<RenderFormat>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<RenderSize>;
};


export type QueryFindSharesArgs = {
  fileNameFilter?: InputMaybe<Scalars['String']>;
  includeRead?: InputMaybe<Scalars['Boolean']>;
  sharedByUser?: InputMaybe<Scalars['String']>;
  sharedToUser?: InputMaybe<Scalars['String']>;
};


export type QueryFindUsersArgs = {
  username?: InputMaybe<Scalars['String']>;
};


export type QueryFindUsersAndTeamsPageArgs = {
  paging?: InputMaybe<Paging>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryFindUsersInAnyOrganisationArgs = {
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<UserSort>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryFindUsersPageArgs = {
  includeAgents?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<Paging>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryFolderArgs = {
  id: Scalars['UUID'];
};


export type QueryGenerateImageArgs = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  prompt: Scalars['String'];
  size?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserArgs = {
  username?: InputMaybe<Scalars['String']>;
};


export type QueryItemsForFolderArgs = {
  input: FindFolderItemInput;
  paging?: InputMaybe<Paging>;
  sorting?: InputMaybe<FolderItemSort>;
};


export type QueryItemsForOrganisationArgs = {
  input: FindFolderItemsInOrganisationInput;
  paging?: InputMaybe<Paging>;
};


export type QueryLayoutConfigArgs = {
  key: Scalars['String'];
  scope: LayoutScope;
  type: Scalars['String'];
};


export type QueryListChatbotSkillsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMcArtworkZipStructureArgs = {
  artworkId: Scalars['UUID'];
};


export type QueryMediaCenterArtworkArgs = {
  artworkId: Scalars['UUID'];
};


export type QueryMediaCenterArtworkForProjectArtworkArgs = {
  projectArtworkId: Scalars['UUID'];
};


export type QueryMediaCenterArtworksForArticleArgs = {
  articleId: Scalars['UUID'];
};


export type QueryMediaCenterArtworksForProductArgs = {
  productId: Scalars['UUID'];
};


export type QueryMediaCenterStorageForAllOrganisationsArgs = {
  unit?: InputMaybe<FolderStorageUnit>;
};


export type QueryMediaCenterTreeHistoryArgs = {
  treeId: Scalars['UUID'];
};


export type QueryMyActivityArgs = {
  from: Scalars['LocalDate'];
  timeZone?: InputMaybe<Scalars['String']>;
  to: Scalars['LocalDate'];
};


export type QueryMyActivityDayArgs = {
  day: Scalars['LocalDate'];
  timeZone?: InputMaybe<Scalars['String']>;
};


export type QueryOpenProjectsCountByMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


export type QueryOrganisationArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryOrganisationMediaCenterStorageStorageArgs = {
  organisationId: Scalars['UUID'];
  unit?: InputMaybe<FolderStorageUnit>;
};


export type QueryOrphanedFilesArgs = {
  organisationId?: InputMaybe<Scalars['ID']>;
};


export type QueryPrintSpecificationArgs = {
  id: Scalars['UUID'];
};


export type QueryProductArgs = {
  productId: Scalars['UUID'];
};


export type QueryProductAttributesArgs = {
  scope?: InputMaybe<AttributeScope>;
};


export type QueryProductsArgs = {
  articleNo?: InputMaybe<Scalars['String']>;
  attributeFilters?: InputMaybe<Array<AttributeFilterInput>>;
  brand?: InputMaybe<Scalars['UUID']>;
  category?: InputMaybe<Scalars['UUID']>;
  maxCompleteness?: InputMaybe<Scalars['Int']>;
  minCompleteness?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<Paging>;
};


export type QueryProjectArgs = {
  id: Scalars['UUID'];
};


export type QueryProjectArtworksForArticleArgs = {
  articleId: Scalars['UUID'];
};


export type QueryProjectArtworksForProductArgs = {
  productId: Scalars['UUID'];
};


export type QueryProjectHistoryArgs = {
  projectId: Scalars['UUID'];
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<ProjectFilter>;
  paging?: InputMaybe<Paging>;
};


export type QuerySearchBlikkProjectsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchHubSpotContactsArgs = {
  email: Scalars['String'];
};


export type QueryShareArgs = {
  id: Scalars['UUID'];
};


export type QueryShareZipStructureArgs = {
  shareId: Scalars['UUID'];
};


export type QueryStatisticsArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySubscriptionOfferPreviewArgs = {
  offerId: Scalars['UUID'];
};


export type QueryTasksForProjectArgs = {
  projectId: Scalars['UUID'];
};


export type QueryTempFileDownloadUrlArgs = {
  fileId: Scalars['UUID'];
};


export type QueryTempFileUploadUrlArgs = {
  fileId: Scalars['UUID'];
  filename?: InputMaybe<Scalars['String']>;
};


export type QueryTempUrlForVideoArgs = {
  fileId: Scalars['UUID'];
};


export type QueryTreeArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUserArgs = {
  userId: Scalars['UUID'];
};


export type QueryUserCountsInAnyOrganisationArgs = {
  filter?: InputMaybe<UserFilter>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryUsersForFolderArgs = {
  folderId: Scalars['UUID'];
};


export type QueryValidateEmailsArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryValidateSubscriptionsArgs = {
  organisationId?: InputMaybe<Scalars['UUID']>;
};

export type Receiver = {
  __typename: 'Receiver';
  downloaded: Scalars['Boolean'];
};

/** ─── file.graphqls ─────────────────────────────────────────────── */
export type Rectangle = {
  __typename: 'Rectangle';
  xEnd: Scalars['Int'];
  xStart: Scalars['Int'];
  yEnd: Scalars['Int'];
  yStart: Scalars['Int'];
};

export type RectangleInput = {
  xEnd?: InputMaybe<Scalars['Int']>;
  xStart?: InputMaybe<Scalars['Int']>;
  yEnd?: InputMaybe<Scalars['Int']>;
  yStart?: InputMaybe<Scalars['Int']>;
};

export type RectangleMarker = {
  __typename: 'RectangleMarker';
  pageNo: Scalars['Int'];
  x: Scalars['Int'];
  xEnd: Scalars['Int'];
  y: Scalars['Int'];
  yEnd: Scalars['Int'];
};

export type Registration = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type RejectArtworkInput = {
  artworkId: Scalars['UUID'];
  comment?: InputMaybe<Scalars['String']>;
  resetUsernames?: InputMaybe<Array<Scalars['String']>>;
  username: Scalars['String'];
};

export type RelationshipInput = {
  relatedProductId: Scalars['UUID'];
  type: RelationshipType;
};

export enum RelationshipType {
  Accessory = 'ACCESSORY',
  Alternative = 'ALTERNATIVE',
  CrossSell = 'CROSS_SELL',
  PartOf = 'PART_OF',
  Upsell = 'UPSELL'
}

export type RemindApproverInput = {
  artworkId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  username: Scalars['String'];
};

export type RemoveFilesFromProductInput = {
  fileIds: Array<Scalars['UUID']>;
  productId: Scalars['UUID'];
};

export type RemoveRelationshipsFromProductInput = {
  productId: Scalars['UUID'];
  relationships: Array<RelationshipInput>;
};

export type RemoveSubApprovalFromArtworkInput = {
  artworkId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type RemoveUserFromArtworkInput = {
  artworkId: Scalars['UUID'];
  username: Scalars['String'];
};

export type RemoveUsersFromProjectInput = {
  projectId: Scalars['UUID'];
  usernames: Array<Scalars['String']>;
};

export enum RenderFormat {
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum RenderSize {
  Large = 'LARGE',
  Original = 'ORIGINAL',
  Small = 'SMALL',
  XLarge = 'X_LARGE'
}

export type RendererStatus = {
  __typename: 'RendererStatus';
  active: Scalars['Boolean'];
  hostname: Scalars['String'];
  ip: Scalars['String'];
  lastSeen: Scalars['DateTime'];
  rendererId: Scalars['String'];
};

/** A revision of the */
export type Revision = {
  __typename: 'Revision';
  /** Is this a closed revision, eg. the latest? */
  closed: Scalars['Boolean'];
  /** Any comment made when creating this revision */
  comment?: Maybe<Scalars['String']>;
  corrections: Array<Correction>;
  created: Scalars['Date'];
  createdBy?: Maybe<User>;
  /** The preview file of the revision (or today the actual revision file as a pdf) */
  file?: Maybe<File>;
  files: Array<ArtworkFile>;
  id: Scalars['UUID'];
  /** Has all messages been sent about this revision */
  messageSent: Scalars['Boolean'];
  name: Scalars['String'];
  printCoverage?: Maybe<PrintCoverage>;
  referenceRevision: Scalars['Boolean'];
  /** The list of corrs for the revisions */
  revisionEvents: Array<RevisionEvent>;
  revisionNo: Scalars['Long'];
  revisionSystemLogs: Array<RevisionSystemLog>;
  ruleVerifications: Array<RuleVerification>;
};

export type RevisionEvent = Correction | RevisionSystemLog;

export type RevisionSystemLog = {
  __typename: 'RevisionSystemLog';
  created: Scalars['DateTime'];
  id: Scalars['UUID'];
  text: Scalars['String'];
};

/**
 * An organisation role, built-in or custom, fully resolved. Read them from Organisation.roles;
 * a member's own is User.role / OrganisationMembership.role. Account ownership is not a role:
 * see Organisation.accountOwner and LoginInfo.isAccountOwner.
 */
export type Role = {
  __typename: 'Role';
  /**
   * False only for the retired "Organisation owner" role (shown as Admin). It is never part
   * of Organisation.roles; you only ever see it as a member's current role.
   */
  assignable: Scalars['Boolean'];
  /** Built-in roles (Limited user, User, Admin) cannot be edited or deleted. */
  builtIn: Scalars['Boolean'];
  description: Scalars['String'];
  /** @deprecated Use !builtIn. */
  editable: Scalars['Boolean'];
  /**
   * True when the current caller may edit or delete this role: a custom role, within the
   * caller's own permissions, for a caller who may manage roles. Roles above you are read-only.
   */
  editableByMe: Scalars['Boolean'];
  /**
   * True when the current caller may hand this role out: assignable, at or below the caller's
   * own permissions, and - for roles carrying billing.manage / seats.purchase - only for the
   * account owner. Build role pickers from roles where this is true.
   */
  grantableByMe: Scalars['Boolean'];
  id: Scalars['UUID'];
  /**
   * True when the current caller may change the role of, or remove, members holding this role:
   * it is at or below the caller's own permissions. Not grantableByMe - the retired owner role
   * is never grantable, but it counts as Admin here, so admins may demote its holders. A member
   * who owns the account is out of reach regardless (Organisation.accountOwner).
   */
  membersChangeableByMe: Scalars['Boolean'];
  name: Scalars['String'];
  /**
   * Every permission id the role effectively grants, built-in roles included, always with the
   * baseline.* ids every role implies. For a built-in role this is the complete description of
   * what it can do; for a custom role it is what was saved plus the baseline. Submitting it back
   * unchanged through setCustomRolePermissions is a no-op.
   */
  permissionIds: Array<Scalars['String']>;
  /** The same permissions resolved, for the role editor. */
  permissions: Array<Permission>;
};

export type RuleVerification = {
  __typename: 'RuleVerification';
  passed: Scalars['Boolean'];
  rule: Scalars['String'];
};

/**
 * A billed seat held by a member. Every seat is explicit: granted by an admin, revocable
 * and reassignable by an admin.
 */
export type SeatAssignment = {
  __typename: 'SeatAssignment';
  seatType: SeatType;
  userId: Scalars['UUID'];
};

/** A pending ask for a seat, resolved by grantSeatRequest / declineSeatRequest. */
export type SeatRequest = {
  __typename: 'SeatRequest';
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  /** Epoch millis */
  requestedAt: Scalars['Long'];
  requestedBy: Scalars['UUID'];
  requestedFor: Scalars['UUID'];
  seatType: SeatType;
};

export type SeatRequestTask = {
  __typename: 'SeatRequestTask';
  assignedTo: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  /** @deprecated Renamed: use dueDate */
  deadline?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  organisationId: Scalars['ID'];
  requestId: Scalars['ID'];
  requestedById: Scalars['ID'];
  requestedByName: Scalars['String'];
  requestedForId: Scalars['ID'];
  requestedForName: Scalars['String'];
  seatType: SeatType;
};

/** Kinds of billable seats. */
export enum SeatType {
  /**
   * The Lightbox supplier app. Sold by Cway sales only (on an offer, or added to the
   * subscription in Stripe), never in the self-service catalog or setSubscriptionSeats.
   * Assigned and requested like project seats: assignSeat / revokeSeat / requestSeat with
   * seatType LIGHTBOX.
   */
  Lightbox = 'LIGHTBOX',
  Project = 'PROJECT'
}

/** Seat usage for organisations on module-based pricing. -1 means unlimited. */
export type SeatUsage = {
  __typename: 'SeatUsage';
  includedSeats: Scalars['Int'];
  purchasedSeats: Scalars['Int'];
  seatsLeft: Scalars['Int'];
  totalSeats: Scalars['Int'];
  usedSeats: Scalars['Int'];
};

export type SendChatMessageInput = {
  /** Optional updated UI context. If provided, replaces the session's context. */
  context?: InputMaybe<ChatContextInput>;
  message: Scalars['String'];
  sessionId: Scalars['UUID'];
};

export type SetProductBrandInput = {
  /** If the brand is known. Overrides brandName. */
  brandId?: InputMaybe<Scalars['UUID']>;
  /** Matches an existing brand name case-insensitively, else creates a new brand. Overridden by brandId. */
  brandName?: InputMaybe<Scalars['String']>;
  productId: Scalars['UUID'];
};

export type SetProductCategoriesInput = {
  categories: Array<Scalars['UUID']>;
  productId: Scalars['UUID'];
};

export type SetProductMarketsInput = {
  /** The full set of markets the product belongs to (replaces any previous set). */
  marketIds: Array<Scalars['UUID']>;
  productId: Scalars['UUID'];
};

/** ─── share.graphqls ────────────────────────────────────────────── */
export type Share = {
  __typename: 'Share';
  created: Scalars['Long'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  organisation: Organisation;
  partialDownloadAllowed: Scalars['Boolean'];
  read: Scalars['Boolean'];
  sharedFrom: Scalars['String'];
  sharedTo: Scalars['String'];
  size: Scalars['Long'];
  validToDate?: Maybe<Scalars['Long']>;
};

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecialInstructions = {
  __typename: 'SpecialInstructions';
  deliverables: Scalars['String'];
  other: Scalars['String'];
  printAndSubstrate: Scalars['String'];
};

export type SpecialInstructionsInput = {
  deliverables: Scalars['String'];
  other: Scalars['String'];
  printAndSubstrate: Scalars['String'];
};

export type SpellingError = {
  __typename: 'SpellingError';
  blockId: Scalars['Int'];
  dismissed: Scalars['Boolean'];
  language: Scalars['String'];
  suggestions: Array<Scalars['String']>;
  word: Scalars['String'];
};

export type SsoDomain = {
  __typename: 'SsoDomain';
  autoCreateUsers: Scalars['Boolean'];
  complementWithGraphInfo: Scalars['Boolean'];
  domain: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  verified: Scalars['Boolean'];
};

export type StartChatSessionInput = {
  /** Initial UI context for the session. See ChatContextInput. */
  context: ChatContextInput;
  /** Named prompt profile to use for the session. Omit for the default. */
  promptProfile?: InputMaybe<Scalars['String']>;
};

/** ─── statistics.graphqls ───────────────────────────────────────── */
export type Statistics = {
  __typename: 'Statistics';
  approvalStats: ApprovalStats;
  artworkRejectionsByCategoryPerMonth: Array<ArtworkRejectionsByCategoryPerMonth>;
  deliveredArtworksByCategoryPerMonth: Array<DeliveredArtworksByCategoryPerMonth>;
  deliveredArtworksPerMonth: Array<DeliveredArtworksPerMonth>;
  deliveredArtworksPerYear: Array<DeliveredArtworksPerYear>;
  fileStorage: Scalars['Long'];
  fileStoragePerMonth: Array<FileStoragePerMonthResult>;
  fullUsersTotalPerMonth: Array<UsersTotalPerMonth>;
  mediaCenter: MediaCenterStats;
  onTimeDeliveriesPerMonth: Array<OnTimeDeliveriesPerMonth>;
  usersTotalPerMonth: Array<UsersTotalPerMonth>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsArtworkRejectionsByCategoryPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsDeliveredArtworksByCategoryPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsDeliveredArtworksPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsFileStoragePerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsFullUsersTotalPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsOnTimeDeliveriesPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};


/** ─── statistics.graphqls ───────────────────────────────────────── */
export type StatisticsUsersTotalPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Long']>;
  startDate?: InputMaybe<Scalars['Long']>;
};

/** ─── project.graphqls ──────────────────────────────────────────── */
export enum StatusBall {
  Blue = 'BLUE',
  Green = 'GREEN',
  Grey = 'GREY',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export enum StatusColor {
  Blue = 'BLUE',
  Green = 'GREEN',
  Grey = 'GREY',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type Subscription = {
  __typename: 'Subscription';
  achievements: AchievementAwarded;
  artwork: Artwork;
  assignmentSubscription: AssignmentUpdateEvent;
  /** @deprecated Badges are replaced by user tasks as a concept: subscribe to userTaskListEvents instead. */
  badgeCountEvent: BadgeCountUpdatedEvent;
  chatStream: ChatStreamEvent;
  download: DownloadEvent;
  fileSubscription: File;
  layoutConfigChanged: LayoutConfig;
  mediaCenterArtwork: MediaCenterArtwork;
  organisation: Organisation;
  ping: Scalars['String'];
  /** Subscribe to updates for a specific product. */
  product: Product;
  /** Fires when product categories change (tree structure or product counts). Client should refetch productCategories query. */
  productCategoriesUpdated: Scalars['Boolean'];
  project: Project;
  /**
   * Per-user project list changes, debounced per project so event storms collapse into
   * a single message. ADDED/REMOVED are relative to the subscribing user's visibility:
   * users who can see all projects get ADDED on creation and REMOVED on deletion, other
   * users get ADDED/REMOVED when they gain/lose membership of a project. Everything else
   * is an UPDATED carrying the resolved project.
   *
   * Recommended client flow: subscribe first, buffer incoming events, fetch the list via
   * the projects query, then apply the buffered events as idempotent upserts (ADDED/
   * UPDATED upsert by projectId, REMOVED deletes), skipping events whose version is not
   * newer than the queried project's version.
   */
  projectListEvents: ProjectListEvent;
  /** @deprecated Subscribe to userTaskListEvents instead: it pushes the actual task-list deltas rather than an empty ping asking the client to refetch tasksForUser. */
  taskCountEvent: TaskCountUpdatedEvent;
  treeEvents?: Maybe<TreeEvent>;
  user?: Maybe<User>;
  /**
   * Pushes the net changes to the current user's task list (the tasksForUser query),
   * one message per change window with the batched ADDED/UPDATED/REMOVED entries.
   * Task ids are stable, so events merge into a queried list by id. Note: share tasks
   * expiring (validTo passing) produce no event and therefore no push.
   */
  userTaskListEvents: Array<UserTaskListEvent>;
};


export type SubscriptionArtworkArgs = {
  id: Scalars['UUID'];
};


export type SubscriptionChatStreamArgs = {
  sessionId: Scalars['UUID'];
};


export type SubscriptionFileSubscriptionArgs = {
  fileId: Scalars['UUID'];
};


export type SubscriptionLayoutConfigChangedArgs = {
  key: Scalars['String'];
  scope: LayoutScope;
  type: Scalars['String'];
};


export type SubscriptionMediaCenterArtworkArgs = {
  artworkId: Scalars['UUID'];
};


export type SubscriptionOrganisationArgs = {
  id: Scalars['UUID'];
};


export type SubscriptionProductArgs = {
  productId: Scalars['UUID'];
};


export type SubscriptionProjectArgs = {
  id: Scalars['UUID'];
};


export type SubscriptionUserArgs = {
  userId: Scalars['UUID'];
};

/**
 * Overage add-ons: units billed on top of a module's included quota. An addon product carries the
 * module it extends plus cway-addon and grants no module by itself; its quantity is the unit count.
 */
export enum SubscriptionAddon {
  SkuOverage = 'SKU_OVERAGE',
  StorageOverage = 'STORAGE_OVERAGE',
  TrafficOverage = 'TRAFFIC_OVERAGE'
}

/**
 * A Stripe discount as applied to a subscription or one of its items: what the customer actually
 * pays relative to the list price. endsAt is epoch millis; null = for the life of the subscription.
 */
export type SubscriptionDiscount = {
  __typename: 'SubscriptionDiscount';
  endsAt?: Maybe<Scalars['Long']>;
  percentOff: Scalars['BigDecimal'];
};

export type SubscriptionItemInput = {
  productId: Scalars['String'];
  /** Omit for 1; used for the seat count on the seats product and units on overage products */
  quantity?: InputMaybe<Scalars['Long']>;
};

/**
 * A special subscription sale built for this organisation: catalog products at list price
 * with per-line and global discounts, an optional trial and an acceptance deadline.
 */
export type SubscriptionOffer = {
  __typename: 'SubscriptionOffer';
  acceptedAt?: Maybe<Scalars['Long']>;
  acceptedBy?: Maybe<User>;
  /** ACCEPTED offers: true when the offer changed the existing subscription instead of creating one */
  appliedToExisting: Scalars['Boolean'];
  /**
   * OPEN offers: the active paid subscription this offer changes on acceptance. Null = the
   * offer creates a new subscription (no subscription, or a CWAY-managed trial) - accept it
   * with acceptSubscriptionOffer; when set, preview with subscriptionOfferPreview and accept
   * with applySubscriptionOffer.
   */
  appliesToSubscriptionId?: Maybe<Scalars['String']>;
  closedAt?: Maybe<Scalars['Long']>;
  /** Who revoked or accepted the offer */
  closedBy?: Maybe<User>;
  closedReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: User;
  globalDiscount?: Maybe<OfferDiscount>;
  id: Scalars['UUID'];
  lines: Array<SubscriptionOfferLine>;
  /** Internal sales note - system admins only, null for everyone else */
  note?: Maybe<Scalars['String']>;
  /**
   * Set when the deal is invoiced with this many days to pay (net N) instead of charged to a
   * card. Accepting then takes billing details (acceptSubscriptionOffer / applySubscriptionOffer
   * with `billing`) and no Stripe page; null = paid by card as before.
   */
  paymentTermsDays?: Maybe<Scalars['Int']>;
  status: SubscriptionOfferStatus;
  /**
   * The Stripe subscription carrying the offer's terms after acceptance: created for it, or
   * (appliedToExisting) the subscription the organisation already had
   */
  subscriptionId?: Maybe<Scalars['String']>;
  /** Free days before the first invoice */
  trialDays?: Maybe<Scalars['Int']>;
  /** Acceptance deadline, epoch millis; null = open-ended */
  validUntil?: Maybe<Scalars['Long']>;
};

export type SubscriptionOfferLine = {
  __typename: 'SubscriptionOfferLine';
  /** Null = billed at the list price */
  discount?: Maybe<OfferDiscount>;
  /**
   * Resolved live from Stripe (name, description, features, list price). Null only when the
   * product no longer exists in Stripe - render the productId and let sales know.
   */
  product?: Maybe<SubscriptionProduct>;
  productId: Scalars['String'];
  /** Seats or overage units; 1 for base modules */
  quantity: Scalars['Long'];
};

export type SubscriptionOfferLineInput = {
  discount?: InputMaybe<OfferDiscountInput>;
  /**
   * Any Stripe product with a default price - catalog modules, seats, overage and custom
   * products such as a support plan (no self-service allowlist applies)
   */
  productId: Scalars['String'];
  /** Omit for 1 */
  quantity?: InputMaybe<Scalars['Long']>;
};

/**
 * The invoice Stripe issues the moment an offer is applied to the running subscription:
 * prorated charges and credits for the rest of the current period, with the offer's discounts and tax.
 */
export type SubscriptionOfferPreview = {
  __typename: 'SubscriptionOfferPreview';
  currency: Scalars['String'];
  lines: Array<SubscriptionOfferPreviewLine>;
  /** Current period end, epoch millis - the next regular invoice date */
  periodEnd: Scalars['Long'];
  /**
   * True when accepting starts a subscription of the accepter's own and cancels the current one,
   * because they are not the Stripe customer it is billed to. The amounts below are then a first
   * full invoice, not a proration: nothing is carried over and the rest of the current period is
   * lost, which the customer must be told before they accept.
   */
  replacesSubscription: Scalars['Boolean'];
  /** Ex VAT after discounts (total less tax) */
  subtotal: Scalars['BigDecimal'];
  tax: Scalars['BigDecimal'];
  /** What is charged now; zero or negative = nothing to pay, a credit lands on the account */
  total: Scalars['BigDecimal'];
};

export type SubscriptionOfferPreviewLine = {
  __typename: 'SubscriptionOfferPreviewLine';
  /** Major currency units ex VAT; negative for a credit */
  amount: Scalars['BigDecimal'];
  /** Stripe's line text, e.g. "Remaining time on Brand Studio Starter after 07 Sep 2026" */
  description: Scalars['String'];
  proration: Scalars['Boolean'];
};

export enum SubscriptionOfferStatus {
  Accepted = 'ACCEPTED',
  /** Never accepted or revoked, and validUntil has passed */
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Revoked = 'REVOKED'
}

export type SubscriptionPrice = {
  __typename: 'SubscriptionPrice';
  amount: Scalars['BigDecimal'];
  currency: Scalars['String'];
};

export type SubscriptionProduct = {
  __typename: 'SubscriptionProduct';
  /** Set on overage products (quantity = units); null for base modules, seats and billing-only lines */
  addon?: Maybe<SubscriptionAddon>;
  description: Scalars['String'];
  /** Item-level discount from an accepted offer (100 = the line is free); null = billed at price */
  discount?: Maybe<SubscriptionDiscount>;
  features: Array<Scalars['String']>;
  id: Scalars['String'];
  /**
   * True for products Cway staff configure (Stripe metadata managed=true): hidden from the
   * self-service catalog, and a subscription containing one is locked to staff changes
   */
  isManaged: Scalars['Boolean'];
  metadata: Array<SubscriptionProductMetadata>;
  module?: Maybe<CwayModule>;
  name: Scalars['String'];
  price: SubscriptionPrice;
  /** Stripe price the item is on (may be a sales-negotiated non-default price) */
  priceId?: Maybe<Scalars['String']>;
  /** Stripe subscription-item quantity (number of seats or overage units; 1 for base modules) */
  quantity: Scalars['Long'];
  /** Set on the seat product: the kind of seat it sells (quantity = purchased seats); null otherwise */
  seatType?: Maybe<SeatType>;
  tier?: Maybe<SubscriptionTier>;
};

export type SubscriptionProductMetadata = {
  __typename: 'SubscriptionProductMetadata';
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum SubscriptionTier {
  Enterprise = 'ENTERPRISE',
  Pro = 'PRO',
  Starter = 'STARTER'
}

/** System-admin diagnostic row from validateSubscriptions: one subscription checked against Stripe. */
export type SubscriptionValidation = {
  __typename: 'SubscriptionValidation';
  existsInStripe: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  /** CWAY-managed trials have no Stripe backing by design and are never orphans */
  isCwayTrial: Scalars['Boolean'];
  /**
   * True when the subscription should exist in Stripe but does not (dev/staging data drift) —
   * removable with removeOrphanedSubscription
   */
  orphaned: Scalars['Boolean'];
  /** The subscription's status as stored locally (ACTIVE, TRIALING, CANCELED, …) */
  status: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type Supplier = {
  __typename: 'Supplier';
  type: Scalars['String'];
};

export type SystemStatus = {
  __typename: 'SystemStatus';
  commandStats: Array<CqsStats>;
  queryStats: Array<CqsStats>;
  rendererStatus?: Maybe<Array<Maybe<RendererStatus>>>;
  unusedCommands: Array<Scalars['String']>;
  unusedQueries: Array<Scalars['String']>;
};

export type TagFilterInput = {
  exclude?: InputMaybe<Array<Scalars['UUID']>>;
  include?: InputMaybe<Array<Scalars['UUID']>>;
  mode: TagFilterMode;
};

export enum TagFilterMode {
  All = 'ALL',
  Any = 'ANY'
}

export enum TaskActionType {
  ApprovePrintCoverage = 'APPROVE_PRINT_COVERAGE',
  ColorProof = 'COLOR_PROOF',
  ColorTarget = 'COLOR_TARGET',
  DeliverToMediacenter = 'DELIVER_TO_MEDIACENTER',
  DigitalProof = 'DIGITAL_PROOF',
  SendPackshot = 'SEND_PACKSHOT'
}

export type TaskCountUpdatedEvent = {
  __typename: 'TaskCountUpdatedEvent';
  id: Scalars['UUID'];
};

export enum TeamApprovalState {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Undecided = 'UNDECIDED'
}

export type TeamAssignmentInput = {
  /** Omit to use the organisation team's approval mode when the team is newly attached; an already attached team keeps its current mode. */
  approvalMode?: InputMaybe<ApprovalMode>;
  approver?: InputMaybe<AssignUserAction>;
  description: Scalars['String'];
  members: Array<TeamMemberInput>;
  name: Scalars['String'];
  receiver?: InputMaybe<AssignUserAction>;
  sourceTeamId: Scalars['UUID'];
  supplier?: InputMaybe<AssignUserAction>;
  /** If false, team composition (members and approval mode) is not changed, but assignments (approver/receiver/supplier) are still updated. Defaults to true. */
  updateTeam?: InputMaybe<Scalars['Boolean']>;
};

export enum TeamAssignmentType {
  Approver = 'APPROVER',
  Receiver = 'RECEIVER',
  Supplier = 'SUPPLIER'
}

export type TeamMemberApproval = {
  __typename: 'TeamMemberApproval';
  approved?: Maybe<Scalars['Boolean']>;
  approvedAt?: Maybe<Scalars['LocalDateTime']>;
  approvedRevision?: Maybe<Scalars['UUID']>;
  clearOnNextRevision: Scalars['Boolean'];
  deadline?: Maybe<Scalars['LocalDateTime']>;
  user: User;
};

export type TeamMemberInput = {
  admin: Scalars['Boolean'];
  userId: Scalars['UUID'];
};

export type TeamUser = {
  __typename: 'TeamUser';
  admin: Scalars['Boolean'];
  user: User;
};

export type TeamUserInput = {
  /** default false */
  admin?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['UUID'];
};

export type TextExtractionResult = {
  __typename: 'TextExtractionResult';
  page: Scalars['Int'];
  spellingErrors: Array<SpellingError>;
  textBlocks: Array<ExtractedTextBlock>;
  usedEmbeddedText: Scalars['Boolean'];
};

export type TreeEvent = {
  __typename: 'TreeEvent';
  /** unique event id to trigger changes */
  id: Scalars['UUID'];
  treeId: Scalars['UUID'];
};

export type TreeHistoryEvent = {
  __typename: 'TreeHistoryEvent';
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  timestamp: Scalars['Long'];
};

/**
 * The fixed reminder schedule for CWAY-managed trials: customer mails go to the billing managers,
 * staff mails to the staff member who started the trial.
 */
export enum TrialReminder {
  Customer_2Days = 'CUSTOMER_2_DAYS',
  Customer_7Days = 'CUSTOMER_7_DAYS',
  CustomerEnded = 'CUSTOMER_ENDED',
  Staff_1Day = 'STAFF_1_DAY',
  Staff_7Days = 'STAFF_7_DAYS',
  StaffEnded = 'STAFF_ENDED'
}

export type TrialReminderRecord = {
  __typename: 'TrialReminderRecord';
  /** Empty for SKIPPED reminders and for SENT ones that reached nobody */
  recipients: Array<User>;
  /** Epoch millis */
  recordedAt: Scalars['Long'];
  reminder: TrialReminder;
  status: TrialReminderStatus;
  subscriptionId: Scalars['String'];
  /** Epoch millis: the trial end the reminder was for (an extension starts a new schedule) */
  trialEnd: Scalars['Long'];
};

/**
 * SENT: handed to the mail pipeline (delivery itself is in the mail provider's logs, header
 * X-CWAY-Trial-Reminder). SKIPPED: overtaken by a more urgent reminder, or the trial ended first.
 */
export enum TrialReminderStatus {
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

export type Trophy = {
  __typename: 'Trophy';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stars: Scalars['Int'];
  trophyType: TrophyType;
};

export type TrophyAwarded = {
  __typename: 'TrophyAwarded';
  name?: Maybe<Scalars['String']>;
  notificationText?: Maybe<Scalars['String']>;
  stars?: Maybe<Scalars['Int']>;
  trophyType?: Maybe<TrophyType>;
};

export enum TrophyType {
  CompletedTask = 'COMPLETED_TASK',
  DeliveredArtwork = 'DELIVERED_ARTWORK',
  FinishedProject = 'FINISHED_PROJECT',
  UploadedRevision = 'UPLOADED_REVISION',
  UploadToMediaCenter = 'UPLOAD_TO_MEDIA_CENTER'
}

export type UpdateArticleInput = {
  articleAxes?: InputMaybe<Scalars['JSON']>;
  articleNo?: InputMaybe<Scalars['String']>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['UUID'];
  indicatorDigit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  packagingLevel?: InputMaybe<Scalars['String']>;
  parentPackArticleId?: InputMaybe<Scalars['UUID']>;
  productId: Scalars['UUID'];
  quantityInParent?: InputMaybe<Scalars['Int']>;
};

export type UpdatePrintSpecificationInput = {
  decor?: InputMaybe<DecorInput>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  packaging?: InputMaybe<PackagingInput>;
  print?: InputMaybe<PrintInput>;
  specialInstructions?: InputMaybe<SpecialInstructionsInput>;
};

export type UpdateProductAttributeInput = {
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  localizable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  regulated?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<AttributeScope>;
  selectValues?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AttributeType>;
  unit?: InputMaybe<Scalars['String']>;
};

export type UpdateProductInput = {
  articleNo?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['UUID']>;
  categories?: InputMaybe<Array<Scalars['UUID']>>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProductStageInput = {
  bucket?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSsoDomainInput = {
  autoCreateUsers: Scalars['Boolean'];
  complementWithGraphInfo: Scalars['Boolean'];
  domain: Scalars['String'];
  isPrimary: Scalars['Boolean'];
};

export type UpdateWebhookInput = {
  basicAuthPassword?: InputMaybe<Scalars['String']>;
  basicAuthUsername?: InputMaybe<Scalars['String']>;
  bearerToken?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  events: Array<Scalars['String']>;
  id: Scalars['UUID'];
  url: Scalars['String'];
};

export type UploadRevisionTask = {
  __typename: 'UploadRevisionTask';
  artworkId: Scalars['ID'];
  artworkName: Scalars['String'];
  assignedTo: Scalars['ID'];
  categoryId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  currentRevisionNumber?: Maybe<Scalars['Long']>;
  /** @deprecated Renamed: use dueDate */
  deadline?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  previewFileId?: Maybe<Scalars['UUID']>;
  projectId: Scalars['ID'];
  projectName: Scalars['String'];
  projectOrderNo: Scalars['String'];
};

/** Any user of the system */
export type User = {
  __typename: 'User';
  acceptedTerms: Scalars['Boolean'];
  /** When the user was added to the current organisation */
  addedAt?: Maybe<Scalars['DateTime']>;
  /** The user that added this user to the current organisation */
  addedBy?: Maybe<User>;
  address: UserAddress;
  avatar: Scalars['Boolean'];
  createdAt: Scalars['Long'];
  earlyAccessProgram: Scalars['Boolean'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  instructions?: Maybe<Scalars['String']>;
  isAgent: Scalars['Boolean'];
  isSSO: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['Long']>;
  /** System admin only (null for everyone else) - the latest login in any organisation, epoch millis. */
  lastLoginAnyOrganisation?: Maybe<Scalars['Long']>;
  lastName: Scalars['String'];
  /**
   * Lightbox in every organisation without a Lightbox seat (e.g. Collabra staff working as a
   * customer's supplier). Granted/revoked by system admins with setLightboxEverywhere.
   */
  lightboxEverywhere: Scalars['Boolean'];
  loginCity?: Maybe<LoginCity>;
  /** The name of the user using FirstName LastName */
  name: Scalars['String'];
  /** Admin only for other users */
  organisationMemberships: Array<OrganisationMembership>;
  /** The user's role in the current organisation (built-in or custom); Limited user when none is recorded. */
  role: Role;
  /** CWAY system administrator. Granted/revoked with the setSystemAdmin mutation. */
  systemAdmin: Scalars['Boolean'];
  trophies: Array<Trophy>;
  username: Scalars['String'];
  workInformation: UserWorkInformation;
};

export type UserAccountInfoInput = {
  businessPhone?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
};

export type UserAddress = {
  __typename: 'UserAddress';
  businessPhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type UserApiToken = {
  __typename: 'UserApiToken';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['UUID'];
};

export type UserAssignmentInput = {
  approver?: InputMaybe<AssignUserAction>;
  receiver?: InputMaybe<AssignUserAction>;
  supplier?: InputMaybe<AssignUserAction>;
  userId: Scalars['UUID'];
};

export type UserAssignmentsInput = {
  artworkIds: Array<Scalars['UUID']>;
  assignments: Array<UserAssignmentInput>;
  projectId: Scalars['UUID'];
  teamAssignments?: InputMaybe<Array<TeamAssignmentInput>>;
};

/** How many of the matched users have each property. total is the number matched. */
export type UserCounts = {
  __typename: 'UserCounts';
  acceptedTerms: Scalars['Int'];
  agents: Scalars['Int'];
  earlyAccessProgram: Scalars['Int'];
  emailNotVerified: Scalars['Int'];
  neverLoggedIn: Scalars['Int'];
  sso: Scalars['Int'];
  systemAdmins: Scalars['Int'];
  total: Scalars['Int'];
  withoutOrganisation: Scalars['Int'];
};

/**
 * Narrows the system-admin user list. Leave a field out to not filter on it.
 * Timestamps are epoch millis and the ranges are inclusive.
 */
export type UserFilter = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']>;
  createdAfter?: InputMaybe<Scalars['Long']>;
  createdBefore?: InputMaybe<Scalars['Long']>;
  earlyAccessProgram?: InputMaybe<Scalars['Boolean']>;
  /** False picks users who never verified their email address. */
  emailValid?: InputMaybe<Scalars['Boolean']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  isSSO?: InputMaybe<Scalars['Boolean']>;
  /**
   * The last-login bounds use the latest login in any organisation and only match users
   * who have logged in at all; use neverLoggedIn for the others.
   */
  lastLoginAfter?: InputMaybe<Scalars['Long']>;
  lastLoginBefore?: InputMaybe<Scalars['Long']>;
  neverLoggedIn?: InputMaybe<Scalars['Boolean']>;
  /** Current members of this organisation. */
  organisationId?: InputMaybe<Scalars['UUID']>;
  systemAdmin?: InputMaybe<Scalars['Boolean']>;
  /** True picks users who belong to no organisation. */
  withoutOrganisation?: InputMaybe<Scalars['Boolean']>;
};

export type UserInput = {
  /** default false */
  forceValidEmail?: InputMaybe<Scalars['Boolean']>;
  /** Default to currentOrganisation */
  organisationId?: InputMaybe<Scalars['UUID']>;
  roleId?: InputMaybe<Scalars['Int']>;
  username: Scalars['String'];
};

export type UserOrTeam = User | UserTeam;

/**
 * ─── user.graphqls ───────────────────────────────────────────────
 * TODO fix the id, that should never be here...
 */
export type UserProperty = {
  __typename: 'UserProperty';
  id: Scalars['Int'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type UserSettings = {
  __typename: 'UserSettings';
  desktopUrl: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  startUrl: Scalars['String'];
};

export type UserSort = {
  /** Defaults to ASC. */
  direction?: InputMaybe<SortingDirection>;
  field: UserSortField;
};

export enum UserSortField {
  CreatedAt = 'CREATED_AT',
  /** Users who never logged in sort last in both directions. */
  LastLogin = 'LAST_LOGIN',
  Name = 'NAME',
  Username = 'USERNAME'
}

export type UserTask = ApproveArtworkTask | BundleArtworkTask | DeliverArtworkTask | DownloadShareTask | SeatRequestTask | UploadRevisionTask;

/** One entry of a pushed task-list delta. ADDED/UPDATED carry the task; REMOVED only the id. */
export type UserTaskListEvent = {
  __typename: 'UserTaskListEvent';
  task?: Maybe<UserTask>;
  taskId: Scalars['ID'];
  type: UserTaskListEventType;
};

export enum UserTaskListEventType {
  Added = 'ADDED',
  Removed = 'REMOVED',
  Updated = 'UPDATED'
}

export type UserTeam = {
  __typename: 'UserTeam';
  /** Approval mode for the team. Defaults to ALL_REQUIRED if not set. */
  approvalMode?: Maybe<ApprovalMode>;
  /** Whether the current user has permission to edit this team */
  canEdit: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** When true, all team members are treated as admins */
  selfManaged: Scalars['Boolean'];
  users: Array<TeamUser>;
};

export type UserWorkInformation = {
  __typename: 'UserWorkInformation';
  companyName?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
};

export type UsersTotalPerMonth = {
  __typename: 'UsersTotalPerMonth';
  count: Scalars['Int'];
  month: Scalars['Long'];
  monthValue: Scalars['Int'];
  year: Scalars['Int'];
};

export enum WallpaperStyle {
  Center = 'CENTER',
  Cover = 'COVER',
  None = 'NONE',
  Repeat = 'REPEAT',
  Stretch = 'STRETCH'
}

export type Webhook = {
  __typename: 'Webhook';
  basicAuth?: Maybe<WebhookBasicAuth>;
  bearerToken?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: User;
  description: Scalars['String'];
  events: Array<Scalars['String']>;
  id: Scalars['UUID'];
  signingSecret?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type WebhookBasicAuth = {
  __typename: 'WebhookBasicAuth';
  username: Scalars['String'];
};

export type WebhookEventType = {
  __typename: 'WebhookEventType';
  description: Scalars['String'];
  name: Scalars['String'];
};

export enum WebhookType {
  ArtworkDelivered = 'ARTWORK_DELIVERED'
}

export type WorkCopy = {
  __typename: 'WorkCopy';
  createdBy?: Maybe<User>;
  discarded?: Maybe<Scalars['Boolean']>;
  files: Array<WorkCopyFile>;
  id: Scalars['UUID'];
  versionNumber: Scalars['Int'];
};

export type WorkCopyFile = {
  __typename: 'WorkCopyFile';
  fileId: Scalars['UUID'];
  filename: Scalars['String'];
};

export type CreateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser: boolean };

export type FindUsersForOrgAssignmentQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<Paging>;
}>;


export type FindUsersForOrgAssignmentQuery = { __typename: 'Query', findUsersInAnyOrganisation: { __typename: 'PaginatedUsers', page: number, totalHits: any, users: Array<{ __typename: 'User', id: any, username: string, email: string, firstName: string, lastName: string, name: string, enabled: boolean, acceptedTerms: boolean, isSSO: boolean, organisationMemberships: Array<{ __typename: 'OrganisationMembership', name: string, organisationId: any }> }> } };

export type SetPermissionGroupForUsersMutationVariables = Exact<{
  usernames: Array<Scalars['String']> | Scalars['String'];
  organisationId?: InputMaybe<Scalars['UUID']>;
  permissionGroupId: Scalars['UUID'];
}>;


export type SetPermissionGroupForUsersMutation = { __typename: 'Mutation', setPermissionGroupForUsers: boolean };

export type CreateCustomerOrganisationMutationVariables = Exact<{
  input: CreateCustomerOrganisationInput;
}>;


export type CreateCustomerOrganisationMutation = { __typename: 'Mutation', createCustomerOrganisation: any };

export type UpdateOrganisationBaseInformationMutationVariables = Exact<{
  organisationId: Scalars['UUID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganisationBaseInformationMutation = { __typename: 'Mutation', updateOrganisationBaseInformation: boolean };

export type OrganisationUpdatedForEditSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type OrganisationUpdatedForEditSubscription = { __typename: 'Subscription', organisation: { __typename: 'Organisation', id: any, name: string, description?: string | null, active: boolean } };

export type SetUserEmailMutationVariables = Exact<{
  oldEmail: Scalars['String'];
  newEmail: Scalars['String'];
}>;


export type SetUserEmailMutation = { __typename: 'Mutation', setUserEmail: boolean };

export type ChangePasswordMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename: 'Mutation', changePassword?: boolean | null };

export type UpdateUserAccountInfoForUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  input: UserAccountInfoInput;
}>;


export type UpdateUserAccountInfoForUserMutation = { __typename: 'Mutation', updateUserAccountInfoForUser: boolean };

export type UserUpdatedForEditSubscriptionVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserUpdatedForEditSubscription = { __typename: 'Subscription', user?: { __typename: 'User', id: any, username: string, email: string, firstName: string, lastName: string, name: string, address: { __typename: 'UserAddress', streetAddress?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, mobilePhone?: string | null, businessPhone?: string | null }, workInformation: { __typename: 'UserWorkInformation', companyName?: string | null, department?: string | null, jobTitle?: string | null } } | null };

export type LoginInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginInfoQuery = { __typename: 'Query', loginInfo?: { __typename: 'LoginInfo', id: any, impersonatedBy?: string | null, isSystemAdmin: boolean, user: { __typename: 'User', id: any, username: string, firstName: string, lastName: string, email: string }, organisationMemberships: Array<{ __typename: 'OrganisationMembership', organisationId: any, name: string }>, currentOrganisation?: { __typename: 'Organisation', id: any, name: string } | null } | null };

export type OrganisationSubscriptionDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type OrganisationSubscriptionDetailQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: any, name: string, requiresSeats: boolean, activeSubscription?: { __typename: 'PaymentSubscription', id: string, status: string, isActive: boolean, isTrial: boolean, isCwayTrial: boolean, autoRenewal: boolean, currentPeriodStart: any, currentPeriodEnd?: any | null, hasModulePricing: boolean, isManaged: boolean, paymentTermsDays?: number | null, entitlements: Array<{ __typename: 'ModuleEntitlement', module: CwayModule, tier?: SubscriptionTier | null, quantity: any, includedUsers?: number | null, storageQuotaGb?: any | null, trafficQuotaGb?: any | null, skuLimit?: number | null }>, products: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, description: string, features: Array<string>, quantity: any, priceId?: string | null, module?: CwayModule | null, tier?: SubscriptionTier | null, addon?: SubscriptionAddon | null, seatType?: SeatType | null, price: { __typename: 'SubscriptionPrice', amount: any, currency: string } }>, createdBy: { __typename: 'User', id: any, firstName: string, lastName: string, email: string } } | null, seatUsage?: { __typename: 'SeatUsage', usedSeats: number, includedSeats: number, purchasedSeats: number, totalSeats: number, seatsLeft: number } | null, lightboxSeatUsage?: { __typename: 'SeatUsage', usedSeats: number, includedSeats: number, purchasedSeats: number, totalSeats: number, seatsLeft: number } | null, seatAssignments: Array<{ __typename: 'SeatAssignment', userId: any, seatType: SeatType }>, users: Array<{ __typename: 'User', id: any, firstName: string, lastName: string, email: string }> } | null };

export type SubscriptionProductsCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionProductsCatalogQuery = { __typename: 'Query', subscriptionProducts: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, module?: CwayModule | null, tier?: SubscriptionTier | null, addon?: SubscriptionAddon | null, seatType?: SeatType | null, price: { __typename: 'SubscriptionPrice', amount: any, currency: string } }> };

export type StartOrganisationTrialMutationVariables = Exact<{
  organisationId: Scalars['UUID'];
  trialEnd: Scalars['Long'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type StartOrganisationTrialMutation = { __typename: 'Mutation', startOrganisationTrial: boolean };

export type UpdateOrganisationTrialMutationVariables = Exact<{
  organisationId: Scalars['UUID'];
  trialEnd: Scalars['Long'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganisationTrialMutation = { __typename: 'Mutation', updateOrganisationTrial: boolean };

export type StopOrganisationTrialMutationVariables = Exact<{
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type StopOrganisationTrialMutation = { __typename: 'Mutation', stopOrganisationTrial: boolean };

export type AssignSeatMutationVariables = Exact<{
  userId: Scalars['UUID'];
  seatType: SeatType;
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type AssignSeatMutation = { __typename: 'Mutation', assignSeat: boolean };

export type RevokeSeatMutationVariables = Exact<{
  userId: Scalars['UUID'];
  seatType: SeatType;
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type RevokeSeatMutation = { __typename: 'Mutation', revokeSeat: boolean };

export type SetSubscriptionSeatsMutationVariables = Exact<{
  quantity: Scalars['Long'];
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type SetSubscriptionSeatsMutation = { __typename: 'Mutation', setSubscriptionSeats: boolean };

export type UpdateSubscriptionItemsMutationVariables = Exact<{
  items: Array<SubscriptionItemInput> | SubscriptionItemInput;
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateSubscriptionItemsMutation = { __typename: 'Mutation', updateSubscriptionItems: boolean };

export type ValidateSubscriptionsQueryVariables = Exact<{
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type ValidateSubscriptionsQuery = { __typename: 'Query', validateSubscriptions: Array<{ __typename: 'SubscriptionValidation', subscriptionId: string, status: string, isActive: boolean, isCwayTrial: boolean, existsInStripe: boolean, orphaned: boolean }> };

export type RemoveOrphanedSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type RemoveOrphanedSubscriptionMutation = { __typename: 'Mutation', removeOrphanedSubscription: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  subscriptionId?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type CancelSubscriptionMutation = { __typename: 'Mutation', cancelSubscription: boolean };

export type CancelSubscriptionImmediatelyMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  organisationId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type CancelSubscriptionImmediatelyMutation = { __typename: 'Mutation', cancelSubscriptionImmediately: boolean };

export type SubscriptionOfferProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionOfferProductsQuery = { __typename: 'Query', offerProducts: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, description: string, module?: CwayModule | null, tier?: SubscriptionTier | null, addon?: SubscriptionAddon | null, seatType?: SeatType | null, isManaged: boolean, quantity: any, metadata: Array<{ __typename: 'SubscriptionProductMetadata', key: string, value: string }>, price: { __typename: 'SubscriptionPrice', amount: any, currency: string } }> };

export type CreateSubscriptionOfferMutationVariables = Exact<{
  organisationId: Scalars['UUID'];
  input: CreateSubscriptionOfferInput;
}>;


export type CreateSubscriptionOfferMutation = { __typename: 'Mutation', createSubscriptionOffer: any };

export type OrganisationSubscriptionOffersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type OrganisationSubscriptionOffersQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: any, subscriptionOffers: Array<{ __typename: 'SubscriptionOffer', id: any, status: SubscriptionOfferStatus, trialDays?: number | null, paymentTermsDays?: number | null, validUntil?: any | null, note?: string | null, createdAt: any, acceptedAt?: any | null, subscriptionId?: string | null, appliedToExisting: boolean, appliesToSubscriptionId?: string | null, closedAt?: any | null, closedReason?: string | null, globalDiscount?: { __typename: 'OfferDiscount', percentOff: any, durationMonths?: number | null } | null, lines: Array<{ __typename: 'SubscriptionOfferLine', productId: string, quantity: any, discount?: { __typename: 'OfferDiscount', percentOff: any, durationMonths?: number | null } | null, product?: { __typename: 'SubscriptionProduct', id: string, name: string, module?: CwayModule | null, tier?: SubscriptionTier | null, quantity: any, price: { __typename: 'SubscriptionPrice', amount: any, currency: string } } | null }>, createdBy: { __typename: 'User', id: any, name: string }, acceptedBy?: { __typename: 'User', id: any, name: string } | null, closedBy?: { __typename: 'User', id: any, name: string } | null }>, activeSubscription?: { __typename: 'PaymentSubscription', id: string, isActive: boolean, isCwayTrial: boolean, autoRenewal: boolean, paymentTermsDays?: number | null, discount?: { __typename: 'SubscriptionDiscount', percentOff: any, endsAt?: any | null } | null, products: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, quantity: any, module?: CwayModule | null, tier?: SubscriptionTier | null, addon?: SubscriptionAddon | null, seatType?: SeatType | null, price: { __typename: 'SubscriptionPrice', amount: any, currency: string }, discount?: { __typename: 'SubscriptionDiscount', percentOff: any, endsAt?: any | null } | null }> } | null, seatUsage?: { __typename: 'SeatUsage', usedSeats: number, includedSeats: number, purchasedSeats: number, totalSeats: number, seatsLeft: number } | null } | null };

export type RevokeSubscriptionOfferMutationVariables = Exact<{
  organisationId: Scalars['UUID'];
  offerId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type RevokeSubscriptionOfferMutation = { __typename: 'Mutation', revokeSubscriptionOffer: boolean };

export type SetOwnUserRealNameMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type SetOwnUserRealNameMutation = { __typename: 'Mutation', setOwnUserRealName: boolean };

export type UpdateUserAccountInfoMutationVariables = Exact<{
  input: UserAccountInfoInput;
}>;


export type UpdateUserAccountInfoMutation = { __typename: 'Mutation', updateUserAccountInfo: boolean };

export type UserUpdatedForSettingsSubscriptionVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserUpdatedForSettingsSubscription = { __typename: 'Subscription', user?: { __typename: 'User', id: any, username: string, email: string, firstName: string, lastName: string, address: { __typename: 'UserAddress', streetAddress?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, mobilePhone?: string | null, businessPhone?: string | null }, workInformation: { __typename: 'UserWorkInformation', companyName?: string | null, department?: string | null, jobTitle?: string | null } } | null };

export type OrganisationRolesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type OrganisationRolesQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: any, roles: Array<{ __typename: 'Role', id: any, name: string, description: string, builtIn: boolean, assignable: boolean, grantableByMe: boolean, permissionIds: Array<string> }> } | null };

export type CacheTestSubscriptionDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type CacheTestSubscriptionDetailQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: any, activeSubscription?: { __typename: 'PaymentSubscription', id: string, products: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, description: string, quantity: any }> } | null } | null };

export type CacheTestSubscriptionOffersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type CacheTestSubscriptionOffersQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: any, activeSubscription?: { __typename: 'PaymentSubscription', id: string, products: Array<{ __typename: 'SubscriptionProduct', id: string, quantity: any, discount?: { __typename: 'SubscriptionDiscount', percentOff: any, endsAt?: any | null } | null }> } | null } | null };

export type ArtworkUpdatedSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ArtworkUpdatedSubscription = { __typename: 'Subscription', artwork: { __typename: 'Artwork', id: any, name: string, state: ArtworkState, latestActivity: any } };

export type ProjectUpdatedSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectUpdatedSubscription = { __typename: 'Subscription', project: { __typename: 'Project', id: any, name: string, state: ProjectState, lastActivity?: any | null } };

export type MediaCenterArtworkUpdatedSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MediaCenterArtworkUpdatedSubscription = { __typename: 'Subscription', mediaCenterArtwork: { __typename: 'MediaCenterArtwork', id: any, name: string, modifiedDate: any } };

export type DashboardUserCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardUserCountsQuery = { __typename: 'Query', userCountsInAnyOrganisation: { __typename: 'UserCounts', total: number, systemAdmins: number, earlyAccessProgram: number, acceptedTerms: number, sso: number, agents: number, withoutOrganisation: number, emailNotVerified: number, neverLoggedIn: number } };

export type DashboardOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardOrganisationsQuery = { __typename: 'Query', organisations?: Array<{ __typename: 'Organisation', id: any, active: boolean, numberOfUsers: number } | null> | null };

export type DuplicateUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type DuplicateUsersQuery = { __typename: 'Query', duplicateUsers: Array<{ __typename: 'DuplicateUserPair', email: string, currentLookupPointsTo: any, oldUser: { __typename: 'DuplicateUserInfo', userId: any, username: string, name: string, eventCount: number, hasPassword: boolean, createdAt: any, organisationNames: Array<string> }, newUser: { __typename: 'DuplicateUserInfo', userId: any, username: string, name: string, eventCount: number, hasPassword: boolean, createdAt: any, organisationNames: Array<string> } }> };

export type RenameDuplicateUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  newEmail: Scalars['String'];
}>;


export type RenameDuplicateUserMutation = { __typename: 'Mutation', renameDuplicateUser: boolean };

export type OrganisationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  withAdoption: Scalars['Boolean'];
}>;


export type OrganisationQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: any, name: string, description?: string | null, active: boolean, numberOfUsers: number, requiresSeats: boolean, accountOwner?: { __typename: 'User', id: any, username: string, firstName: string, lastName: string } | null, roles: Array<{ __typename: 'Role', id: any, name: string, description: string, builtIn: boolean, assignable: boolean, grantableByMe: boolean, permissionIds: Array<string> }>, users: Array<{ __typename: 'User', id: any, username: string, firstName: string, lastName: string, email: string, enabled: boolean, acceptedTerms: boolean, createdAt: any, isSSO: boolean, organisationMemberships: Array<{ __typename: 'OrganisationMembership', organisationId: any, isAccountOwner: boolean, role: { __typename: 'Role', id: any, name: string, membersChangeableByMe: boolean } }>, workInformation: { __typename: 'UserWorkInformation', jobTitle?: string | null, department?: string | null, companyName?: string | null }, address: { __typename: 'UserAddress', mobilePhone?: string | null, businessPhone?: string | null, city?: string | null, country?: string | null } }>, teams: Array<{ __typename: 'UserTeam', id: any, name: string, description: string, users: Array<{ __typename: 'TeamUser', admin: boolean, user: { __typename: 'User', id: any, username: string, firstName: string, lastName: string, email: string } }> }>, activeSubscription?: { __typename: 'PaymentSubscription', id: string, status: string, isActive: boolean, isTrial: boolean, isCwayTrial: boolean, autoRenewal: boolean, currentPeriodStart: any, currentPeriodEnd?: any | null, hasModulePricing: boolean, isManaged: boolean, offerId?: any | null, paymentTermsDays?: number | null, discount?: { __typename: 'SubscriptionDiscount', percentOff: any, endsAt?: any | null } | null, entitlements: Array<{ __typename: 'ModuleEntitlement', module: CwayModule, tier?: SubscriptionTier | null, quantity: any, includedUsers?: number | null, storageQuotaGb?: any | null, trafficQuotaGb?: any | null, skuLimit?: number | null }>, products: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, quantity: any, priceId?: string | null, module?: CwayModule | null, tier?: SubscriptionTier | null, addon?: SubscriptionAddon | null, seatType?: SeatType | null, price: { __typename: 'SubscriptionPrice', amount: any, currency: string }, discount?: { __typename: 'SubscriptionDiscount', percentOff: any, endsAt?: any | null } | null }> } | null, seatUsage?: { __typename: 'SeatUsage', usedSeats: number, includedSeats: number, purchasedSeats: number, totalSeats: number, seatsLeft: number } | null, lightboxSeatUsage?: { __typename: 'SeatUsage', usedSeats: number, includedSeats: number, purchasedSeats: number, totalSeats: number, seatsLeft: number } | null, seatAssignments: Array<{ __typename: 'SeatAssignment', userId: any, seatType: SeatType }>, subscriptions: Array<{ __typename: 'PaymentSubscription', id: string, status: string, currentPeriodStart: any, currentPeriodEnd?: any | null, autoRenewal: boolean }>, artworkCategories: Array<{ __typename: 'Category', id: any, name: string, description: string, usage?: number | null }>, adoption?: { __typename: 'OrganisationAdoption', lastActivityAt?: any | null, milestones: Array<{ __typename: 'AdoptionMilestone', key: AdoptionMilestoneKey, achieved: boolean, firstAchievedAt?: any | null, count: number }> } | null } | null };

export type OrganisationUpdatedSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type OrganisationUpdatedSubscription = { __typename: 'Subscription', organisation: { __typename: 'Organisation', id: any, name: string, description?: string | null, active: boolean, numberOfUsers: number, accountOwner?: { __typename: 'User', id: any, username: string, firstName: string, lastName: string } | null, users: Array<{ __typename: 'User', id: any, username: string, firstName: string, lastName: string, email: string, enabled: boolean, acceptedTerms: boolean, createdAt: any, isSSO: boolean, organisationMemberships: Array<{ __typename: 'OrganisationMembership', organisationId: any, isAccountOwner: boolean, role: { __typename: 'Role', id: any, name: string, membersChangeableByMe: boolean } }>, workInformation: { __typename: 'UserWorkInformation', jobTitle?: string | null, department?: string | null, companyName?: string | null }, address: { __typename: 'UserAddress', mobilePhone?: string | null, businessPhone?: string | null, city?: string | null, country?: string | null } }>, teams: Array<{ __typename: 'UserTeam', id: any, name: string, description: string, users: Array<{ __typename: 'TeamUser', admin: boolean, user: { __typename: 'User', id: any, username: string, firstName: string, lastName: string, email: string } }> }>, subscriptions: Array<{ __typename: 'PaymentSubscription', id: string, status: string, currentPeriodStart: any, currentPeriodEnd?: any | null, autoRenewal: boolean }>, artworkCategories: Array<{ __typename: 'Category', id: any, name: string, description: string, usage?: number | null }> } };

export type ActivateOrganisationsMutationVariables = Exact<{
  organisationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type ActivateOrganisationsMutation = { __typename: 'Mutation', activateOrganisations: boolean };

export type DeactivateOrganisationsMutationVariables = Exact<{
  organisationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DeactivateOrganisationsMutation = { __typename: 'Mutation', deactivateOrganisations: boolean };

export type OrganisationMediaCenterStorageQueryVariables = Exact<{
  organisationId: Scalars['UUID'];
  unit?: InputMaybe<FolderStorageUnit>;
}>;


export type OrganisationMediaCenterStorageQuery = { __typename: 'Query', organisationMediaCenterStorageStorage: { __typename: 'MediaCenterStorageSummary', organisationId: any, organisationName?: string | null, totalSize: any, fullSize: any, unit: FolderStorageUnit } };

export type DeleteUsersMutationVariables = Exact<{
  organisationId?: InputMaybe<Scalars['UUID']>;
  usernames: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteUsersMutation = { __typename: 'Mutation', deleteUsers?: boolean | null };

export type TransferAccountOwnershipMutationVariables = Exact<{
  userId: Scalars['UUID'];
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type TransferAccountOwnershipMutation = { __typename: 'Mutation', transferAccountOwnership: boolean };

export type OrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationsQuery = { __typename: 'Query', organisations?: Array<{ __typename: 'Organisation', id: any, name: string, description?: string | null, active: boolean, numberOfUsers: number, numberOfArtworks: number, accountOwner?: { __typename: 'User', id: any, username: string, firstName: string, lastName: string } | null } | null> | null };

export type OrphanedFilesOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrphanedFilesOrganisationsQuery = { __typename: 'Query', organisations?: Array<{ __typename: 'Organisation', id: any, name: string } | null> | null };

export type OrphanedFilesQueryVariables = Exact<{
  organisationId?: InputMaybe<Scalars['ID']>;
}>;


export type OrphanedFilesQuery = { __typename: 'Query', orphanedFiles: Array<{ __typename: 'OrphanedFile', fileId: string, organisationId?: string | null, name?: string | null, sizeBytes?: any | null, createdAt: any }> };

export type CheckAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckAuthQuery = { __typename: 'Query', loginInfo?: { __typename: 'LoginInfo', user: { __typename: 'User', username: string } } | null };

export type OrganisationSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationSubscriptionsQuery = { __typename: 'Query', organisations?: Array<{ __typename: 'Organisation', id: any, name: string, active: boolean, numberOfUsers: number, activeSubscription?: { __typename: 'PaymentSubscription', id: string, status: string, isActive: boolean, isTrial: boolean, isCwayTrial: boolean, autoRenewal: boolean, currentPeriodEnd?: any | null, hasModulePricing: boolean, isManaged: boolean, paymentTermsDays?: number | null, entitlements: Array<{ __typename: 'ModuleEntitlement', module: CwayModule, tier?: SubscriptionTier | null, quantity: any, includedUsers?: number | null }>, products: Array<{ __typename: 'SubscriptionProduct', id: string, name: string, quantity: any, module?: CwayModule | null, tier?: SubscriptionTier | null, addon?: SubscriptionAddon | null, seatType?: SeatType | null, price: { __typename: 'SubscriptionPrice', amount: any, currency: string } }> } | null, seatUsage?: { __typename: 'SeatUsage', usedSeats: number, includedSeats: number, purchasedSeats: number, totalSeats: number, seatsLeft: number } | null } | null> | null };

export type GetUserQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
}>;


export type GetUserQuery = { __typename: 'Query', getUser?: { __typename: 'User', id: any, username: string, email: string, firstName: string, lastName: string, name: string, enabled: boolean, acceptedTerms: boolean, createdAt: any, isSSO: boolean, earlyAccessProgram: boolean, lightboxEverywhere: boolean, systemAdmin: boolean, avatar: boolean, organisationMemberships: Array<{ __typename: 'OrganisationMembership', organisationId: any, name: string, isAccountOwner: boolean, role: { __typename: 'Role', id: any, name: string, membersChangeableByMe: boolean } }>, address: { __typename: 'UserAddress', streetAddress?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, mobilePhone?: string | null, businessPhone?: string | null }, workInformation: { __typename: 'UserWorkInformation', companyName?: string | null, department?: string | null, jobTitle?: string | null }, loginCity?: { __typename: 'LoginCity', name: string, country: string, latitude: number, longitude: number } | null } | null };

export type UserUpdatedSubscriptionVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserUpdatedSubscription = { __typename: 'Subscription', user?: { __typename: 'User', id: any, username: string, email: string, firstName: string, lastName: string, name: string, enabled: boolean, acceptedTerms: boolean, createdAt: any, isSSO: boolean, earlyAccessProgram: boolean, lightboxEverywhere: boolean, systemAdmin: boolean, avatar: boolean, organisationMemberships: Array<{ __typename: 'OrganisationMembership', organisationId: any, name: string, isAccountOwner: boolean, role: { __typename: 'Role', id: any, name: string, membersChangeableByMe: boolean } }>, address: { __typename: 'UserAddress', streetAddress?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, mobilePhone?: string | null, businessPhone?: string | null }, workInformation: { __typename: 'UserWorkInformation', companyName?: string | null, department?: string | null, jobTitle?: string | null }, loginCity?: { __typename: 'LoginCity', name: string, country: string, latitude: number, longitude: number } | null } | null };

export type SetEarlyAccessMutationVariables = Exact<{
  userId: Scalars['UUID'];
  earlyAccess: Scalars['Boolean'];
}>;


export type SetEarlyAccessMutation = { __typename: 'Mutation', setEarlyAccess: boolean };

export type SetLightboxEverywhereMutationVariables = Exact<{
  userId: Scalars['UUID'];
  lightboxEverywhere: Scalars['Boolean'];
}>;


export type SetLightboxEverywhereMutation = { __typename: 'Mutation', setLightboxEverywhere: boolean };

export type SetSystemAdminMutationVariables = Exact<{
  userId: Scalars['UUID'];
  admin: Scalars['Boolean'];
}>;


export type SetSystemAdminMutation = { __typename: 'Mutation', setSystemAdmin: boolean };

export type FindUsersInAnyOrganisationQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<Paging>;
  filter?: InputMaybe<UserFilter>;
  sort?: InputMaybe<UserSort>;
}>;


export type FindUsersInAnyOrganisationQuery = { __typename: 'Query', findUsersInAnyOrganisation: { __typename: 'PaginatedUsers', page: number, totalHits: any, users: Array<{ __typename: 'User', id: any, username: string, email: string, firstName: string, lastName: string, name: string, enabled: boolean, acceptedTerms: boolean, isSSO: boolean, earlyAccessProgram: boolean, createdAt: any, lastLoginAnyOrganisation?: any | null, organisationMemberships: Array<{ __typename: 'OrganisationMembership', name: string, organisationId: any }>, workInformation: { __typename: 'UserWorkInformation', jobTitle?: string | null, companyName?: string | null, department?: string | null } }> } };

export type ExportUsersInAnyOrganisationQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilter>;
  sort?: InputMaybe<UserSort>;
}>;


export type ExportUsersInAnyOrganisationQuery = { __typename: 'Query', exportUsersInAnyOrganisation: string };


export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const FindUsersForOrgAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUsersForOrgAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paging"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Paging"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUsersInAnyOrganisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"paging"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paging"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"isSSO"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalHits"}}]}}]}}]} as unknown as DocumentNode<FindUsersForOrgAssignmentQuery, FindUsersForOrgAssignmentQueryVariables>;
export const SetPermissionGroupForUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPermissionGroupForUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissionGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPermissionGroupForUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"usernames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"permissionGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissionGroupId"}}}]}]}}]} as unknown as DocumentNode<SetPermissionGroupForUsersMutation, SetPermissionGroupForUsersMutationVariables>;
export const CreateCustomerOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerOrganisationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerOrganisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateCustomerOrganisationMutation, CreateCustomerOrganisationMutationVariables>;
export const UpdateOrganisationBaseInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganisationBaseInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganisationBaseInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}]}}]} as unknown as DocumentNode<UpdateOrganisationBaseInformationMutation, UpdateOrganisationBaseInformationMutationVariables>;
export const OrganisationUpdatedForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrganisationUpdatedForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<OrganisationUpdatedForEditSubscription, OrganisationUpdatedForEditSubscriptionVariables>;
export const SetUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oldEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"newEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}}}]}]}}]} as unknown as DocumentNode<SetUserEmailMutation, SetUserEmailMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateUserAccountInfoForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserAccountInfoForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAccountInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAccountInfoForUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserAccountInfoForUserMutation, UpdateUserAccountInfoForUserMutationVariables>;
export const UserUpdatedForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserUpdatedForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]}}]} as unknown as DocumentNode<UserUpdatedForEditSubscription, UserUpdatedForEditSubscriptionVariables>;
export const LoginInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoginInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impersonatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemAdmin"}}]}}]}}]} as unknown as DocumentNode<LoginInfoQuery, LoginInfoQueryVariables>;
export const OrganisationSubscriptionDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganisationSubscriptionDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isTrial"}},{"kind":"Field","name":{"kind":"Name","value":"isCwayTrial"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"hasModulePricing"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedUsers"}},{"kind":"Field","name":{"kind":"Name","value":"storageQuotaGb"}},{"kind":"Field","name":{"kind":"Name","value":"trafficQuotaGb"}},{"kind":"Field","name":{"kind":"Name","value":"skuLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"addon"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"EnumValue","value":"PROJECT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"includedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsLeft"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lightboxSeatUsage"},"name":{"kind":"Name","value":"seatUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"EnumValue","value":"LIGHTBOX"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"includedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsLeft"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiresSeats"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationSubscriptionDetailQuery, OrganisationSubscriptionDetailQueryVariables>;
export const SubscriptionProductsCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubscriptionProductsCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"addon"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionProductsCatalogQuery, SubscriptionProductsCatalogQueryVariables>;
export const StartOrganisationTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartOrganisationTrial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trialEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startOrganisationTrial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trialEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trialEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<StartOrganisationTrialMutation, StartOrganisationTrialMutationVariables>;
export const UpdateOrganisationTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganisationTrial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trialEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganisationTrial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trialEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trialEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<UpdateOrganisationTrialMutation, UpdateOrganisationTrialMutationVariables>;
export const StopOrganisationTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StopOrganisationTrial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopOrganisationTrial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<StopOrganisationTrialMutation, StopOrganisationTrialMutationVariables>;
export const AssignSeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignSeat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seatType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SeatType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignSeat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seatType"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<AssignSeatMutation, AssignSeatMutationVariables>;
export const RevokeSeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeSeat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seatType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SeatType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeSeat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seatType"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<RevokeSeatMutation, RevokeSeatMutationVariables>;
export const SetSubscriptionSeatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSubscriptionSeats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSubscriptionSeats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<SetSubscriptionSeatsMutation, SetSubscriptionSeatsMutationVariables>;
export const UpdateSubscriptionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSubscriptionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionItemInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubscriptionItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<UpdateSubscriptionItemsMutation, UpdateSubscriptionItemsMutationVariables>;
export const ValidateSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isCwayTrial"}},{"kind":"Field","name":{"kind":"Name","value":"existsInStripe"}},{"kind":"Field","name":{"kind":"Name","value":"orphaned"}}]}}]}}]} as unknown as DocumentNode<ValidateSubscriptionsQuery, ValidateSubscriptionsQueryVariables>;
export const RemoveOrphanedSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrphanedSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrphanedSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<RemoveOrphanedSubscriptionMutation, RemoveOrphanedSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CancelSubscriptionImmediatelyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelSubscriptionImmediately"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelSubscriptionImmediately"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables>;
export const SubscriptionOfferProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubscriptionOfferProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"addon"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOfferProductsQuery, SubscriptionOfferProductsQueryVariables>;
export const CreateSubscriptionOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSubscriptionOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSubscriptionOfferInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubscriptionOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateSubscriptionOfferMutation, CreateSubscriptionOfferMutationVariables>;
export const OrganisationSubscriptionOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganisationSubscriptionOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"appliedToExisting"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedReason"}},{"kind":"Field","name":{"kind":"Name","value":"globalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"durationMonths"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"durationMonths"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isCwayTrial"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"addon"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"EnumValue","value":"PROJECT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"includedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsLeft"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationSubscriptionOffersQuery, OrganisationSubscriptionOffersQueryVariables>;
export const RevokeSubscriptionOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeSubscriptionOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeSubscriptionOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<RevokeSubscriptionOfferMutation, RevokeSubscriptionOfferMutationVariables>;
export const SetOwnUserRealNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetOwnUserRealName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setOwnUserRealName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}]}]}}]} as unknown as DocumentNode<SetOwnUserRealNameMutation, SetOwnUserRealNameMutationVariables>;
export const UpdateUserAccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserAccountInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAccountInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAccountInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserAccountInfoMutation, UpdateUserAccountInfoMutationVariables>;
export const UserUpdatedForSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserUpdatedForSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]}}]} as unknown as DocumentNode<UserUpdatedForSettingsSubscription, UserUpdatedForSettingsSubscriptionVariables>;
export const OrganisationRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganisationRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"builtIn"}},{"kind":"Field","name":{"kind":"Name","value":"assignable"}},{"kind":"Field","name":{"kind":"Name","value":"grantableByMe"}},{"kind":"Field","name":{"kind":"Name","value":"permissionIds"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationRolesQuery, OrganisationRolesQueryVariables>;
export const CacheTestSubscriptionDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CacheTestSubscriptionDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CacheTestSubscriptionDetailQuery, CacheTestSubscriptionDetailQueryVariables>;
export const CacheTestSubscriptionOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CacheTestSubscriptionOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CacheTestSubscriptionOffersQuery, CacheTestSubscriptionOffersQueryVariables>;
export const ArtworkUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ArtworkUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artwork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"latestActivity"}}]}}]}}]} as unknown as DocumentNode<ArtworkUpdatedSubscription, ArtworkUpdatedSubscriptionVariables>;
export const ProjectUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ProjectUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lastActivity"}}]}}]}}]} as unknown as DocumentNode<ProjectUpdatedSubscription, ProjectUpdatedSubscriptionVariables>;
export const MediaCenterArtworkUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MediaCenterArtworkUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaCenterArtwork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"artworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedDate"}}]}}]}}]} as unknown as DocumentNode<MediaCenterArtworkUpdatedSubscription, MediaCenterArtworkUpdatedSubscriptionVariables>;
export const DashboardUserCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardUserCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCountsInAnyOrganisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"systemAdmins"}},{"kind":"Field","name":{"kind":"Name","value":"earlyAccessProgram"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"sso"}},{"kind":"Field","name":{"kind":"Name","value":"agents"}},{"kind":"Field","name":{"kind":"Name","value":"withoutOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"emailNotVerified"}},{"kind":"Field","name":{"kind":"Name","value":"neverLoggedIn"}}]}}]}}]} as unknown as DocumentNode<DashboardUserCountsQuery, DashboardUserCountsQueryVariables>;
export const DashboardOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardOrganisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsers"}}]}}]}}]} as unknown as DocumentNode<DashboardOrganisationsQuery, DashboardOrganisationsQueryVariables>;
export const DuplicateUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DuplicateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currentLookupPointsTo"}},{"kind":"Field","name":{"kind":"Name","value":"oldUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eventCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"organisationNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eventCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"organisationNames"}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateUsersQuery, DuplicateUsersQueryVariables>;
export const RenameDuplicateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameDuplicateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameDuplicateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}}}]}]}}]} as unknown as DocumentNode<RenameDuplicateUserMutation, RenameDuplicateUserMutationVariables>;
export const OrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Organisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withAdoption"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsers"}},{"kind":"Field","name":{"kind":"Name","value":"accountOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"builtIn"}},{"kind":"Field","name":{"kind":"Name","value":"assignable"}},{"kind":"Field","name":{"kind":"Name","value":"grantableByMe"}},{"kind":"Field","name":{"kind":"Name","value":"permissionIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSSO"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"isAccountOwner"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"membersChangeableByMe"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhone"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isTrial"}},{"kind":"Field","name":{"kind":"Name","value":"isCwayTrial"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"hasModulePricing"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedUsers"}},{"kind":"Field","name":{"kind":"Name","value":"storageQuotaGb"}},{"kind":"Field","name":{"kind":"Name","value":"trafficQuotaGb"}},{"kind":"Field","name":{"kind":"Name","value":"skuLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"addon"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"EnumValue","value":"PROJECT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"includedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsLeft"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lightboxSeatUsage"},"name":{"kind":"Name","value":"seatUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"EnumValue","value":"LIGHTBOX"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"includedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsLeft"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiresSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"artworkCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"usage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adoption"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withAdoption"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastActivityAt"}},{"kind":"Field","name":{"kind":"Name","value":"milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"achieved"}},{"kind":"Field","name":{"kind":"Name","value":"firstAchievedAt"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationQuery, OrganisationQueryVariables>;
export const OrganisationUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrganisationUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsers"}},{"kind":"Field","name":{"kind":"Name","value":"accountOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSSO"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"isAccountOwner"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"membersChangeableByMe"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhone"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"artworkCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"usage"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationUpdatedSubscription, OrganisationUpdatedSubscriptionVariables>;
export const ActivateOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateOrganisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationIds"}}}]}]}}]} as unknown as DocumentNode<ActivateOrganisationsMutation, ActivateOrganisationsMutationVariables>;
export const DeactivateOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateOrganisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationIds"}}}]}]}}]} as unknown as DocumentNode<DeactivateOrganisationsMutation, DeactivateOrganisationsMutationVariables>;
export const OrganisationMediaCenterStorageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganisationMediaCenterStorage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FolderStorageUnit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationMediaCenterStorageStorage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"totalSize"}},{"kind":"Field","name":{"kind":"Name","value":"fullSize"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<OrganisationMediaCenterStorageQuery, OrganisationMediaCenterStorageQueryVariables>;
export const DeleteUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"usernames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}}}]}]}}]} as unknown as DocumentNode<DeleteUsersMutation, DeleteUsersMutationVariables>;
export const TransferAccountOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferAccountOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferAccountOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}]}}]} as unknown as DocumentNode<TransferAccountOwnershipMutation, TransferAccountOwnershipMutationVariables>;
export const OrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Organisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsers"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfArtworks"}},{"kind":"Field","name":{"kind":"Name","value":"accountOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationsQuery, OrganisationsQueryVariables>;
export const OrphanedFilesOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanedFilesOrganisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrphanedFilesOrganisationsQuery, OrphanedFilesOrganisationsQueryVariables>;
export const OrphanedFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanedFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orphanedFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<OrphanedFilesQuery, OrphanedFilesQueryVariables>;
export const CheckAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckAuth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]} as unknown as DocumentNode<CheckAuthQuery, CheckAuthQueryVariables>;
export const OrganisationSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganisationSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsers"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isTrial"}},{"kind":"Field","name":{"kind":"Name","value":"isCwayTrial"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"hasModulePricing"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedUsers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"addon"}},{"kind":"Field","name":{"kind":"Name","value":"seatType"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seatType"},"value":{"kind":"EnumValue","value":"PROJECT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"includedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsLeft"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationSubscriptionsQuery, OrganisationSubscriptionsQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSSO"}},{"kind":"Field","name":{"kind":"Name","value":"earlyAccessProgram"}},{"kind":"Field","name":{"kind":"Name","value":"lightboxEverywhere"}},{"kind":"Field","name":{"kind":"Name","value":"systemAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAccountOwner"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"membersChangeableByMe"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loginCity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const UserUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSSO"}},{"kind":"Field","name":{"kind":"Name","value":"earlyAccessProgram"}},{"kind":"Field","name":{"kind":"Name","value":"lightboxEverywhere"}},{"kind":"Field","name":{"kind":"Name","value":"systemAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAccountOwner"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"membersChangeableByMe"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loginCity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<UserUpdatedSubscription, UserUpdatedSubscriptionVariables>;
export const SetEarlyAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetEarlyAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"earlyAccess"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setEarlyAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"earlyAccess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"earlyAccess"}}}]}]}}]} as unknown as DocumentNode<SetEarlyAccessMutation, SetEarlyAccessMutationVariables>;
export const SetLightboxEverywhereDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetLightboxEverywhere"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lightboxEverywhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setLightboxEverywhere"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lightboxEverywhere"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lightboxEverywhere"}}}]}]}}]} as unknown as DocumentNode<SetLightboxEverywhereMutation, SetLightboxEverywhereMutationVariables>;
export const SetSystemAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSystemAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"admin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSystemAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"admin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"admin"}}}]}]}}]} as unknown as DocumentNode<SetSystemAdminMutation, SetSystemAdminMutationVariables>;
export const FindUsersInAnyOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUsersInAnyOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paging"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Paging"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUsersInAnyOrganisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"paging"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paging"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"isSSO"}},{"kind":"Field","name":{"kind":"Name","value":"earlyAccessProgram"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginAnyOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalHits"}}]}}]}}]} as unknown as DocumentNode<FindUsersInAnyOrganisationQuery, FindUsersInAnyOrganisationQueryVariables>;
export const ExportUsersInAnyOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportUsersInAnyOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportUsersInAnyOrganisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}]}}]} as unknown as DocumentNode<ExportUsersInAnyOrganisationQuery, ExportUsersInAnyOrganisationQueryVariables>;